import React, { useEffect, useState } from "react";
import cx from "classnames";
import * as styles from "./legal.module.scss";
import PortableText from "../components/portableText";
import mapboxgl from "!mapbox-gl";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import * as turf from "@turf/turf";

export const StoreLocater = ({ data }) => {
  const storesAZ = {
    type: "FeatureCollection",
    features: [
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.931429, 33.501572],
      },
      properties: {
        name: "Mastro's City Hall Steakhouse",
        phoneFormatted: "",
        phone: "",
        address: "6991 E Camelback Rd",
        city: "Scottsdale",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 1,
        resposado: 1,
        anejo: 1,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-112.083409, 33.392599],
      },
      properties: {
        name: "Paradise Liquor Mini Mart",
        phoneFormatted: "",
        phone: "",
        address: "722 W Southern Ave",
        city: "Phoenix",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "Off",
        blanco: 1,
        resposado: 1,
        anejo: 1,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.92514, 33.6254],
      },
      properties: {
        name: "Etta Scottsdale",
        phoneFormatted: "",
        phone: "",
        address: "15301 N Scottsdale RD A1-100",
        city: "Scottsdale",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 1,
        resposado: 1,
        anejo: 1,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.98186, 33.34813],
      },
      properties: {
        name: "Cactus Jacks Bar & Grill",
        phoneFormatted: "",
        phone: "",
        address: "4747 East Elliot Road #5",
        city: "Phoenix",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 1,
        resposado: 1,
        anejo: 1,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.921045, 33.501335],
      },
      properties: {
        name: "Almost Famous",
        phoneFormatted: "",
        phone: "",
        address: "7419 E Indian Plaza",
        city: "Scottsdale",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 1,
        resposado: 1,
        anejo: 1,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.925378, 33.510885],
      },
      properties: {
        name: "Hotel Adeline",
        phoneFormatted: "",
        phone: "",
        address: "5101 N Scottsdale Rd",
        city: "Scottsdale",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 1,
        resposado: 1,
        anejo: 1,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-112.009185, 34.732695],
      },
      properties: {
        name: "The Chaparral Bar",
        phoneFormatted: "",
        phone: "",
        address: "325 S Main St",
        city: "Cottonwood",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 1,
        resposado: 1,
        anejo: 1,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.924603, 33.493441],
      },
      properties: {
        name: "Porter's Western Saloon",
        phoneFormatted: "",
        phone: "",
        address: "3944 N Brown Ave",
        city: "Scottsdale",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 1,
        resposado: 1,
        anejo: 1,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-114.341456, 34.467664],
      },
      properties: {
        name: "La Vita Dolce",
        phoneFormatted: "",
        phone: "",
        address: "231 Swanson Ave",
        city: "Lake Havasu City",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 1,
        resposado: 1,
        anejo: 1,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.931242, 33.493309],
      },
      properties: {
        name: "The House Brasserie",
        phoneFormatted: "",
        phone: "",
        address: "6936 E Main St",
        city: "Scottsdale",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 1,
        resposado: 1,
        anejo: 1,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.925577, 33.491487],
      },
      properties: {
        name: "Rehab Burger Therapy",
        phoneFormatted: "",
        phone: "",
        address: "7210 E 2nd St",
        city: "Scottsdale",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 1,
        resposado: 1,
        anejo: 1,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.927142, 33.615341],
      },
      properties: {
        name: "The Rooster Tavern",
        phoneFormatted: "",
        phone: "",
        address: "14202 N Scottsdale Ste 104",
        city: "Scottsdale",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 1,
        resposado: 1,
        anejo: 1,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.9183, 33.566814],
      },
      properties: {
        name: "Hyatt Regency Scottsdale",
        phoneFormatted: "",
        phone: "",
        address: "7500 E Doubletree Ranch Rd",
        city: "Scottsdale",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 1,
        resposado: 1,
        anejo: 1,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.922732, 33.493433],
      },
      properties: {
        name: "Sonder the Monarch",
        phoneFormatted: "",
        phone: "",
        address: "4000 N Drinkwater Blvd",
        city: "Scottsdale",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 1,
        resposado: 1,
        anejo: 1,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.9294, 33.502],
      },
      properties: {
        name: "Maple and Ash",
        phoneFormatted: "",
        phone: "",
        address: "7135 E Camelback Road #130",
        city: "Scottsdale",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 1,
        resposado: 1,
        anejo: 1,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.924947, 33.498205],
      },
      properties: {
        name: "Giligin's Bar and Shrimp Hut",
        phoneFormatted: "",
        phone: "",
        address: "4251 N Winfield Scott",
        city: "Scottsdale",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 1,
        resposado: 1,
        anejo: 1,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-112.271779, 33.551951],
      },
      properties: {
        name: "The Cabin Whiskey and Grill",
        phoneFormatted: "",
        phone: "",
        address: "9868 W Nothern Ave",
        city: "Peoria",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 1,
        resposado: 1,
        anejo: 1,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.93408, 33.493425],
      },
      properties: {
        name: "Hotel Valley Ho",
        phoneFormatted: "",
        phone: "",
        address: "6850 E Main St",
        city: "Scottsdale",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 1,
        resposado: 1,
        anejo: 1,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-112.47034, 34.5425],
      },
      properties: {
        name: "The Point Bar and Lounge",
        phoneFormatted: "",
        phone: "",
        address: "114 N Montezuma St",
        city: "Prescott",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 1,
        resposado: 1,
        anejo: 1,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.66371, 35.19201],
      },
      properties: {
        name: "High Country Motor Lodge",
        phoneFormatted: "",
        phone: "",
        address: "1000 W Route 66",
        city: "Flagstaff",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 1,
        resposado: 1,
        anejo: 1,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-112.0729295, 33.4669455],
      },
      properties: {
        name: "Phoenix Art Museum Bar",
        phoneFormatted: "",
        phone: "",
        address: "1625 N Central Ave",
        city: "Phoenix",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 1,
        resposado: 1,
        anejo: 1,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.647909, 35.207054],
      },
      properties: {
        name: "Grand Canyon Spirits",
        phoneFormatted: "",
        phone: "",
        address: "982 Fort Valley Road",
        city: "Flagstaff",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "Off",
        blanco: 1,
        resposado: 1,
        anejo: 1,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.9511755, 33.507095],
      },
      properties: {
        name: "The Phoenician",
        phoneFormatted: "",
        phone: "",
        address: "6000 East Camelback",
        city: "Scottsdale",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 1,
        resposado: 1,
        anejo: 1,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-110.976054, 32.330198],
      },
      properties: {
        name: "Hifalutin",
        phoneFormatted: "",
        phone: "",
        address: "6780 N Oracle Rd",
        city: "Tucson",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 1,
        resposado: 1,
        anejo: 1,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.923359, 33.491713],
      },
      properties: {
        name: "Los Olivos Mexican Patio",
        phoneFormatted: "",
        phone: "",
        address: "7328 E 2nd Strret",
        city: "Scottsdale",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 1,
        resposado: 1,
        anejo: 1,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.615634, 35.206589],
      },
      properties: {
        name: "La Fonda Mexican Restaurant",
        phoneFormatted: "",
        phone: "",
        address: "1900 N 2nd St",
        city: "Flagstaff",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 1,
        resposado: 1,
        anejo: 1,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.90047, 33.55702],
      },
      properties: {
        name: "PHX Beer Co. Brewery and Restaurant",
        phoneFormatted: "",
        phone: "",
        address: "8320 N Hayden Road d 100",
        city: "Scottsdale",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 1,
        resposado: 1,
        anejo: 1,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.880305, 33.307],
      },
      properties: {
        name: "Ameircan Legion Post 35",
        phoneFormatted: "",
        phone: "",
        address: "2240 W Chandler Blvd.",
        city: "Chandler",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 1,
        resposado: 1,
        anejo: 1,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-112.06536, 33.507955],
      },
      properties: {
        name: "Tequila Cocina + Cantina",
        phoneFormatted: "",
        phone: "",
        address: "4818 N 7th St",
        city: "Phoenix",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 1,
        resposado: 1,
        anejo: 1,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.665709, 35.176434],
      },
      properties: {
        name: "Delhi Palace Cuisine of India",
        phoneFormatted: "",
        phone: "",
        address: "2500 S Woodland Village Dr #8",
        city: "Flagstaff",
        country: "United States",
        postalCode: "86001",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.97746, 33.597285],
      },
      properties: {
        name: "The Mexicano",
        phoneFormatted: "",
        phone: "",
        address: "4801 E Cactus Road",
        city: "Scottsdale",
        country: "United States",
        postalCode: "85254",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.927473, 33.496998],
      },
      properties: {
        name: "Pour Decisions Patio and Kitchen",
        phoneFormatted: "",
        phone: "",
        address: "4209 N Craftsman Court",
        city: "Scottsdale",
        country: "United States",
        postalCode: "85251",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.925327, 33.494251],
      },
      properties: {
        name: "Cien Agaves Tacos and Tequila",
        phoneFormatted: "",
        phone: "",
        address: "7228 E 1st Ave",
        city: "Scottsdale",
        country: "United States",
        postalCode: "85251",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.88816, 33.67478],
      },
      properties: {
        name: "All American Modern Sports Grill",
        phoneFormatted: "",
        phone: "",
        address: "20751 N Pima Rd #105",
        city: "Scottsdale",
        country: "United States",
        postalCode: "85255",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.977458, 33.31734],
      },
      properties: {
        name: "Living Room Wine Cafe & Lounge",
        phoneFormatted: "",
        phone: "",
        address: "20751 N Pima Rd suite 120 ",
        city: "Scottsdale",
        country: "United States",
        postalCode: "85255",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.93926, 33.42286],
      },
      properties: {
        name: "The Westin Tempe",
        phoneFormatted: "",
        phone: "",
        address: "11 E 7th Street",
        city: "Tempe",
        country: "United States",
        postalCode: "85281",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-112.0738, 33.44816],
      },
      properties: {
        name: "Pigtails",
        phoneFormatted: "",
        phone: "",
        address: "1 E Washington St",
        city: "Phoenix",
        country: "United States",
        postalCode: "85004",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-112.047963, 33.524877],
      },
      properties: {
        name: "Goerge Yang's Chinese Cuisine",
        phoneFormatted: "",
        phone: "",
        address: "6048 N 16th Street",
        city: "Phoenix",
        country: "United States",
        postalCode: "85016",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-110.965245, 32.22432],
      },
      properties: {
        name: "Ermanos",
        phoneFormatted: "",
        phone: "",
        address: "220 N 4th Ave",
        city: "Tucson",
        country: "United States",
        postalCode: "85705",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-110.957095, 32.23198],
      },
      properties: {
        name: "Agave House",
        phoneFormatted: "",
        phone: "",
        address: "943 E University Blvd. #171",
        city: "Tucson",
        country: "United States",
        postalCode: "85719",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.925935, 33.42226],
      },
      properties: {
        name: "Society By Evo",
        phoneFormatted: "",
        phone: "",
        address: "920 E University Drive #204",
        city: "Tempe",
        country: "United States",
        postalCode: "85281",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.92279, 33.494035],
      },
      properties: {
        name: "Sonder",
        phoneFormatted: "",
        phone: "",
        address: "4000 N Drinkwater Blvd",
        city: "Scottsdale",
        country: "United States",
        postalCode: "85251",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.9439055, 33.436932],
      },
      properties: {
        name: "Marquee Theatre",
        phoneFormatted: "",
        phone: "",
        address: "730 N Mill Avenue",
        city: "Tempe",
        country: "United States",
        postalCode: "85281",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.87278, 33.39329],
      },
      properties: {
        name: "Los Sombreros",
        phoneFormatted: "",
        phone: "",
        address: "1976 W Soutern Ave",
        city: "Mesa",
        country: "United States",
        postalCode: "85202",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.926591, 33.476555],
      },
      properties: {
        name: "Los Sombreros",
        phoneFormatted: "",
        phone: "",
        address: "2534 N Scottsdale Rd",
        city: "Scottsdale",
        country: "United States",
        postalCode: "85257",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.9258, 33.499162],
      },
      properties: {
        name: "Barstool Scottsdale",
        phoneFormatted: "4321 N Scottsdale Rd",
        phone: "",
        address: "",
        city: "Scottsdale",
        country: "United States",
        postalCode: "85251",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-114.443526, 32.66264],
      },
      properties: {
        name: "Fortuna Hills Liquor",
        phoneFormatted: "",
        phone: "",
        address: "11525 S Fortuna Rd",
        city: "Yuma",
        country: "United States",
        postalCode: "85364",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-112.072175, 33.455865],
      },
      properties: {
        name: "Chambers",
        phoneFormatted: "",
        phone: "",
        address: "705 N 1st #100 & #101",
        city: "Phoenix",
        country: "United States",
        postalCode: "85004",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.932186, 33.493287],
      },
      properties: {
        name: "Old Town Tortilla Factory",
        phoneFormatted: "",
        phone: "",
        address: "6910 E Main Street",
        city: "Scottsdale",
        country: "United States",
        postalCode: "85251",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.93782, 33.392525],
      },
      properties: {
        name: "Valley Fair Liquor",
        phoneFormatted: "",
        phone: "",
        address: "121 E Southern",
        city: "Tempe",
        country: "United States",
        postalCode: "85282",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.908519, 33.486817],
      },
      properties: {
        name: "Carlsbad Tavern",
        phoneFormatted: "",
        phone: "",
        address: "3313 N Hayden Rd.",
        city: "Scottsdale",
        country: "United States",
        postalCode: "85251",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.923067, 33.499775],
      },
      properties: {
        name: "Goodwood",
        phoneFormatted: "",
        phone: "",
        address: "7330 E Stetson Drive",
        city: "Scottsdale",
        country: "United States",
        postalCode: "85251",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.90602, 33.67066],
      },
      properties: {
        name: "Craftsman",
        phoneFormatted: "",
        phone: "",
        address: "20469 N Hayden Road",
        city: "SCottsdale",
        country: "United States",
        postalCode: "85255",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.789425, 33.33587],
      },
      properties: {
        name: "Quick N Shine Car Wash",
        phoneFormatted: "",
        phone: "",
        address: "777 S Gilbert Rd",
        city: "Gilbert",
        country: "United States",
        postalCode: "85296",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.942643, 33.420793],
      },
      properties: {
        name: "Casey Moore's Oyster House",
        phoneFormatted: "",
        phone: "",
        address: "850 S Ash",
        city: "Tempe",
        country: "United States",
        postalCode: "85281",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.550732, 33.414322],
      },
      properties: {
        name: "Lucky Bob's",
        phoneFormatted: "",
        phone: "",
        address: "431 W. Apache Trail",
        city: "Apache Junction",
        country: "United States",
        postalCode: "85220",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-110.92226, 32.25012],
      },
      properties: {
        name: "Maui Mart",
        phoneFormatted: "",
        phone: "",
        address: "3310 E Grant Rd",
        city: "Tucson",
        country: "United States",
        postalCode: "85716",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.92465, 33.498775],
      },
      properties: {
        name: "Social Tap",
        phoneFormatted: "",
        phone: "",
        address: "4312 N Brown Ave",
        city: "Scottsdale",
        country: "United States",
        postalCode: "85251",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.75313, 33.30688],
      },
      properties: {
        name: "Salt Tacos Y Tequila",
        phoneFormatted: "",
        phone: "",
        address: "2206 E Williams Field Rd #101",
        city: "Gilbert",
        country: "United States",
        postalCode: "85296",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-112.05669, 33.506147],
      },
      properties: {
        name: "Hi-Liter",
        phoneFormatted: "",
        phone: "",
        address: "4716 N 12th Street",
        city: "Phoenix",
        country: "United States",
        postalCode: "85014",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.89346, 33.46645],
      },
      properties: {
        name: "Sam's Market",
        phoneFormatted: "",
        phone: "",
        address: "8770 E McDowell Rd",
        city: "Scottsdale",
        country: "United States",
        postalCode: "85251",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.92585, 33.47755],
      },
      properties: {
        name: "The Well Bar and Lounge",
        phoneFormatted: "",
        phone: "",
        address: "2623 N Scottsdale Rd",
        city: "Scottsdale",
        country: "United States",
        postalCode: "85257",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.881379, 33.581892],
      },
      properties: {
        name: "Liquor Vault",
        phoneFormatted: "",
        phone: "",
        address: "9301 E Shea",
        city: "Scottsdale",
        country: "United States",
        postalCode: "85258",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.924174, 33.499419],
      },
      properties: {
        name: "Wasted Grain",
        phoneFormatted: "",
        phone: "",
        address: "7295 E Stetson Dr",
        city: "Scottsdale",
        country: "United States",
        postalCode: "85251",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.925925, 33.491635],
      },
      properties: {
        name: "RnR",
        phoneFormatted: "",
        phone: "",
        address: "3737 N Scottsdale Rd",
        city: "Scottsdale",
        country: "United States",
        postalCode: "85251",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-110.967619, 32.140677],
      },
      properties: {
        name: "Liquor Dan",
        phoneFormatted: "",
        phone: "",
        address: "6121 S 6th Avenue",
        city: "Tucson",
        country: "United States",
        postalCode: "85706",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.92564, 33.415245],
      },
      properties: {
        name: "Jerry's Liquor",
        phoneFormatted: "",
        phone: "",
        address: "1217 S. Rural",
        city: "Tempe",
        country: "United States",
        postalCode: "85281",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.53531, 33.40739],
      },
      properties: {
        name: "Canyon Food Mart",
        phoneFormatted: "",
        phone: "",
        address: "1000 E Old West Hwy",
        city: "Apache Junction",
        country: "United States",
        postalCode: "85219",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.971543, 33.465863],
      },
      properties: {
        name: "Mr. Haney's (Castaways)",
        phoneFormatted: "",
        phone: "",
        address: "5110 E McDowell Rd",
        city: "Phoenic",
        country: "United States",
        postalCode: "85008",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.92034, 33.498715],
      },
      properties: {
        name: "Fox Cigar Warehouse",
        phoneFormatted: "",
        phone: "",
        address: "248 E 10th Dr",
        city: "Mesa",
        country: "United States",
        postalCode: "85251",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.927212, 33.653829],
      },
      properties: {
        name: "Whole Foods Scottsdale",
        phoneFormatted: "",
        phone: "",
        address: "7111 E Mayo Blvd",
        city: "Phoenix",
        country: "United States",
        postalCode: "85054",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.790001, 33.352291],
      },
      properties: {
        name: "GCM Liquor",
        phoneFormatted: "",
        phone: "",
        address: "100 N Gilbert Rd",
        city: "Gilbert",
        country: "United States",
        postalCode: "85233",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.469435, 36.921717],
      },
      properties: {
        name: "Lake Powell National Golf Club",
        phoneFormatted: "",
        phone: "",
        address: "400 Club House Dr",
        city: "Page",
        country: "United States",
        postalCode: "86040",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-110.96727, 32.221952],
      },
      properties: {
        name: "Playground",
        phoneFormatted: "",
        phone: "",
        address: "278 E Congress St.",
        city: "Tucson",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.84182, 33.30161],
      },
      properties: {
        name: "The Stillery",
        phoneFormatted: "",
        phone: "",
        address: "130 S Arizona Ave BLDG STE1",
        city: "Chandleer",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-112.00017, 33.3044],
      },
      properties: {
        name: "La Casa De Juana",
        phoneFormatted: "",
        phone: "",
        address: "3941 E Chandler BLVD #101",
        city: "Phoenix",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-110.965657, 32.22806],
      },
      properties: {
        name: "Mr. Heads",
        phoneFormatted: "",
        phone: "",
        address: "513 N 4th Ave",
        city: "Tucson",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.92404, 33.52604],
      },
      properties: {
        name: "Fleming's Prime Steakhouse",
        phoneFormatted: "",
        phone: "",
        address: "6333 N Scottsdale Rd",
        city: "Scottsdale",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.910123, 33.487013],
      },
      properties: {
        name: "Uncle Sal's Ristorante",
        phoneFormatted: "",
        phone: "",
        address: "3370 N Hayden Rd #120",
        city: "Scottsdale",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.57678, 35.23245],
      },
      properties: {
        name: "Cinder's Liquors",
        phoneFormatted: "",
        phone: "",
        address: "5620 N Hwy 89",
        city: "Flagstaff",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-110.0658, 31.71241],
      },
      properties: {
        name: "Wyatt Earp's Oriental Saloon",
        phoneFormatted: "",
        phone: "",
        address: "500 E Allen St",
        city: "Tombstone",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.845451, 33.438862],
      },
      properties: {
        name: "Mesa Country Club",
        phoneFormatted: "",
        phone: "",
        address: "660 W Fairway Drive",
        city: "Mesa",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.843325, 33.302045],
      },
      properties: {
        name: "Puro Cigar Bar",
        phoneFormatted: "",
        phone: "",
        address: "111 W Boston St",
        city: "Chandler",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-112.064765, 33.47199],
      },
      properties: {
        name: "Dahlia Tapas Tequila and Wine",
        phoneFormatted: "",
        phone: "",
        address: "2221 N 7th St",
        city: "Phoenix",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.87501, 33.319435],
      },
      properties: {
        name: "Valle Luna",
        phoneFormatted: "",
        phone: "",
        address: "1949 W Ray Rd Bldg G",
        city: "Chandler",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-112.074181, 33.447403],
      },
      properties: {
        name: "Chico Malo",
        phoneFormatted: "",
        phone: "",
        address: "50 W Jefferson St. #105",
        city: "Phoenix",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-110.97492, 32.35524],
      },
      properties: {
        name: "The Landing",
        phoneFormatted: "",
        phone: "",
        address: "8195 N Oracle Rd #105",
        city: "Oro Valley",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.97072, 33.445955],
      },
      properties: {
        name: "Le Girls Gentlemen's Club",
        phoneFormatted: "",
        phone: "",
        address: "5151 E Washington",
        city: "Phoenix",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.92448, 33.62801],
      },
      properties: {
        name: "Evo North",
        phoneFormatted: "",
        phone: "",
        address: "15507 N Scottsdale Rd #100",
        city: "Scottsdale",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-110.953275, 32.271545],
      },
      properties: {
        name: "Guadalajara Grill",
        phoneFormatted: "",
        phone: "",
        address: "1220 E Prince Rd",
        city: "Tucson",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.835198, 33.414785],
      },
      properties: {
        name: "Tacos Chiwas",
        phoneFormatted: "",
        phone: "",
        address: "127 W Main St",
        city: "Mesa",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-112.186131, 33.639673],
      },
      properties: {
        name: "Popo's Fiesta Del Sol",
        phoneFormatted: "",
        phone: "",
        address: "17037 N 58th Ave",
        city: "Glendale",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-110.843851, 32.308287],
      },
      properties: {
        name: "Commoner & Co",
        phoneFormatted: "",
        phone: "",
        address: "6960 E Sunrise #110",
        city: "Tucson",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-110.976054, 32.330198],
      },
      properties: {
        name: "Hifalutin",
        phoneFormatted: "",
        phone: "",
        address: "6790 N Oracle Rd",
        city: "Tucson",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-112.204329, 33.564125],
      },
      properties: {
        name: "Morningstar at Golden Ridge",
        phoneFormatted: "",
        phone: "",
        address: "6735 W Golden Lane",
        city: "Peoria",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-112.11806, 33.78497],
      },
      properties: {
        name: "LIMóN Urban Kitchen",
        phoneFormatted: "",
        phone: "",
        address: "2750 W Dove Valley Rd. #190",
        city: "Phoenix",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-112.064951, 33.653668],
      },
      properties: {
        name: "Magnum's Cigar, Wine & Liquor",
        phoneFormatted: "",
        phone: "",
        address: "731 E Union Hills Dr. Ste B10",
        city: "Phoenix",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.961036, 33.531582],
      },
      properties: {
        name: "El Chorro Lodge",
        phoneFormatted: "",
        phone: "",
        address: "5550 E Lincoln",
        city: "Paradise Valley",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-112.26062, 33.53368],
      },
      properties: {
        name: "The Lola",
        phoneFormatted: "",
        phone: "",
        address: "6770 N Sunrise Blvd. #G109",
        city: "Glendale",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-112.07228, 33.44859],
      },
      properties: {
        name: "The Desmond",
        phoneFormatted: "",
        phone: "",
        address: "1 N 1st St STE 103",
        city: "Phoenix",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-110.97567, 32.2622],
      },
      properties: {
        name: "Family Food Store",
        phoneFormatted: "",
        phone: "2100 W Ruthrauff Rd",
        address: "",
        city: "Tuscon",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.62504, 35.19205],
      },
      properties: {
        name: "Dirty Birdies Sports Bar and Grill",
        phoneFormatted: "",
        phone: "",
        address: "2285 E Butler Ave",
        city: "Flagstaff",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-112.437487, 33.593501],
      },
      properties: {
        name: "Sterling Grove Country Club",
        phoneFormatted: "",
        phone: "",
        address: "17193 W Montpelier St",
        city: "Surprise",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.915098, 33.55045],
      },
      properties: {
        name: "Scottsdale Conference Center",
        phoneFormatted: "",
        phone: "",
        address: "7700 E. Mccormick Pkwy",
        city: "Scottsdale",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.922348, 33.500868],
      },
      properties: {
        name: "Bevvy",
        phoneFormatted: "",
        phone: "",
        address: "4420 N Saddlebag Trail #100",
        city: "Scottsdale",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-110.965918, 32.225415],
      },
      properties: {
        name: "Hut on Fourth",
        phoneFormatted: "",
        phone: "",
        address: "305 N Herbert Ave",
        city: "Tucson",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.923125, 33.49789],
      },
      properties: {
        name: "11:11 Nightclub",
        phoneFormatted: "",
        phone: "",
        address: "4280 N Drinkwater Blvd. #100",
        city: "Scottsdale",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.85789, 33.38476],
      },
      properties: {
        name: "Ojos Locos Sports Cantina",
        phoneFormatted: "",
        phone: "",
        address: "1656 S Alma School Rd",
        city: "Mesa",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.96351, 33.3063],
      },
      properties: {
        name: "Hawkins Chevron",
        phoneFormatted: "",
        phone: "",
        address: "7000 W Chandler Blvd.",
        city: "Chandler",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-112.203734, 33.583918],
      },
      properties: {
        name: "Enoch's Sports Lounge",
        phoneFormatted: "",
        phone: "",
        address: "6750 W. Peoria Ste. 145",
        city: "Peoria",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-110.87889, 32.22091],
      },
      properties: {
        name: "The Dutch - DAM Good Food",
        phoneFormatted: "",
        phone: "",
        address: "5340 E Broadway #100",
        city: "Tucson",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-110.893022, 32.310136],
      },
      properties: {
        name: "Finis's Landing",
        phoneFormatted: "",
        phone: "",
        address: "5689 Swan Rd",
        city: "Tucson",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-112.00279, 33.494678],
      },
      properties: {
        name: "Dilly Dally Cocktail Lounge",
        phoneFormatted: "",
        phone: "",
        address: "3639 E Indian SChool",
        city: "Phoenix",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-110.948415, 32.22112],
      },
      properties: {
        name: "Axis Food Mart",
        phoneFormatted: "",
        phone: "",
        address: "1540 E Broadway",
        city: "Tucson",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-110.96582, 32.22483],
      },
      properties: {
        name: "O'Malley's on Fourth",
        phoneFormatted: "",
        phone: "",
        address: "247 N 4th Ave",
        city: "Tucson",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-109.93069, 34.12612],
      },
      properties: {
        name: "Pasta House",
        phoneFormatted: "",
        phone: "",
        address: "2188 White Mountain R",
        city: "Pinetop",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.860535, 33.32012],
      },
      properties: {
        name: "Stadium Club",
        phoneFormatted: "",
        phone: "",
        address: "940 N Alma School Rd #106",
        city: "Chandler",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.647295, 35.19823],
      },
      properties: {
        name: "Monte Vista Cocktail Lounge",
        phoneFormatted: "",
        phone: "",
        address: "100 N San Francisco",
        city: "Flagstaff",
        country: "United States",
        postalCode: "",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-112.069325, 33.445685],
      },
      properties: {
        name: "Willie's Taco Joint",
        phoneFormatted: "",
        phone: "",
        address: "333 E Jefferson St STE 102",
        city: "Phoenix",
        country: "United States",
        postalCode: "85004",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.929763, 33.493337],
      },
      properties: {
        name: "The Beverly on Main",
        phoneFormatted: "",
        phone: "",
        address: "7018 E Main St",
        city: "Scottsdale",
        country: "United States",
        postalCode: "85251",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.924651, 33.498778],
      },
      properties: {
        name: "Social Tap",
        phoneFormatted: "",
        phone: "",
        address: "4312 N Brown Ave",
        city: "Scottsdale",
        country: "United States",
        postalCode: "85251",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-114.59729, 35.00949],
      },
      properties: {
        name: "Speedway Mini Mart",
        phoneFormatted: "",
        phone: "",
        address: "5100 Hwy 95",
        city: "Fort Mohave",
        country: "United States",
        postalCode: "86426",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.92025, 33.415294],
      },
      properties: {
        name: "Sun Stop Liquor",
        phoneFormatted: "",
        phone: "",
        address: "1212 E Apache Blvd.",
        city: "Tempe",
        country: "United States",
        postalCode: "85281",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.926591, 33.476555],
      },
      properties: {
        name: "Los Sombreros",
        phoneFormatted: "",
        phone: "",
        address: "2534 N Scottsdale Rd",
        city: "Scottsdale",
        country: "United States",
        postalCode: "85257",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-110.97765, 32.3364],
      },
      properties: {
        name: "Whole Foods Oracle",
        phoneFormatted: "",
        phone: "",
        address: "7133 N Oracle Rd",
        city: "Tucson",
        country: "United States",
        postalCode: "85704",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-112.009185, 34.732695],
      },
      properties: {
        name: "The Chaparral Bar",
        phoneFormatted: "",
        phone: "",
        address: "325 S Main St",
        city: "Cottonwood",
        country: "United States",
        postalCode: "86326",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-110.77927, 32.24004],
      },
      properties: {
        name: "Club at La Mariposa",
        phoneFormatted: "",
        phone: "",
        address: "1501 N Houghton Rd",
        city: "Tucson",
        country: "United States",
        postalCode: "85749",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-112.026758, 33.522867],
      },
      properties: {
        name: "Wrigley Mansion Club",
        phoneFormatted: "",
        phone: "",
        address: "2501 E Telewa Trail",
        city: "Phoenix",
        country: "United States",
        postalCode: "85016",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.92585, 33.47755],
      },
      properties: {
        name: "Well Bar and Lounge",
        phoneFormatted: "",
        phone: "",
        address: "2623 N Scottsdale Road",
        city: "Scottsdale",
        country: "United States",
        postalCode: "85257",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-111.790566, 33.356776],
      },
      properties: {
        name: "Clever Koi",
        phoneFormatted: "",
        phone: "",
        address: "60 W Vaughn Ave #101-103",
        city: "Gilbert",
        country: "United States",
        postalCode: "85234",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-112.012015, 33.58207],
      },
      properties: {
        name: "The Playa II",
        phoneFormatted: "",
        phone: "",
        address: "3217 Shea Blvd",
        city: "Phoenix",
        country: "United States",
        postalCode: "85028",
        state: "AZ",
        premise: "ON",
        blanco: 0,
        resposado: 0,
        anejo: 0,
      },
     },
    ],
  };
  const storesCA = {
    type: "FeatureCollection",
    features: [
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.4099907, 33.8829066],
        },
        properties: {
          name: "Arthur J",
          phoneFormatted: "(310)878-9620",
          phone: "3108789620",
          address: "903 Manhattan Ave",
          city: "Manhattan Beach ",
          country: "United States",
          postalCode: "90266",
          state: "CA",
          premise: "ON",
          blanco: 0,
          resposado: 1,
          anejo: 0,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.582946, 33.595818],
        },
        properties: {
          name: "Coto De Caza Golf Rqt",
          phoneFormatted: "",
          phone: "",
          address: "25291 Vista Del Verde",
          city: "Coto De Caza",
          country: "United States",
          postalCode: "",
          state: "AZ",
          premise: "ON",
          blanco: 0,
          resposado: 0,
          anejo: 0,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.289735, 34.171054],
        },
        properties: {
          name: "Remedy Liquor",
          phoneFormatted: "(818)549-1055",
          phone: "8185491055",
          address: "1700 W Glenoaks ",
          city: "Glendale ",
          country: "United States",
          postalCode: "91201",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.3615598, 33.9877628],
        },
        properties: {
          name: "Slauson Liquor",
          phoneFormatted: "(323)792-4803",
          phone: "3237924803",
          address: "4834 W. Slauson Ave",
          city: "Los Angeles ",
          country: "United States",
          postalCode: "90056",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.3578831, 33.9795907],
        },
        properties: {
          name: "DROBE Stogies Lounge",
          phoneFormatted: "(424)227-9005",
          phone: "4242279005",
          address: "1322 N. La Brea Ave",
          city: "Inglewood ",
          country: "United States",
          postalCode: "90302",
          state: "CA ",
          premise: "ON",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.096597, 33.967911],
        },
        properties: {
          name: "Serv Rite",
          phoneFormatted: "(562)948-1906",
          phone: "5629481906",
          address: "9420 Slauson Ave",
          city: "Pico Rivera",
          country: "United States",
          postalCode: "90660",
          state: "CA",
          premise: "ON",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.93054, 34.133655],
        },
        properties: {
          name: "Daddys Liquor",
          phoneFormatted: "(909)600-7448",
          phone: "9896007448",
          address: "17264 Foothill Blvd K",
          city: "Fontana",
          country: "United States",
          postalCode: "92335",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.97397, 33.98133],
        },
        properties: {
          name: "CA Mini Mart",
          phoneFormatted: "(626)474-2192",
          phone: "6264742192",
          address: "3109 Colima Rd",
          city: "Hacienda Heights",
          country: "United States",
          postalCode: "91745",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.346373, 33.959635],
         },
        properties: {
          name: "Martinos Liquor",
          phoneFormatted: "(310)672-0494",
          phone: "3106720494",
          address: "706 E Manchester Blvd.",
          city: "Inglewood",
          country: "United States",
          postalCode: "90301",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.36352, 33.96147],
         },
        properties: {
          name: "Andys Liquor",
          phoneFormatted: "(310)672-3284",
          phone: "3106723284",
          address: "440 W Manchester Blvd",
          city: "Inglewood",
          country: "United States",
          postalCode: "90301",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.388063, 33.81736],
         },
        properties: {
          name: "Hook and Plow",
          phoneFormatted: "(424)247-8272",
          phone: "4242478272",
          address: "1729 S Catalina",
          city: "Redondo Beach",
          country: "United States",
          postalCode: "90277",
          state: "CA",
          premise: "ON",
          blanco: 0,
          resposado: 0,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.36087, 33.82664],
         },
        properties: {
          name: "Chateau Liquor",
          phoneFormatted: "(310)540-0021",
          phone: "3105400021",
          address: "4545 Sepulveda Blvd",
          city: "Torrance",
          country: "United States",
          postalCode: "90505",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.43786, 33.95897],
         },
        properties: {
          name: "Dales Jr Market",
          phoneFormatted: "(310)574-6775",
          phone: "3105746775",
          address: "8105 W Manchester",
          city: "Playa Del Rey",
          country: "United States",
          postalCode: "90293",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 0,
          anejo: 0,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.330167, 34.103931],
         },
        properties: {
          name: "Playboy Liquor",
          phoneFormatted: "(323)465-5544",
          phone: "3234655544",
          address: "6435 Yucca Street",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90028",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.871043, 33.88955],
         },
        properties: {
          name: "Vendome Wine and Spirits",
          phoneFormatted: "(714)524-0800",
          phone: "7145240800",
          address: "3115 Yorba Linda Blvd",
          city: "Fullerton",
          country: "United States",
          postalCode: "92831",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.37182, 33.90196],
         },
        properties: {
          name: "King Keg",
          phoneFormatted: "(310)536-9414",
          phone: "3105369414",
          address: "5241 W Rosecrans Ave",
          city: "Hawthorn",
          country: "United States",
          postalCode: "90250",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.25566, 32.793293],
         },
        properties: {
          name: "Baja Beach Cafe",
          phoneFormatted: "(858)230-6315",
          phone: "8582306315",
          address: "701 Thomas Ave",
          city: "San Diego",
          country: "United States",
          postalCode: "92109",
          state: "CA",
          premise: "ON",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.89954, 33.60138],
         },
        properties: {
          name: "Cabo Cantina",
          phoneFormatted: "(949)675-7760",
          phone: "9496757760",
          address: "100 Main St",
          city: "Newport Beach",
          country: "United States",
          postalCode: "92661",
          state: "CA",
          premise: "ON",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.33587, 34.10181],
         },
        properties: {
          name: "Jamesons Irish Pub",
          phoneFormatted: "(323)798-5360",
          phone: "3237985360",
          address: "6681 Hollywood Blvd",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90028",
          state: "CA",
          premise: "ON",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.497665, 34.017009],
         },
        properties: {
          name: "Cabo Cantina",
          phoneFormatted: "(310)393-5755",
          phone: "3103935755",
          address: "1240 3rd St Promenade",
          city: "Santa Monica",
          country: "United States",
          postalCode: "90401",
          state: "CA",
          premise: "ON",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.482637, 34.00073],
         },
        properties: {
          name: "Jamesons Pub",
          phoneFormatted: "(424)330-0069",
          phone: "4243300069",
          address: "2702 Main St",
          city: "Santa Monica",
          country: "United States",
          postalCode: "90405",
          state: "CA",
          premise: "ON",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.39558, 33.89837],
         },
        properties: {
          name: "Sushi Roku",
          phoneFormatted: "(310)683-4060",
          phone: "3106834060",
          address: "3110 N Sepulveda Blvd",
          city: "Manhattan Beach",
          country: "United States",
          postalCode: "90266",
          state: "CA",
          premise: "ON",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.39539112317735, 33.898810268678695],
         },
        properties: {
          name: "Boa Steakhouse",
          phoneFormatted: "(310)683-4080",
          phone: "3106834080",
          address: "3110 N Sepulveda Blvd",
          city: "Manhattan Beach",
          country: "United States",
          postalCode: "90266",
          state: "CA",
          premise: "ON",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.49305, 34.02452],
         },
        properties: {
          name: "El Cholo",
          phoneFormatted: "(310)899-1106",
          phone: "3108991106",
          address: "1025 Wilshire Blvd",
          city: "Santa Monica",
          country: "United States",
          postalCode: "90401",
          state: "CA",
          premise: "ON",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.35992, 34.03265],
         },
        properties: {
          name: "ALTA",
          phoneFormatted: "(323)571-4999",
          phone: "3235714999",
          address: "5359 W Adams Blvd",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90016",
          state: "CA",
          premise: "ON",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.398723, 34.066173],
         },
        properties: {
          name: "South Beverly Grill",
          phoneFormatted: "(310)550-0242",
          phone: "3105500242",
          address: "122 S Beverly Drive",
          city: "Beverly Hills",
          country: "United States",
          postalCode: "90212",
          state: "CA",
          premise: "ON",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.85281, 33.78102],
         },
        properties: {
          name: "K and B Market",
          phoneFormatted: "(714)538-1216",
          phone: "7145381216",
          address: "481 S Glassell St",
          city: "Orange",
          country: "United States",
          postalCode: "92866",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.24181, 34.21295],
         },
        properties: {
          name: "Village Liquor",
          phoneFormatted: "(818)248-9224",
          phone: "8182489224",
          address: "2905 Honolulu Ave",
          city: "La Crescenta",
          country: "United States",
          postalCode: "91214",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.298162, 34.255065],
         },
        properties: {
          name: "City 21 Market",
          phoneFormatted: "(818)352-0788",
          phone: "8183520788",
          address: "7611 Foothill Blvd",
          city: "Tujunga",
          country: "United States",
          postalCode: "91042",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.809875, 33.74957],
         },
        properties: {
          name: "Bradleys Fine Wine and Spirits",
          phoneFormatted: "(714)544-1444",
          phone: "7145441444",
          address: "12932 Newport Ave 1",
          city: "Tustin",
          country: "United States",
          postalCode: "92780",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.63184, 33.43247],
         },
        properties: {
          name: "Landers",
          phoneFormatted: "(949)503-4100",
          phone: "9495034100",
          address: "1814 N El Camino Real",
          city: "San Clemente",
          country: "United States",
          postalCode: "92672",
          state: "CA",
          premise: "ON",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.252117, 34.055906],
         },
        properties: {
          name: "Bunker Hill Market and Deli",
          phoneFormatted: "(213)624-1245",
          phone: "2136241245",
          address: "Road, 800 W 1st St 101",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90012",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 0,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.9279, 33.802915],
         },
        properties: {
          name: "Wonderland Liquor",
          phoneFormatted: "(714)535-0127",
          phone: "7145350127",
          address: "1178 W Katella Ave",
          city: "Anaheim",
          country: "United States",
          postalCode: "92802",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.98895, 33.66546],
         },
        properties: {
          name: "Hilltop Liquor",
          phoneFormatted: "(714)536-6275",
          phone: "7145366275",
          address: "815 Indianapolis Ave",
          city: "Huntington Beach",
          country: "United States",
          postalCode: "92648",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.81401, 33.74465],
         },
        properties: {
          name: "So Cal Wine and Spirits",
          phoneFormatted: "(714)544-2661",
          phone: "7145442661",
          address: "1042 E 1st St",
          city: "Tustin",
          country: "United States",
          postalCode: "92780",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.612431, 33.426197],
        },
        properties: {
          name: "Catalina Liquor and JR Market",
          phoneFormatted: "(949)492-6606",
          phone: "9494926606",
          address: "102 Avenida Victoria",
          city: "San Clemente",
          country: "United States",
          postalCode: "92672",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.6138, 33.427985],
        },
        properties: {
          name: "Nomads Canteen",
          phoneFormatted: "(949)481-4853",
          phone: "9494814853",
          address: "102 Avenida Cabrillo",
          city: "San Clemente",
          country: "United States",
          postalCode: "92672",
          state: "CA",
          premise: "ON",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.361575, 33.9128],
        },
        properties: {
          name: "SK Liquor",
          phoneFormatted: "(310)263-1760",
          phone: "3102631760",
          address: "13201 S Inglewood Ave",
          city: "Hawthorne",
          country: "United States",
          postalCode: "90250",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.130125, 33.927895],
        },
        properties: {
          name: "Aloha Liquor",
          phoneFormatted: "(562)674-3333",
          phone: "5626749999",
          address: "11837 Lakewood Blvd",
          city: "Downey",
          country: "United States",
          postalCode: "90241",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 0,
          anejo: 0,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.32645, 34.09633],
        },
        properties: {
          name: "K and L Merchants",
          phoneFormatted: "(323)464-9463",
          phone: "3234649463",
          address: "1400 Vine Street",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90028",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.112597, 33.992653],
        },
        properties: {
          name: "Johnnys Liquor",
          phoneFormatted: "(323)721-2391",
          phone: "3237212391",
          address: "400 Washington Blvd",
          city: "Montebello",
          country: "United States",
          postalCode: "90640",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.11419, 34.01889],
        },
        properties: {
          name: "Super Star Liquor",
          phoneFormatted: "(323)721-8988",
          phone: "3237218988",
          address: "1436 W Beverly",
          city: "Montebello",
          country: "United States",
          postalCode: "90640",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.02158, 33.92481],
        },
        properties: {
          name: "Rodeo Liquor",
          phoneFormatted: "(562)758-3133",
          phone: "5627583133",
          address: "14547 Leffingwell Rd",
          city: "Whittier",
          country: "United States",
          postalCode: "90604",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.117711, 33.932116],
        },
        properties: {
          name: "Wymans Liquor",
          phoneFormatted: "(562)803-0314",
          phone: "5628030314",
          address: "9300 Firestone Blvd",
          city: "Downey",
          country: "United States",
          postalCode: "90241",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.941659, 33.873682],
        },
        properties: {
          name: "G&D Liquor",
          phoneFormatted: "(714)525-0085",
          phone: "7145250085",
          address: "338 N Euclid St",
          city: "Downey",
          country: "United States",
          postalCode: "92832",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-122.323598, 37.579286],
        },
        properties: {
          name: "Coasters",
          phoneFormatted: "(650)437-2954",
          phone: "6504372954",
          address: "1127 N Amphlett Blvd",
          city: "San Mateo",
          country: "United States",
          postalCode: "94401",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.449665, 34.192235],
        },
        properties: {
          name: "Jon's Market #2",
          phoneFormatted: "(818)781-1772",
          phone: "8187811772",
          address: "6655 Van Nuys Blvd.",
          city: "Van Nuys",
          country: "United States",
          postalCode: "91405",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.30522, 34.09093],
        },
        properties: {
          name: "Jon's Market #7",
          phoneFormatted: "(323)461-9382",
          phone: "3234619382",
          address: "5315 Santa Monica Blvd",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90029",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.28973, 34.17189],
        },
        properties: {
          name: "Jon's Market #9",
          phoneFormatted: "(818)244-2575",
          phone: "8182442575",
          address: "1717 W Glenoaks Blvd",
          city: "Glendale",
          country: "United States",
          postalCode: "91201",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.29248, 34.10023],
        },
        properties: {
          name: "Jon's Market #11",
          phoneFormatted: "(323)660-0220",
          phone: "3236600220",
          address: "1601 N Vermont Ave",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90027",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.248293, 34.14239],
        },
        properties: {
          name: "Jon's Market #14",
          phoneFormatted: "(818)956-0999",
          phone: "8189560999",
          address: "600 E Colorado St",
          city: "Glendale",
          country: "United States",
          postalCode: "91205",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.57283, 34.22033],
        },
        properties: {
          name: "Jon's Market #15",
          phoneFormatted: "(818)576-0477",
          phone: "8185760477",
          address: "20151 Roscoe Blvd.",
          city: "Winnetka",
          country: "United States",
          postalCode: "91306",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.39742, 34.16471],
        },
        properties: {
          name: "Jon's Market #16",
          phoneFormatted: "(818)985-4780",
          phone: "8189854780",
          address: "12122 W Magnolia Blvd.",
          city: "Valley Village",
          country: "United States",
          postalCode: "91607",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.465995, 34.20015],
        },
        properties: {
          name: "Jon's Martket #19",
          phoneFormatted: "(818)455-4020",
          phone: "8184555020",
          address: "7134 Sepulveda Blvd.",
          city: "Van Nuys",
          country: "United States",
          postalCode: "91405",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.528835, 34.202095],
        },
        properties: {
          name: "Jon's Market #24",
          phoneFormatted: "(818)758-3422",
          phone: "8187583422",
          address: "18135 Sherman Way",
          city: "Reseda",
          country: "United States",
          postalCode: "91335",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.344181, 34.048524],
        },
        properties: {
          name: "Pip's On La Brea",
          phoneFormatted: "(323)954-7477",
          phone: "3239547477",
          address: "1356 S La Brea Ave",
          city: "90019",
          country: "United States",
          postalCode: "",
          state: "CA",
          premise: "ON",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.398723, 34.066173],
        },
        properties: {
          name: "The HONOR Bar",
          phoneFormatted: "(310)550-0292",
          phone: "3105500292",
          address: "122 S Beverly Drive",
          city: "Beverly Hills",
          country: "United States",
          postalCode: "90212",
          state: "CA",
          premise: "ON",
          blanco: 1,
          resposado: 0,
          anejo: 0,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.477088, 33.996331],
        },
        properties: {
          name: "The Rose Venice",
          phoneFormatted: "(310)399-0711",
          phone: "3103990711",
          address: "220 Rose Ave",
          city: "Venice",
          country: "United States",
          postalCode: "90291",
          state: "CA",
          premise: "ON",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.47316, 33.998255],
        },
        properties: {
          name: "Wabi on Rose",
          phoneFormatted: "(310)564-2177",
          phone: "3105642177",
          address: "512 F Rose Ave",
          city: "Venice",
          country: "United States",
          postalCode: "",
          state: "CA",
          premise: "ON",
          blanco: 1,
          resposado: 0,
          anejo: 0,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.498226, 34.014489],
        },
        properties: {
          name: "Blue Plate Oysterette",
          phoneFormatted: "(310)576-3474",
          phone: "3105763474",
          address: "1355 Ocean Ave",
          city: "Santa Monica",
          country: "United States",
          postalCode: "90401",
          state: "CA",
          premise: "ON",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.417883, 33.900713],
        },
        properties: {
          name: "Panchos",
          phoneFormatted: "(310)545-6670",
          phone: "3105456670",
          address: "3615 Highland Ave.",
          city: "Manhattan Beach",
          country: "United States",
          postalCode: "90266",
          state: "CA",
          premise: "ON",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.38739, 34.02835],
        },
        properties: {
          name: "ETTA Culver City",
          phoneFormatted: "(424)570-4444",
          phone: "4245704444",
          address: "8801 Washington Blvd.",
          city: "Culver City",
          country: "United States",
          postalCode: "90232",
          state: "CA",
          premise: "ON",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.396195, 33.885295],
        },
        properties: {
          name: "Barsha Wine & Spirit Shop",
          phoneFormatted: "(310)318-9080",
          phone: "3103189080",
          address: "917 N Sepulveda",
          city: "Manhattan Beach",
          country: "United States",
          postalCode: "90266",
          state: "CA",
          premise: "OFF",
          blanco: 0,
          resposado: 1,
          anejo: 0,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.93726, 33.93874],
        },
        properties: {
          name: "El Cholo",
          phoneFormatted: "(562)691-4618",
          phone: "5626914618",
          address: "840 E Whittier Blvd.",
          city: "La Habra",
          country: "United States",
          postalCode: "90631",
          state: "CA",
          premise: "ON",
          blanco: 1,
          resposado: 0,
          anejo: 0,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.032888, 33.979322],
        },
        properties: {
          name: "California Grill",
          phoneFormatted: "(562)907-7017",
          phone: "5629077017",
          address: "6751 Painter",
          city: "Whittier",
          country: "United States",
          postalCode: "90601",
          state: "CA",
          premise: "ON",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.424415, 33.982505],
        },
        properties: {
          name: "Beverage Warehouse",
          phoneFormatted: "(310)306-2822",
          phone: "3103062822",
          address: "4935 McConnell Ave, Unit 21",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90066",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.451845, 33.9880529],
        },
        properties: {
          name: "Nueva",
          phoneFormatted: "(310)747-6050",
          phone: "3107476050",
          address: "822 Washington Blvd",
          city: "Venice",
          country: "United States",
          postalCode: "90292",
          state: "CA",
          premise: "ON",
          blanco: 1,
          resposado: 0,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-122.4111449, 37.7867679],
        },
        properties: {
          name: "Redwood Room",
          phoneFormatted: "(415)929-2372",
          phone: "4159292372",
          address: "495 Geary St.",
          city: "San Francisco",
          country: "United States",
          postalCode: "94102",
          state: "CA",
          premise: "ON",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.135471, 34.1459613],
        },
        properties: {
          name: "Total Wine and More",
          phoneFormatted: "(626)463-1444",
          phone: "6264631444",
          address: "721 E. Colorado Blvd",
          city: "Pasadena",
          country: "United States",
          postalCode: "91101",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.3539437, 33.8677505],
        },
        properties: {
          name: "Total Wine and More",
          phoneFormatted: "(310)542-1460",
          phone: "3105421460",
          address: "1505 Hawthorne Blvd",
          city: "Redondo Beach",
          country: "United States",
          postalCode: "90278",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.525272, 34.122329],
        },
        properties: {
          name: "Total Wine and More",
          phoneFormatted: "(909)463-5670",
          phone: "9094635670",
          address: "8201 Day Creek Blvd",
          city: "Rancho Cugamonga",
          country: "United States",
          postalCode: "91739",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.086873, 33.827538],
        },
        properties: {
          name: "Total Wine and More",
          phoneFormatted: "(562)420-2018",
          phone: "5624202018",
          address: "7400 Carson Blvd",
          city: "Long Beach",
          country: "United States",
          postalCode: "90808",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.192339, 32.74985],
        },
        properties: {
          name: "Old Town Liquor and Deli",
          phoneFormatted: "(619)291-4888",
          phone: "6192914888",
          address: "2304 San Diego Ave Ste A",
          city: "San Diego",
          country: "United States",
          postalCode: "92110",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.142679, 33.875528],
        },
        properties: {
          name: "Emilios Beverage Warehouse",
          phoneFormatted: "(562)630-8683",
          phone: "5626308683",
          address: "17251 Lakewood Blvd",
          city: "Bellflower",
          country: "United States",
          postalCode: "90706",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.30038, 34.161158],
        },
        properties: {
          name: "7 Days Liquor",
          phoneFormatted: "(818)551-0300",
          phone: "8185510300",
          address: "1700 Victory Blvd",
          city: "Glendale ",
          country: "United States",
          postalCode: "91201",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.370187, 34.172281],
        },
        properties: {
          name: "Circus Liquor",
          phoneFormatted: "(818)769-1500",
          phone: "8187691500",
          address: "5600 Vineland Ave",
          city: "N. Hollywood",
          country: "United States",
          postalCode: "91601",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.9178623, 33.6329753],
        },
        properties: {
          name: "Hi Time Cellars",
          phoneFormatted: "(949) 650-8463",
          phone: "9496508463",
          address: "250 Ogle Street",
          city: "Costa Mesa",
          country: "United States",
          postalCode: "92627",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.0296415, 33.9611681],
        },
        properties: {
          name: "Liquor Mart",
          phoneFormatted: "(562)693-7731",
          phone: "5626937731",
          address: "13583 Whittier Blvd",
          city: "Whittier",
          country: "United States",
          postalCode: "90605",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.9933074, 33.9310033],
        },
        properties: {
          name: "Liquor Mart #2",
          phoneFormatted: "(562)943-3490",
          phone: "5629433490",
          address: "15721 Leffingwell Rd",
          city: "Whittier",
          country: "United States",
          postalCode: "90604",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.21535, 34.035034],
        },
        properties: {
          name: "Ramirez Liquor",
          phoneFormatted: "(323)269-0029",
          phone: "3232690029",
          address: "736 S Soto St",
          city: "Los Angeles ",
          country: "United States",
          postalCode: "90023",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.2185057, 34.0236116],
        },
        properties: {
          name: "Ramirez Liquor",
          phoneFormatted: "(323)266-2338",
          phone: "3232662338",
          address: "2766 E Olympic Blvd",
          city: "Los Angeles ",
          country: "United States",
          postalCode: "90023",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 0,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.0967839, 33.9685008],
        },
        properties: {
          name: "Ramirez Liquor",
          phoneFormatted: "(562)222-2337",
          phone: "5622222337",
          address: "9419 Slauson Ave",
          city: "Pico Rivera",
          country: "United States",
          postalCode: "90660",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 0,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.559105, 34.2417312],
        },
        properties: {
          name: "Super King",
          phoneFormatted: "(818)350-5970",
          phone: "8183505970",
          address: "19500 Plummer St",
          city: "Northridge",
          country: "United States",
          postalCode: "91324",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 0,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.4488575, 34.2017334],
        },
        properties: {
          name: "Super King",
          phoneFormatted: "(818)464-4322",
          phone: "8184644322",
          address: "7227 Van Nuys Blvd",
          city: "Van Nuys",
          country: "United States",
          postalCode: "91405",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 0,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.2692202, 34.1417838],
        },
        properties: {
          name: "Super King",
          phoneFormatted: "(747)272-0077",
          phone: "7472720077",
          address: "6501 San Fernando Rd",
          city: "Glendale ",
          country: "United States",
          postalCode: "91201",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 0,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.1586727, 34.1914167],
        },
        properties: {
          name: "Super King",
          phoneFormatted: "(626)296-9311",
          phone: "6262969311",
          address: "2260 Lincoln Ave",
          city: "Altadena",
          country: "United States",
          postalCode: "91001",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 0,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.242479, 34.109675],
        },
        properties: {
          name: "Super King",
          phoneFormatted: "(323)225-0044",
          phone: "3232250044",
          address: "2716 N San Fernando Rd",
          city: "Los Angeles ",
          country: "United States",
          postalCode: "90065",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 0,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.0799764, 34.0626697],
        },
        properties: {
          name: "Super King",
          phoneFormatted: "(626)573-1919",
          phone: "6265731919",
          address: "7459 Garvey Ave",
          city: "Rosemead",
          country: "United States",
          postalCode: "91770",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 0,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.9762483, 33.8523076],
        },
        properties: {
          name: "Super King",
          phoneFormatted: "(714)527-5809",
          phone: "7145275809",
          address: "10500 Magnolia Ave",
          city: "Anaheim",
          country: "United States",
          postalCode: "92804",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 0,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.7202364, 34.0806554],
        },
        properties: {
          name: "Super King",
          phoneFormatted: "(909)267-7252",
          phone: "9092677252",
          address: "436 Auto Center Dr",
          city: "Claremont",
          country: "United States",
          postalCode: "91711",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 0,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.6169978, 34.1325426],
        },
        properties: {
          name: "Castle Liquor",
          phoneFormatted: "(909)476-1913",
          phone: "9094761913",
          address: "8655 19th St",
          city: "Rancho Cucamonga",
          country: "United States",
          postalCode: "91701",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.87338, 33.676079],
        },
        properties: {
          name: "Costa Mesa Wine & Spirits",
          phoneFormatted: "(714)540-2519",
          phone: "7145402519",
          address: "891 Baker St # B1",
          city: "Costa Mesa",
          country: "United States",
          postalCode: "92626",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.555703, 34.03845],
        },
        properties: {
          name: "Gladstone's ",
          phoneFormatted: "(310)454-3474",
          phone: "3104543474",
          address: "17300 CA-1",
          city: "Pacific Palisades",
          country: "United States",
          postalCode: "90272",
          state: "CA",
          premise: "ON",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.419345, 34.058913],
        },
        properties: {
          name: "Javier's ",
          phoneFormatted: "(42403138143",
          phone: "42403138143",
          address: "10250 Santa Monica Blvd",
          city: "Los Angeles ",
          country: "United States",
          postalCode: "90067",
          state: "CA",
          premise: "ON",
          blanco: 1,
          resposado: 1,
          anejo: 0,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.3939201, 33.8734702],
        },
        properties: {
          name: "Manhattan Fine Wines",
          phoneFormatted: "310 374-3454",
          phone: "3103743454",
          address: "1157 Artesia Blvd.",
          city: "Manhattan Beach ",
          country: "United States",
          postalCode: "90266",
          state: "CA",
          premise: "OFF ",
          blanco: 1,
          resposado: 1,
          anejo: 0,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.396126, 33.900313],
        },
        properties: {
          name: "Tin Roof Bistro",
          phoneFormatted: "(310)939-0900",
          phone: "3109390900",
          address: "3500 N. Sepulveda Blvd",
          city: "Manhattan Beach ",
          country: "United States",
          postalCode: "90266",
          state: "CA",
          premise: "ON",
          blanco: 0,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.3989569, 34.0666729],
        },
        properties: {
          name: "Honor Wine & Spirits",
          phoneFormatted: "(310)550-4557",
          phone: "3105504557",
          address: "114 S. Beverly Dr.",
          city: "Beverly Hills ",
          country: "United States",
          postalCode: "90212",
          state: "CA ",
          premise: "OFF",
          blanco: 1,
          resposado: 0,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.39591, 33.86428],
        },
        properties: {
          name: "Dawn to Dusk Liquor",
          phoneFormatted: "",
          phone: "",
          address: "",
          city: "Hermosa Beach ",
          country: "United States",
          postalCode: "90254",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.113558, 34.169063],
        },
        properties: {
          name: "Mission Liquor",
          phoneFormatted: "(626)794-7026",
          phone: "6267947026",
          address: "1785 E Washington Blvd",
          city: "Pasadena",
          country: "United States",
          postalCode: "91104",
          state: "CA ",
          premise: "OFF ",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.9789327, 33.9317303],
        },
        properties: {
          name: "Big 6 Liquor",
          phoneFormatted: "(562) 943-2012",
          phone: "5629432012",
          address: "16519 Leffingwell Rd",
          city: "Whittier",
          country: "United States",
          postalCode: "90603",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 0,
          anejo: 0,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.933145, 33.935235],
        },
        properties: {
          name: "Harbor Mart Liquor",
          phoneFormatted: "(562)691-5030",
          phone: "5626915030",
          address: "320 N. Harbor Blvd",
          city: "La Habra",
          country: "United States",
          postalCode: "90631",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.9329328, 33.9161354],
        },
        properties: {
          name: "Sunny Hills Market",
          phoneFormatted: "(714) 525-0866",
          phone: "7145250866",
          address: "1510 S. Harbor Blvd",
          city: "La Habra",
          country: "United States",
          postalCode: "90631",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 0,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.588134, 33.9146608],
        },
        properties: {
          name: "J&M Market",
          phoneFormatted: "(951)734-6151",
          phone: "9517346151",
          address: "440 River Rd Ste M",
          city: "Corona",
          country: "United States",
          postalCode: "92880",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.8434804, 33.6815917],
        },
        properties: {
          name: "Irvine Market",
          phoneFormatted: "(949) 250-0640",
          phone: "9492500640",
          address: "2540 Main St",
          city: "Irvine",
          country: "United States",
          postalCode: "92614",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.524023, 33.837112],
        },
        properties: {
          name: "El Cerrito Liquor",
          phoneFormatted: "(951) 272-1646",
          phone: "9512721646",
          address: "19480 E Ontario Ave, Unit C",
          city: "Corona",
          country: "United States",
          postalCode: "92881",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 0,
          anejo: 0,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.842698, 34.031072],
        },
        properties: {
          name: "Vintage Grocers",
          phoneFormatted: "(310)457-2828",
          phone: "3104572828",
          address: "30745 E Pacific Coast Hwy #24",
          city: "Malibu",
          country: "United States",
          postalCode: "90265",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.842907, 34.031548],
        },
        properties: {
          name: "Kristy's Malibu",
          phoneFormatted: "(310)457-1018",
          phone: "3104571018",
          address: "30745 E Pacific Coast Hwy 1-B",
          city: "Malibu",
          country: "United States",
          postalCode: "90265",
          state: "CA",
          premise: "ON",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.457709, 33.982687],
        },
        properties: {
          name: "Jamaica Bay Inn",
          phoneFormatted: "(310)823-5333",
          phone: "3108235333",
          address: "4175 Admiralty Way",
          city: "Marina Del Ray",
          country: "United States",
          postalCode: "90292",
          state: "CA",
          premise: "ON",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.65542, 33.465049],
        },
        properties: {
          name: "San 'O Mart",
          phoneFormatted: "(949) 492-3717",
          phone: "9494923717",
          address: "3119 South Camino Real",
          city: "San Clemente",
          country: "United States",
          postalCode: "92672",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.97773, 33.851785],
        },
        properties: {
          name: "Northdale Market Warehouse",
          phoneFormatted: "",
          phone: "",
          address: "1201 N Magnolia Ave",
          city: "Anaheim",
          country: "United States",
          postalCode: "92805",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.40408, 34.1723],
        },
        properties: {
          name: "Elat Glatt Mart",
          phoneFormatted: "",
          phone: "",
          address: "12431 Burbank Bl",
          city: "North Hollywood",
          country: "United States",
          postalCode: "91607",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.50245, 34.20828],
        },
        properties: {
          name: "Wine and Liquor Depot",
          phoneFormatted: "",
          phone: "",
          address: "16938 Saticoy St",
          city: "Van Nuys",
          country: "United States",
          postalCode: "91406",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.55532, 34.27346],
        },
        properties: {
          name: "Pals Liquor and Wine Shop",
          phoneFormatted: "",
          phone: "",
          address: "19344 Rinaldi St",
          city: "Northridge",
          country: "United States",
          postalCode: "91326",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.91974, 33.63957],
        },
        properties: {
          name: "El Matador",
          phoneFormatted: "",
          phone: "",
          address: "1768 Newport Blvd",
          city: "Costa Mesa",
          country: "United States",
          postalCode: "92627",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.9106, 33.82353],
        },
        properties: {
          name: "Anaheim White House Restaurant",
          phoneFormatted: "",
          phone: "",
          address: "887 S Anaheim Blvd",
          city: "Anaheim",
          country: "United States",
          postalCode: "92805",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.361249, 34.165218],
        },
        properties: {
          name: "Bamford Liquor",
          phoneFormatted: "",
          phone: "",
          address: "10575 Magnolia Blvd",
          city: "North Hollywood",
          country: "United States",
          postalCode: "91601",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [ -121.30152, 38.15368],
        },
        properties: {
          name: "Woodbridge Market & Liquor",
          phoneFormatted: "",
          phone: "",
          address: "1060 E Augusta St",
          city: "Woodbridge",
          country: "United States",
          postalCode: "95258",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.438517, 34.299707],
        },
        properties: {
          name: "The Bottle Shoppe",
          phoneFormatted: "",
          phone: "",
          address: "14040 Hubbard St",
          city: "Sylmar",
          country: "United States",
          postalCode: "91342",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.396835, 34.208185],
        },
        properties: {
          name: "Circus Liquor & Market",
          phoneFormatted: "",
          phone: "",
          address: "7561 Laurel Canyon Blvd",
          city: "North Hollywood",
          country: "United States",
          postalCode: "91605",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.38293, 34.17206],
        },
        properties: {
          name: "Phil's Liquor",
          phoneFormatted: "",
          phone: "",
          address: "11510 Burbank Blvd",
          city: "North Hollywood",
          country: "United States",
          postalCode: "91601",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.406075, 34.193615],
        },
        properties: {
          name: "Carmel Liquor",
          phoneFormatted: "",
          phone: "",
          address: "12516 Vanowen St",
          city: "North Hollywood",
          country: "United States",
          postalCode: "91605",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.405575, 34.17912],
        },
        properties: {
          name: "Dale's Junior Liquor Store",
          phoneFormatted: "",
          phone: "",
          address: "12500 Oxnard St.",
          city: "North Hollywood",
          country: "United States",
          postalCode: "91606",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.208383, 33.89755],
        },
        properties: {
          name: "DnD Liquor",
          phoneFormatted: "",
          phone: "",
          address: "217 N Long Beach Blvd",
          city: "Compton",
          country: "United States",
          postalCode: "90221",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.387425, 34.20146],
        },
        properties: {
          name: "Danny's Liquor",
          phoneFormatted: "",
          phone: "",
          address: "7202 Lankershim Blvd",
          city: "North Hollywood",
          country: "United States",
          postalCode: "91605",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.40585, 34.18684],
        },
        properties: {
          name: "Joe's Liquor",
          phoneFormatted: "",
          phone: "",
          address: "12519 Victory Blvd",
          city: "North Hollywood",
          country: "United States",
          postalCode: "91606",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.51965, 33.993],
        },
        properties: {
          name: "Mira Loma",
          phoneFormatted: "",
          phone: "",
          address: "10789 Jurupa Rd",
          city: "Jurupa Valley",
          country: "United States",
          postalCode: "91752",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.335253, 34.171682],
        },
        properties: {
          name: "Handi Market",
          phoneFormatted: "",
          phone: "",
          address: "2514 W Magnolia Blvd",
          city: "Burbank",
          country: "United States",
          postalCode: "91505",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.67291, 34.03944],
        },
        properties: {
          name: "V's Restaurant",
          phoneFormatted: "",
          phone: "",
          address: "22821 Pacific Coast Hwy",
          city: "Malibu",
          country: "United States",
          postalCode: "90265",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.928835, 33.608713],
        },
        properties: {
          name: "Blue Beet",
          phoneFormatted: "",
          phone: "",
          address: "107 21st Pl",
          city: "Newport Beach",
          country: "United States",
          postalCode: "92663",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.63063, 33.565345],
        },
        properties: {
          name: "Mama's Comfort Food & Cocktails",
          phoneFormatted: "",
          phone: "",
          address: "25606 Crown Valley Pkwy #K2",
          city: "Ladera Ranch",
          country: "United States",
          postalCode: "92694",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.07152, 33.80119],
        },
        properties: {
          name: "Mama's Comfort Food & Cocktails",
          phoneFormatted: "",
          phone: "",
          address: "11122 Los Alamitos Blvd",
          city: "Los Alamitos",
          country: "United States",
          postalCode: "90720",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.477088, 33.996331],
        },
        properties: {
          name: "The Rose Venice",
          phoneFormatted: "",
          phone: "",
          address: "220 Rose Ave",
          city: "Venice",
          country: "United States",
          postalCode: "90291",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.466319, 33.979191],
        },
        properties: {
          name: "Mercedes Grill",
          phoneFormatted: "",
          phone: "",
          address: "14 Washington Blvd",
          city: "Marina Del Rey",
          country: "United States",
          postalCode: "90292",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.987118, 33.657352],
        },
        properties: {
          name: "Mama's on 39",
          phoneFormatted: "",
          phone: "",
          address: "21022 Beach Blvd.",
          city: "Huntington Beach",
          country: "United States",
          postalCode: "92648",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.11436, 33.76149],
        },
        properties: {
          name: "A PCH",
          phoneFormatted: "",
          phone: "",
          address: "6460 E Pacific Coast Hwy. #200",
          city: "Long Beach",
          country: "United States",
          postalCode: "90803",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.065409, 33.713252],
        },
        properties: {
          name: "J. King Neptunes",
          phoneFormatted: "",
          phone: "",
          address: "17115 Pacific Coast Hwy",
          city: "Sunset Beach",
          country: "United States",
          postalCode: "90742",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.91422650000001, 33.61560299999999],
        },
        properties: {
          name: "Balboa Bay Resort",
          phoneFormatted: "",
          phone: "",
          address: "1221 W Coast Hwy",
          city: "Newport Beach",
          country: "United States",
          postalCode: "92663",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-122.113817, 37.400383],
        },
        properties: {
          name: "Armadillo Willy's BBQ",
          phoneFormatted: "",
          phone: "",
          address: "1031 N San Antonio Rd",
          city: "Los Altos",
          country: "United States",
          postalCode: "94022",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.3418345, 34.1045515],
        },
        properties: {
          name: "The Magic Castle",
          phoneFormatted: "",
          phone: "",
          address: "7001 Franklin Ave",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90028",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.930022, 33.60985],
        },
        properties: {
          name: "Fly 'N' Fish Oyster Bar & Grill",
          phoneFormatted: "",
          phone: "",
          address: "2304 W Ocean Front",
          city: "Newport Beach",
          country: "United States",
          postalCode: "92663",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.00134, 33.658755],
        },
        properties: {
          name: "Cruisers Pizza Bar Grill",
          phoneFormatted: "",
          phone: "",
          address: "210 5th Street",
          city: "Huntington Beach",
          country: "United States",
          postalCode: "92648",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.8993, 33.60179],
        },
        properties: {
          name: "Cruisers Pizza Bar Grill",
          phoneFormatted: "",
          phone: "",
          address: "801 E Balboa Blvd",
          city: "Newport Beach",
          country: "United States",
          postalCode: "92661",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.25663, 34.041763],
        },
        properties: {
          name: "Ace Hotel Downtown",
          phoneFormatted: "",
          phone: "",
          address: "921-933 S Broadway",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90015",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.25718, 34.051244],
        },
        properties: {
          name: "Drago Centro",
          phoneFormatted: "",
          phone: "",
          address: "525 S Flower St #120",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90071",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.406741, 34.015867],
        },
        properties: {
          name: "Blind Barber",
          phoneFormatted: "",
          phone: "",
          address: "10797 Washington Blvd",
          city: "Culver City",
          country: "United States",
          postalCode: "90232",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.384145, 34.0844],
        },
        properties: {
          name: "Rocco's WeHo",
          phoneFormatted: "",
          phone: "",
          address: "8900 Santa Monica Blvd",
          city: "West Hollywood",
          country: "United States",
          postalCode: "90069",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-122.243095, 37.49822],
        },
        properties: {
          name: "K&L Wine Warehouse",
          phoneFormatted: "",
          phone: "",
          address: "920 Bing St",
          city: "San Carlos",
          country: "United States",
          postalCode: "94070",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.8342, 33.5706],
        },
        properties: {
          name: "Javier's Restaurant",
          phoneFormatted: "",
          phone: "",
          address: "7832 Pacific Coast Hwy",
          city: "Newport Beach",
          country: "United States",
          postalCode: "92657",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.4095, 33.88302],
        },
        properties: {
          name: "900 Manhattan Ave",
          phoneFormatted: "",
          phone: "",
          address: "900 Manhattan Ave",
          city: "Manhattan Beach",
          country: "United States",
          postalCode: "90266",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.38656, 33.819435],
        },
        properties: {
          name: "The Rex Steakhouse",
          phoneFormatted: "",
          phone: "",
          address: "221 Avenue I",
          city: "Redondo Beach",
          country: "United States",
          postalCode: "90277",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.44603, 34.01574],
        },
        properties: {
          name: "The Cloverfield",
          phoneFormatted: "",
          phone: "",
          address: "3300 Airport Ave",
          city: "Santa Monica",
          country: "United States",
          postalCode: "90405",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.909779, 33.605499],
        },
        properties: {
          name: "Newport Harbor Yacht Club",
          phoneFormatted: "",
          phone: "",
          address: "720 W Bay Ave",
          city: "Newport Beach",
          country: "United States",
          postalCode: "92661",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.91407, 33.63253],
        },
        properties: {
          name: "The Country Club",
          phoneFormatted: "",
          phone: "",
          address: "330 E 17th St",
          city: "Costa Mesa",
          country: "United States",
          postalCode: "92627",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.917715, 33.63286],
        },
        properties: {
          name: "Hi-Time Wine Cellars",
          phoneFormatted: "",
          phone: "",
          address: "250 Ogle St #F",
          city: "Costa Mesa",
          country: "United States",
          postalCode: "92627",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.74616, 33.65154],
        },
        properties: {
          name: "Javier's Restaurant - Irvine",
          phoneFormatted: "",
          phone: "",
          address: "536 Spectrum Center Dr",
          city: "Irvine",
          country: "United States",
          postalCode: "92618",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.355517, 34.032725],
        },
        properties: {
          name: "The Gathering Spot LA",
          phoneFormatted: "",
          phone: "",
          address: "5211 West Adams Blvd",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90016",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.192304, 32.749668],
        },
        properties: {
          name: "El Agave Tequileria",
          phoneFormatted: "",
          phone: "",
          address: "2304 San Diego Ave",
          city: "San Diego",
          country: "United States",
          postalCode: "92110",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.8796, 33.61632],
        },
        properties: {
          name: "VEA Newport Beach",
          phoneFormatted: "",
          phone: "",
          address: "900 Newport Center Drive",
          city: "Newport Beach",
          country: "United States",
          postalCode: "92660",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.38739, 34.02835],
        },
        properties: {
          name: "The Shay",
          phoneFormatted: "",
          phone: "",
          address: "8801 Washington Blvd",
          city: "Culver City",
          country: "United States",
          postalCode: "90232",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.842907, 34.031548],
        },
        properties: {
          name: "Kristy's Village Cafe",
          phoneFormatted: "",
          phone: "",
          address: "30745 Pacific Coast Hwy",
          city: "Malibu",
          country: "United States",
          postalCode: "90265",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.929797, 33.614492],
        },
        properties: {
          name: "Helmsman Ale House",
          phoneFormatted: "",
          phone: "",
          address: "2920 Newport Blvd",
          city: "Newport Beach",
          country: "United States",
          postalCode: "92663",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.14871, 33.99607],
        },
        properties: {
          name: "CCM Market",
          phoneFormatted: "",
          phone: "",
          address: "6046 E Washington Blvd",
          city: "Commerce",
          country: "United States",
          postalCode: "90040",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.28773050000001, 34.014273],
        },
        properties: {
          name: "LA Memorial Coliseum",
          phoneFormatted: "",
          phone: "",
          address: "3911 S Figueroa St",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90037",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.04224, 33.72393],
        },
        properties: {
          name: "Harbor Market",
          phoneFormatted: "",
          phone: "",
          address: "16369 Bolsa Chica",
          city: "Huntington Beach",
          country: "United States",
          postalCode: "92649",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.448487, 33.959419],
        },
        properties: {
          name: "Mo's Place",
          phoneFormatted: "",
          phone: "",
          address: "203 Culver Bl",
          city: "Playa Del Ray",
          country: "United States",
          postalCode: "90293",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.8737, 33.61653],
        },
        properties: {
          name: "Whole Foods Mkt 10468 NPT",
          phoneFormatted: "",
          phone: "",
          address: "415 Newport Center Dr",
          city: "Newport Beach",
          country: "United States",
          postalCode: "92660",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.47215, 33.987665],
        },
        properties: {
          name: "Gran Blanco",
          phoneFormatted: "",
          phone: "",
          address: "1607 Pacific Ave",
          city: "Venice",
          country: "United States",
          postalCode: "90291",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.90056, 33.603031],
        },
        properties: {
          name: "Class of 47",
          phoneFormatted: "",
          phone: "",
          address: "209 Palm St",
          city: "Balboa",
          country: "United States",
          postalCode: "92661",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.212736, 32.87261],
        },
        properties: {
          name: "Javier's La Jolla",
          phoneFormatted: "",
          phone: "",
          address: "4301 La Jolla Village Dr",
          city: "San Diego",
          country: "United States",
          postalCode: "92122",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-121.855327, 39.751262],
        },
        properties: {
          name: "Italian Cottage Espla",
          phoneFormatted: "",
          phone: "",
          address: "2234 Esplanade",
          city: "Chico",
          country: "United States",
          postalCode: "95926",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.376576, 34.084986],
        },
        properties: {
          name: "The Belmont",
          phoneFormatted: "",
          phone: "",
          address: "747 N La Cienega",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90069",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.418261, 33.901815],
        },
        properties: {
          name: "Fish Bar",
          phoneFormatted: "",
          phone: "",
          address: "3801 Highland Ave",
          city: "Manhattan Beach",
          country: "United States",
          postalCode: "90266",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.41651, 33.9761],
        },
        properties: {
          name: "Neighbors Restaurant",
          phoneFormatted: "",
          phone: "",
          address: "12751 W Millenium Dr. STE 140",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90094",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.855189, 33.676153],
        },
        properties: {
          name: "Center Hub Bar",
          phoneFormatted: "",
          phone: "",
          address: "2222 Michelson Dr. #216 & 220",
          city: "Irvine",
          country: "United States",
          postalCode: "92612",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.42031, 34.059167],
        },
        properties: {
          name: "Toscanova",
          phoneFormatted: "",
          phone: "",
          address: "10250 Santa Monica Bl #192",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90067",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.899587, 33.60137],
        },
        properties: {
          name: "Cabo Cantina",
          phoneFormatted: "",
          phone: "1",
          address: "100 S Main St",
          city: "Balboa",
          country: "United States",
          postalCode: "92661",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.3701775, 34.083535999999995],
        },
        properties: {
          name: "Crossroads Kitchen",
          phoneFormatted: "",
          phone: "",
          address: "8282-86 Melrose Ave",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90046",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.342342, 34.152299],
        },
        properties: {
          name: "Don Cuco's Mexican Restaurant",
          phoneFormatted: "",
          phone: "",
          address: "3911 Riverside Dr",
          city: "Burbank",
          country: "United States",
          postalCode: "91505",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.176646, 32.986807],
        },
        properties: {
          name: "The Farms Golf Club",
          phoneFormatted: "",
          phone: "",
          address: "8500 St. Andrews RD",
          city: "Rancho Santa Fe",
          country: "United States",
          postalCode: "92067",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.373147, 34.095381],
        },
        properties: {
          name: "Andaz West Hollywood",
          phoneFormatted: "",
          phone: "",
          address: "8401 Sunset Bl",
          city: "West Hollywood",
          country: "United States",
          postalCode: "90069",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.23512, 33.20997],
        },
        properties: {
          name: "Beverage House Liquor #3",
          phoneFormatted: "",
          phone: "",
          address: "810 E Vista Way",
          city: "Vista",
          country: "United States",
          postalCode: "92084",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.47917, 33.9972],
        },
        properties: {
          name: "Forma",
          phoneFormatted: "",
          phone: "",
          address: "110 Navy St. #1",
          city: "Venice",
          country: "United States",
          postalCode: "90291",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.138297, 33.792255],
        },
        properties: {
          name: "Tap 24 Bar and Grill",
          phoneFormatted: "",
          phone: "",
          address: "4750 Los Coyotes DI",
          city: "Long Beach",
          country: "United States",
          postalCode: "90815",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-119.725314, 34.438327],
        },
        properties: {
          name: "Lemon Tree Inn",
          phoneFormatted: "",
          phone: "",
          address: "2819 State St",
          city: "Santa Barbara",
          country: "United States",
          postalCode: "93105",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.16048, 32.71197],
        },
        properties: {
          name: "Greystone",
          phoneFormatted: "",
          phone: "",
          address: "658 5th Ave",
          city: "San Diego",
          country: "United States",
          postalCode: "92101",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.15015, 34.1455],
        },
        properties: {
          name: "35 ER",
          phoneFormatted: "",
          phone: "",
          address: "12 E Colorado Bl",
          city: "Pasadena",
          country: "United States",
          postalCode: "91105",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.25263, 33.375626],
        },
        properties: {
          name: "Major Market",
          phoneFormatted: "",
          phone: "",
          address: "845 S Main St.",
          city: "Fallbrook",
          country: "United States",
          postalCode: "92028",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.88982, 33.691885],
        },
        properties: {
          name: "Blossom's & Brass",
          phoneFormatted: "",
          phone: "",
          address: "3333 Bristol St. BLMG STE B",
          city: "Costa Mesa",
          country: "United States",
          postalCode: "92626",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.35649, 34.07322],
        },
        properties: {
          name: "Blue Ribbon Sushi Bar & Grill",
          phoneFormatted: "",
          phone: "",
          address: "189 The Grove Dr. #O 10",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90036",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.292425, 34.08346],
        },
        properties: {
          name: "Bestie Hollywood",
          phoneFormatted: "",
          phone: "",
          address: "4216 Melrose Ave",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90029",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.267225, 33.071503],
        },
        properties: {
          name: "Casa De Bandini",
          phoneFormatted: "",
          phone: "",
          address: "1901 Calle Barcelona",
          city: "Carlsbad",
          country: "United States",
          postalCode: "92009",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.185309, 33.769365],
        },
        properties: {
          name: "Padre",
          phoneFormatted: "",
          phone: "",
          address: "525 E Broadway",
          city: "Long Beach",
          country: "United States",
          postalCode: "90802",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.326545, 33.34259],
        },
        properties: {
          name: "Avalon Plaza Cafe",
          phoneFormatted: "",
          phone: "",
          address: "128 D Summer Ave",
          city: "Avalon",
          country: "United States",
          postalCode: "90704",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.254097, 34.14448],
        },
        properties: {
          name: "The Oak and Vine",
          phoneFormatted: "",
          phone: "",
          address: "117 E Harvard St",
          city: "Glendale",
          country: "United States",
          postalCode: "91205",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.04161, 34.06282],
        },
        properties: {
          name: "Sunseris",
          phoneFormatted: "",
          phone: "",
          address: "10617 E Garvey Ave",
          city: "El Monte",
          country: "United States",
          postalCode: "91733",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.45753, 33.97481],
        },
        properties: {
          name: "Hotel MDR",
          phoneFormatted: "",
          phone: "",
          address: "4360 Via Marina",
          city: "Marina Del Rey",
          country: "United States",
          postalCode: "90292",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.25142, 34.052019],
        },
        properties: {
          name: "Omni Hotel",
          phoneFormatted: "",
          phone: "",
          address: "251 S Olive St",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90012",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.257889, 34.049563],
        },
        properties: {
          name: "Takami Sushi and Robata",
          phoneFormatted: "",
          phone: "",
          address: "811 Wilshire Blvd. #2100",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90017",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-116.30019, 33.76297],
        },
        properties: {
          name: "Legend's & Icons Pub & Grill",
          phoneFormatted: "",
          phone: "",
          address: "78152 Vaner Rd STE A&B",
          city: "Palm Desert",
          country: "United States",
          postalCode: "92211",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.425003, 34.146999],
        },
        properties: {
          name: "Tony's Liquor Store",
          phoneFormatted: "",
          phone: "",
          address: "13368 Ventura Blvd",
          city: "Sherman Oaks",
          country: "United States",
          postalCode: "91423",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.512672, 34.370174],
        },
        properties: {
          name: "Town and Country Liquor",
          phoneFormatted: "",
          phone: "",
          address: "23638 San Fernando RD #1-3",
          city: "Santa Clara",
          country: "United States",
          postalCode: "91321",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-116.296485, 33.71707],
        },
        properties: {
          name: "El Patio La Quinta",
          phoneFormatted: "",
          phone: "",
          address: "78370 Hwy 111 STE 150",
          city: "La Quinta",
          country: "United States",
          postalCode: "92253",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.50359, 34.257318],
        },
        properties: {
          name: "Less 4 Cocktails",
          phoneFormatted: "",
          phone: "",
          address: "17040 Devonshire St",
          city: "Northridge",
          country: "United States",
          postalCode: "91325",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.925925, 33.87005],
        },
        properties: {
          name: "Garcia's South of the Border",
          phoneFormatted: "",
          phone: "",
          address: "136 W Commonwealth Ave",
          city: "Fullerton",
          country: "United States",
          postalCode: "92832",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.417495, 33.918595],
        },
        properties: {
          name: "Porterhouse Bourbon & Bones",
          phoneFormatted: "",
          phone: "",
          address: "223 Richmond St",
          city: "El Segundo",
          country: "United States",
          postalCode: "90245",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.189175, 33.820279],
        },
        properties: {
          name: "Phil Trani's",
          phoneFormatted: "",
          phone: "",
          address: "3490 Long Beach Blvd",
          city: "Long Beach",
          country: "United States",
          postalCode: "90807",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-119.705642, 34.423555],
        },
        properties: {
          name: "Soho Restaurant",
          phoneFormatted: "",
          phone: "",
          address: "1221 State St #205",
          city: "Santa Barbara",
          country: "United States",
          postalCode: "93101",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.38776, 34.09079],
        },
        properties: {
          name: "Rainbow Bar and Grill",
          phoneFormatted: "",
          phone: "",
          address: "9015 W Sunset Blvd",
          city: "West Hollywood",
          country: "United States",
          postalCode: "90069",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-116.54461, 33.82112],
        },
        properties: {
          name: "Dick's on Arenas",
          phoneFormatted: "",
          phone: "",
          address: "301 E Arenas Rd",
          city: "Palm Springs",
          country: "United States",
          postalCode: "92262",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-116.894148, 32.743808],
        },
        properties: {
          name: "Steele canyon Golf Course",
          phoneFormatted: "",
          phone: "",
          address: "3199 Stonefield Dr",
          city: "Jamul",
          country: "United States",
          postalCode: "91935",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.582946, 33.595818],
        },
        properties: {
          name: "Coto De Caza Golf-RQT",
          phoneFormatted: "",
          phone: "",
          address: "25291 Vista Del Verde",
          city: "Coto De Caza",
          country: "United States",
          postalCode: "92679",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.329372, 34.10092],
        },
        properties: {
          name: "Elbow Room",
          phoneFormatted: "",
          phone: "",
          address: "1634 N Cahuenga Blvd.",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90028",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.35245, 34.07596],
        },
        properties: {
          name: "Escuela Taqueria",
          phoneFormatted: "",
          phone: "",
          address: "7450 Beverly Blvd.",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90036",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.422693, 34.146835],
        },
        properties: {
          name: "Casa Vega",
          phoneFormatted: "",
          phone: "",
          address: "13301 Ventura Blvd.",
          city: "Sherman Oaks",
          country: "United States",
          postalCode: "91423",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.447049, 34.031006],
        },
        properties: {
          name: "Don Antonio",
          phoneFormatted: "",
          phone: "",
          address: "11755-57 W Pico Blvd.",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90064",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.394377, 37.361273],
        },
        properties: {
          name: "Taqueria Las Palmas",
          phoneFormatted: "",
          phone: "",
          address: "136 Line St. #B&C",
          city: "Bishop",
          country: "United States",
          postalCode: "93514",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.215474, 34.139114],
        },
        properties: {
          name: "La Fuente Bar & Grill",
          phoneFormatted: "",
          phone: "",
          address: "2256 W Colorado BL #104 & 105",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90041",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.073226, 34.128215],
        },
        properties: {
          name: "Clearman's Galley",
          phoneFormatted: "",
          phone: "",
          address: "7215 Rosemead Bl",
          city: "San Gabriel",
          country: "United States",
          postalCode: "91775",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.130585, 32.748615],
        },
        properties: {
          name: "Shank & Bone",
          phoneFormatted: "",
          phone: "",
          address: "2930 University Ave",
          city: "san Diego",
          country: "United States",
          postalCode: "92104",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.729115, 33.611957],
        },
        properties: {
          name: "The Village Greens",
          phoneFormatted: "",
          phone: "",
          address: "24122 Moulton PKWY",
          city: "Laguna Woods",
          country: "United States",
          postalCode: "92653",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.682972, 35.651418],
        },
        properties: {
          name: "American Legion Post 684",
          phoneFormatted: "",
          phone: "",
          address: "641 Inyokern RD",
          city: "Ridgecrest",
          country: "United States",
          postalCode: "93555",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.942725, 33.866315],
        },
        properties: {
          name: "Cielo Karaoke Y Mas",
          phoneFormatted: "",
          phone: "",
          address: "1050 W Valencia Dr",
          city: "Fullerton",
          country: "United States",
          postalCode: "92833",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.387218, 34.02724],
        },
        properties: {
          name: "Margot.LA",
          phoneFormatted: "",
          phone: "",
          address: "8820 Washington Blvd STE 301",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90232",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.403745, 34.069495],
        },
        properties: {
          name: "The Hideaway",
          phoneFormatted: "",
          phone: "",
          address: "421 N Rodeo Dr. STE G18",
          city: "Beverly Hills",
          country: "United States",
          postalCode: "90210",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-116.76467, 32.83577],
        },
        properties: {
          name: "Alpine Liquor & Deli",
          phoneFormatted: "",
          phone: "",
          address: "2262 Alpine BL",
          city: "Alpine",
          country: "United States",
          postalCode: "91901",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.289698, 33.736206],
        },
        properties: {
          name: "J Trani's Ristorante",
          phoneFormatted: "",
          phone: "",
          address: "584 W 9th ST",
          city: "San Pedro",
          country: "United States",
          postalCode: "91901",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.091842, 34.150205],
        },
        properties: {
          name: "Foothill",
          phoneFormatted: "",
          phone: "",
          address: "2835 E Foothill Bl",
          city: "Pasadena",
          country: "United States",
          postalCode: "91107",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.15675, 33.03319],
        },
        properties: {
          name: "The Crosby Club",
          phoneFormatted: "",
          phone: "",
          address: "17102 Bing Crosby Bl",
          city: "Rancho Santa Fe",
          country: "United States",
          postalCode: "92127",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.435194, 34.228195],
        },
        properties: {
          name: "Dale's Liquor",
          phoneFormatted: "",
          phone: "",
          address: "8717 Woodman Ave",
          city: "Arleta",
          country: "United States",
          postalCode: "91331",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.30927, 34.181812],
        },
        properties: {
          name: "Don Cuco Restaurant",
          phoneFormatted: "",
          phone: "",
          address: "218 E Orange Ave",
          city: "Burbank",
          country: "United States",
          postalCode: "91502",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.149542, 34.145675],
        },
        properties: {
          name: "Bar Celona",
          phoneFormatted: "",
          phone: "",
          address: "46 E Colorado Blvd.",
          city: "Pasadena",
          country: "United States",
          postalCode: "91105",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.038965, 33.83142],
        },
        properties: {
          name: "Discount Liquor",
          phoneFormatted: "",
          phone: "",
          address: "5362 Lincoln Ave",
          city: "Cypress",
          country: "United States",
          postalCode: "90630",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-119.227545, 38.25617],
        },
        properties: {
          name: "Rhino's Bar and Grill",
          phoneFormatted: "",
          phone: "",
          address: "Main & Sinclair STS Hwy 395",
          city: "Bridgeport",
          country: "United States",
          postalCode: "93517",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.28726, 34.1073],
        },
        properties: {
          name: "Nossa Caipirinha Bar",
          phoneFormatted: "",
          phone: "",
          address: "1964-66-68 N Hillhurst Ave",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90027",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.13049, 32.70836],
        },
        properties: {
          name: "Al's Food Market",
          phoneFormatted: "",
          phone: "",
          address: "2955 K Street",
          city: "San Diego",
          country: "United States",
          postalCode: "92102",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.783211, 33.541656],
        },
        properties: {
          name: "C'est La Vie",
          phoneFormatted: "",
          phone: "",
          address: "373 S Coast Hwy",
          city: "Laguna Beach",
          country: "United States",
          postalCode: "92651",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.241644, 34.212823],
        },
        properties: {
          name: "El Sol Mexican Restaurant",
          phoneFormatted: "",
          phone: "",
          address: "2901 1/2 Honolulu Ave",
          city: "La Crescenta",
          country: "United States",
          postalCode: "91214",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.395745, 37.36229],
        },
        properties: {
          name: "Bishop Market",
          phoneFormatted: "",
          phone: "",
          address: "211 Main St",
          city: "Bishop",
          country: "United States",
          postalCode: "93514",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.327038, 34.094133],
        },
        properties: {
          name: "El Floridita",
          phoneFormatted: "",
          phone: "",
          address: "1253 Wine St #3-4",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90038",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-116.35587, 33.77994],
        },
        properties: {
          name: "Pueblo Viejo Grill",
          phoneFormatted: "",
          phone: "",
          address: "36901 Cook St #3 & 4",
          city: "Palm Desert",
          country: "United States",
          postalCode: "92211",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.281082, 33.188145],
        },
        properties: {
          name: "Stagecoach Inn",
          phoneFormatted: "",
          phone: "",
          address: "1865 W Vista Way",
          city: "Vista",
          country: "United States",
          postalCode: "92083",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.335023, 34.101108],
        },
        properties: {
          name: "Boardners",
          phoneFormatted: "",
          phone: "",
          address: "1652 N Cherokee Ave",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90028",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.271227, 33.2167],
        },
        properties: {
          name: "1 Stop Convenience",
          phoneFormatted: "",
          phone: "",
          address: "4770 Oceanside Ave",
          city: "Oceanside",
          country: "United States",
          postalCode: "92056",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.227118, 34.205395],
        },
        properties: {
          name: "Basin 141",
          phoneFormatted: "",
          phone: "",
          address: "2265 Honolulu Ave",
          city: "Montrose",
          country: "United States",
          postalCode: "92056",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.1499, 34.145855],
        },
        properties: {
          name: "The Lounge at Mi Piace",
          phoneFormatted: "",
          phone: "",
          address: "25 E Colorado Blvd.",
          city: "Pasadena",
          country: "United States",
          postalCode: "91105",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.85223, 33.8025],
        },
        properties: {
          name: "Pancho's Mexican Restaurant",
          phoneFormatted: "",
          phone: "",
          address: "135 E Collins Blvd",
          city: "Orange",
          country: "United States",
          postalCode: "92867",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-119.771943, 34.440073],
        },
        properties: {
          name: "Creek Side Inn",
          phoneFormatted: "",
          phone: "",
          address: "4444 Hollister Ave",
          city: "Santa Barbara",
          country: "United States",
          postalCode: "93110",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.39457, 37.35995],
        },
        properties: {
          name: "Eastern Sierra",
          phoneFormatted: "",
          phone: "",
          address: "250 S Main St",
          city: "Bishop",
          country: "United States",
          postalCode: "93514",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.00075, 34.14795],
        },
        properties: {
          name: "Basin 141 Monrovia",
          phoneFormatted: "",
          phone: "",
          address: "402-404 S Myrtle Ave",
          city: "Monrovia",
          country: "United States",
          postalCode: "91016",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.22449, 34.20464],
        },
        properties: {
          name: "New Moon in Montose",
          phoneFormatted: "",
          phone: "",
          address: "2138 Verdugo Blvd",
          city: "Montrose",
          country: "United States",
          postalCode: "91016",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.101548, 34.146261],
        },
        properties: {
          name: "Plate 38",
          phoneFormatted: "",
          phone: "",
          address: "2361 E Colorado Blvd",
          city: "Pasadena",
          country: "United States",
          postalCode: "91107",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.080877, 32.640695],
        },
        properties: {
          name: "Farmer's Table",
          phoneFormatted: "",
          phone: "",
          address: "330 F ST",
          city: "Chula Vista",
          country: "United States",
          postalCode: "91910",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.274317, 32.841003],
        },
        properties: {
          name: "Bernine's Bistro",
          phoneFormatted: "",
          phone: "",
          address: "7550 Fay Ave #A-B",
          city: "La Jolla",
          country: "United States",
          postalCode: "920`37",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.22981, 34.206283],
        },
        properties: {
          name: "Joselito's Mexican Food",
          phoneFormatted: "",
          phone: "",
          address: "2345 Honolulu Ave",
          city: "Montrose",
          country: "United States",
          postalCode: "91020",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.17003, 32.69905],
        },
        properties: {
          name: "Costa Azul Coronado",
          phoneFormatted: "",
          phone: "",
          address: "1201 1st St #115",
          city: "Coronado",
          country: "United States",
          postalCode: "92118",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.253452, 34.146556],
        },
        properties: {
          name: "Raffi's Place",
          phoneFormatted: "",
          phone: "",
          address: "211 E Broadway #E",
          city: "Glendale",
          country: "United States",
          postalCode: "91205",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.16035, 33.84624],
        },
        properties: {
          name: "Zanzabuku Sports Lounge",
          phoneFormatted: "",
          phone: "",
          address: "4825 N Paramount Bl",
          city: "Lakewood",
          country: "United States",
          postalCode: "90712",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.383289, 34.085715],
        },
        properties: {
          name: "Trunks",
          phoneFormatted: "",
          phone: "",
          address: "8809 W Santa Monica",
          city: "West Hollywood",
          country: "United States",
          postalCode: "90069",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.265065, 32.958217],
        },
        properties: {
          name: "En Fuego Restaurant",
          phoneFormatted: "",
          phone: "",
          address: "1340 Camino Del Mar",
          city: "Del Mar",
          country: "United States",
          postalCode: "92014",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.22563, 33.97521],
        },
        properties: {
          name: "El Chamizal Restaurant",
          phoneFormatted: "",
          phone: "",
          address: "7111 Pacific Bl",
          city: "Huntington Park",
          country: "United States",
          postalCode: "90255",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.1951, 34.20179],
        },
        properties: {
          name: "Dish",
          phoneFormatted: "",
          phone: "",
          address: "734 Foothill Bl",
          city: "La Canada Flintridge",
          country: "United States",
          postalCode: "91011",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.754959, 34.144446],
        },
        properties: {
          name: "Plata Cantina",
          phoneFormatted: "",
          phone: "",
          address: "28914 Roadside Dr. Ste 110",
          city: "Agoura Hills",
          country: "United States",
          postalCode: "91301",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.16922, 32.74962],
        },
        properties: {
          name: "Hills Wine and Spirits",
          phoneFormatted: "",
          phone: "",
          address: "3981 Eagle St",
          city: "San Diego",
          country: "United States",
          postalCode: "92103",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.447215, 34.24872],
        },
        properties: {
          name: "A&F Liquor",
          phoneFormatted: "",
          phone: "",
          address: "14419 VAN NUYS BL",
          city: "Pacoima",
          country: "United States",
          postalCode: "92103",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.67165, 33.54501],
        },
        properties: {
          name: "Shooters",
          phoneFormatted: "",
          phone: "",
          address: "28752 Marguerite Pkwy",
          city: "Mission Viejo",
          country: "United States",
          postalCode: "92692",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.864402, 33.665066],
        },
        properties: {
          name: "Classic Q",
          phoneFormatted: "",
          phone: "",
          address: "4251 Macaurthor Blvd.",
          city: "Newport Beach",
          country: "United States",
          postalCode: "92660",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.150604, 32.74826],
        },
        properties: {
          name: "Baja Betty's",
          phoneFormatted: "",
          phone: "",
          address: "1421 University Ave",
          city: "San Diego",
          country: "United States",
          postalCode: "92103",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.258115, 34.048236],
        },
        properties: {
          name: "Shoo Shoo Baby",
          phoneFormatted: "",
          phone: "",
          address: "717 West Seventh St",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90017",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.150511, 34.147143],
        },
        properties: {
          name: "Victoria's Restaurant",
          phoneFormatted: "",
          phone: "",
          address: "72 N Fair Oaks Ave",
          city: "Pasadena",
          country: "United States",
          postalCode: "91103",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.246902, 34.146303],
        },
        properties: {
          name: "Dave's on Broadway",
          phoneFormatted: "",
          phone: "",
          address: "708 E Broadway",
          city: "Glendale",
          country: "United States",
          postalCode: "91205",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.1009, 32.78121],
        },
        properties: {
          name: "JT's Tavern",
          phoneFormatted: "",
          phone: "",
          address: "5821 Mission George Rd",
          city: "San Diego",
          country: "United States",
          postalCode: "92120",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.07433, 33.10139],
        },
        properties: {
          name: "Major Market",
          phoneFormatted: "",
          phone: "",
          address: "1855 CTR City Pkwy",
          city: "Escondido",
          country: "United States",
          postalCode: "92025",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.25944, 33.04396],
        },
        properties: {
          name: "JD's",
          phoneFormatted: "",
          phone: "",
          address: "215 S El Camino Real",
          city: "San Celemente",
          country: "United States",
          postalCode: "92672",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.396915, 33.98976],
        },
        properties: {
          name: "TWM #1139",
          phoneFormatted: "",
          phone: "",
          address: "11441 Jefferson Blvd.",
          city: "Culver City",
          country: "United States",
          postalCode: "90230",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.419847, 34.058941],
        },
        properties: {
          name: "Javier's Century City",
          phoneFormatted: "",
          phone: "",
          address: "10250 Santa Monica Blvd. #1005",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90067",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.152575, 33.771989],
        },
        properties: {
          name: "Silver Fox",
          phoneFormatted: "",
          phone: "",
          address: "411 Redondo Ave",
          city: "Long Beach",
          country: "United States",
          postalCode: "90814",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.360078, 34.032676],
        },
        properties: {
          name: "Alta Adams",
          phoneFormatted: "",
          phone: "",
          address: "5359 W Adams Blvd.",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90016",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.254812, 32.793828],
        },
        properties: {
          name: "The Open Bar",
          phoneFormatted: "",
          phone: "",
          address: "4302 Mission Bl",
          city: "San Diego",
          country: "United States",
          postalCode: "92109",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.095893, 34.146028],
        },
        properties: {
          name: "The Colorado",
          phoneFormatted: "",
          phone: "",
          address: "2640 E Colorado Blvd.",
          city: "Pasadena",
          country: "United States",
          postalCode: "91107",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.17437, 33.77142],
        },
        properties: {
          name: "Bud Liquor Market",
          phoneFormatted: "",
          phone: "",
          address: "1298 E 4th St",
          city: "Long Beach",
          country: "United States",
          postalCode: "90802",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-116.393256, 33.81607],
        },
        properties: {
          name: "Jerry's Martket",
          phoneFormatted: "",
          phone: "",
          address: "72711 Ramon RD",
          city: "Thousand Palms",
          country: "United States",
          postalCode: "92276",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.71818, 34.27948],
        },
        properties: {
          name: "Don Cuco's Mexican Restaurant",
          phoneFormatted: "",
          phone: "",
          address: "3991 E Cochran St",
          city: "Simi Valley",
          country: "United States",
          postalCode: "93063",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.329328, 34.10102],
        },
        properties: {
          name: "Tokio Los Angeles",
          phoneFormatted: "",
          phone: "",
          address: "1640 N Cahuenga Bl.",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90028",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.352276, 34.097911],
        },
        properties: {
          name: "El Compadre Sunset",
          phoneFormatted: "",
          phone: "",
          address: "7408 W Sunset Blvd.",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90046",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.03278, 33.85964],
        },
        properties: {
          name: "Isla Cuban-Latin Kitchen & Rum Bar",
          phoneFormatted: "",
          phone: "",
          address: "30 Centerpoint Dr #12 & 13",
          city: "La Palma",
          country: "United States",
          postalCode: "90623",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.416048, 33.918085],
        },
        properties: {
          name: "Sausal",
          phoneFormatted: "",
          phone: "",
          address: "215-219 Main St",
          city: "El Segundo",
          country: "United States",
          postalCode: "90245",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.329242, 34.096995],
        },
        properties: {
          name: "Cabana Club/Sterling",
          phoneFormatted: "",
          phone: "",
          address: "1430 N Cahuenga Bl",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90028",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.132109, 33.921386],
        },
        properties: {
          name: "The Olive",
          phoneFormatted: "",
          phone: "",
          address: "8830 Apollo Way #104",
          city: "Downey",
          country: "United States",
          postalCode: "90242",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.940655, 33.77518],
        },
        properties: {
          name: "Aum Beer Club",
          phoneFormatted: "",
          phone: "",
          address: "12900 Main St",
          city: "Garden Grove",
          country: "United States",
          postalCode: "92840",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.87082, 33.59678],
        },
        properties: {
          name: "Papa Liquor",
          phoneFormatted: "",
          phone: "",
          address: "3244 E Coast Hwy",
          city: "Corona Del Mar",
          country: "United States",
          postalCode: "92625",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.97734, 34.17235],
        },
        properties: {
          name: "Gema",
          phoneFormatted: "",
          phone: "",
          address: "360 Via Las Brisas Unit 110",
          city: "Newbury Park",
          country: "United States",
          postalCode: "91320",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.452122, 34.151363],
        },
        properties: {
          name: "On The Thirty",
          phoneFormatted: "",
          phone: "",
          address: "14622 Ventura Bl #112",
          city: "Sherman Oaks",
          country: "United States",
          postalCode: "91403",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.361846, 34.088627],
        },
        properties: {
          name: "Ysabel",
          phoneFormatted: "",
          phone: "",
          address: "945-47-49 N Fairfax Ave",
          city: "West Hollywood",
          country: "United States",
          postalCode: "90046",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.9424, 33.93851],
        },
        properties: {
          name: "La Hambra 300 Bowl",
          phoneFormatted: "",
          phone: "",
          address: "370 E Whittier Bl",
          city: "La Hambra",
          country: "United States",
          postalCode: "90631",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.447135, 34.03063],
        },
        properties: {
          name: "neat.",
          phoneFormatted: "",
          phone: "",
          address: "11780 N Pico Bl",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90064",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.301084, 34.057711],
        },
        properties: {
          name: "R Bar",
          phoneFormatted: "",
          phone: "",
          address: "3331 W 8th St",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90005",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.344707, 34.098832],
        },
        properties: {
          name: "The Woods",
          phoneFormatted: "",
          phone: "",
          address: "3331 N La Brea Ave",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90028",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.890285, 33.695935],
        },
        properties: {
          name: "Antonello Ristorante",
          phoneFormatted: "",
          phone: "",
          address: "1611 W Sunflower Ave",
          city: "Santa Ana",
          country: "United States",
          postalCode: "92704",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.149282, 34.145622],
        },
        properties: {
          name: "Club 54",
          phoneFormatted: "",
          phone: "",
          address: "54 E Colorado Bl",
          city: "Pasadena",
          country: "United States",
          postalCode: "91105",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.893587, 33.679699],
        },
        properties: {
          name: "Kitsch Bar",
          phoneFormatted: "",
          phone: "",
          address: "891 Baker St #10A",
          city: "Costa Mesa",
          country: "United States",
          postalCode: "92626",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.457709, 33.982687],
        },
        properties: {
          name: "Jamaica Bay Inn",
          phoneFormatted: "",
          phone: "",
          address: "4175 Admiralty Way",
          city: "Marina Del Rey",
          country: "United States",
          postalCode: "90292",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.775729, 33.532306],
        },
        properties: {
          name: "Avilas El Ranchito-Newport Beach",
          phoneFormatted: "",
          phone: "",
          address: "2800 Newport Blvd.",
          city: "Newport Beach",
          country: "United States",
          postalCode: "92663",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-121.140471, 40.29081],
        },
        properties: {
          name: "Bailey Creek Golf Course",
          phoneFormatted: "",
          phone: "",
          address: "433 Durkin Dr",
          city: "Lake Almanor",
          country: "United States",
          postalCode: "96137",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.349351, 34.090733],
        },
        properties: {
          name: "Phorage",
          phoneFormatted: "",
          phone: "",
          address: "7326 E Broadway",
          city: "West Hollywood",
          country: "United States",
          postalCode: "90046",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.16953, 33.76718],
        },
        properties: {
          name: "Black",
          phoneFormatted: "",
          phone: "",
          address: "1800 E Broadway",
          city: "Long Beach",
          country: "United States",
          postalCode: "90802",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.35402, 33.19474],
        },
        properties: {
          name: "Fire Mountain Market",
          phoneFormatted: "",
          phone: "",
          address: "1991 Oceanside Bl",
          city: "Oceanside",
          country: "United States",
          postalCode: "92054",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.999179, 33.655234],
        },
        properties: {
          name: "OLA #2",
          phoneFormatted: "",
          phone: "",
          address: "6420 E Pacific Coast HWY #230",
          city: "Long Beach",
          country: "United States",
          postalCode: "90803",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.13163, 33.7592],
        },
        properties: {
          name: "Riley's",
          phoneFormatted: "",
          phone: "",
          address: "5331 E 2nd St",
          city: "Long Beach",
          country: "United States",
          postalCode: "90803",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.71258, 33.55439],
        },
        properties: {
          name: "Whole Foods Market #10437 LGN",
          phoneFormatted: "",
          phone: "",
          address: "23932 Aliso Creek Rd",
          city: "Laguna Niguel",
          country: "United States",
          postalCode: "92677",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.392645, 33.90641],
        },
        properties: {
          name: "Whole Foods Market #10225 PCH",
          phoneFormatted: "",
          phone: "",
          address: "760 S Sepulveda Blvd",
          city: "El Segundo",
          country: "United States",
          postalCode: "90245",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-116.413899, 33.753039],
        },
        properties: {
          name: "Sunrise Country Club",
          phoneFormatted: "",
          phone: "",
          address: "71601 Country Club Dr",
          city: "Rancho Mirage",
          country: "United States",
          postalCode: "92270",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.25091, 32.98053],
        },
        properties: {
          name: "Whole Foods Market #10434 Dmr",
          phoneFormatted: "",
          phone: "",
          address: "2600 Via De La Valle STE 100",
          city: "San Diego",
          country: "United States",
          postalCode: "92014",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.075084, 34.150202],
        },
        properties: {
          name: "Whole Foods Market #10108 Pas",
          phoneFormatted: "",
          phone: "",
          address: "3751 E Foothill Blvd",
          city: "Pasadena",
          country: "United States",
          postalCode: "91107",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.444555, 34.150545],
        },
        properties: {
          name: "Whole Foods Market #10671 SHM",
          phoneFormatted: "",
          phone: "",
          address: "14311 Ventura Blvd",
          city: "Sherman Oaks",
          country: "United States",
          postalCode: "91423",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.960296, 33.633027],
        },
        properties: {
          name: "OLA HB",
          phoneFormatted: "",
          phone: "",
          address: "21040 Pacific Coast Hwy #F200",
          city: "Huntington Beach",
          country: "United States",
          postalCode: "92648",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.92921, 33.61195],
        },
        properties: {
          name: "Cassidy's",
          phoneFormatted: "",
          phone: "",
          address: "2603 Newport Blvd",
          city: "Newport Beach",
          country: "United States",
          postalCode: "92663",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.401602, 33.862215],
        },
        properties: {
          name: "11 Pier Ave",
          phoneFormatted: "",
          phone: "",
          address: "3-11 Pier Ave",
          city: "Hermosa Beach",
          country: "United States",
          postalCode: "90254",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.925015, 33.620118],
        },
        properties: {
          name: "Louies By the Bay",
          phoneFormatted: "",
          phone: "",
          address: "2801 We Pacific Coast Hwy",
          city: "Newport Beach",
          country: "United States",
          postalCode: "92663",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.45058, 34.04607],
        },
        properties: {
          name: "Nickle Mine",
          phoneFormatted: "",
          phone: "",
          address: "11363 Santa Monica Blvd",
          city: "Los Angeles",
          country: "United States",
          postalCode: "90025",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.828513, 33.572886],
        },
        properties: {
          name: "A Crystal Cove",
          phoneFormatted: "",
          phone: "",
          address: "7864 E Coast Hwy",
          city: "Newport Beach",
          country: "United States",
          postalCode: "92657",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.121841, 33.756591],
        },
        properties: {
          name: "Nico's",
          phoneFormatted: "",
          phone: "",
          address: "5760 E 2nd St",
          city: "Long Beach",
          country: "United States",
          postalCode: "90803",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-117.874873, 33.60461],
        },
        properties: {
          name: "CdM",
          phoneFormatted: "",
          phone: "",
          address: "2325 E Coast Hwy",
          city: "Corona Del Mar",
          country: "United States",
          postalCode: "92625",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.029849, 33.87646],
        },
        properties: {
          name: "Team #004 Freda",
          phoneFormatted: "",
          phone: "",
          address: "17101 Valley View Ave",
          city: "Cerritos",
          country: "United States",
          postalCode: "90703",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-122.030725, 37.37373],
        },
        properties: {
          name: "Whole Foods Market #10707 SVL",
          phoneFormatted: "",
          phone: "",
          address: "150 E Mckinley Ave #100",
          city: "Sunnyvale",
          country: "United States",
          postalCode: "94086",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-122.03976, 37.32315],
        },
        properties: {
          name: "Whole Foods Martket #10267 STC",
          phoneFormatted: "",
          phone: "",
          address: "20955 Steven's Creek Blvd.",
          city: "Cupertino",
          country: "United States",
          postalCode: "95014",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-122.476775, 37.728545],
        },
        properties: {
          name: "Whole Foods Market #10717 STO",
          phoneFormatted: "",
          phone: "",
          address: "3251 20th Ave #340",
          city: "San Francisco",
          country: "United States",
          postalCode: "94132",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-122.525832, 37.902447],
        },
        properties: {
          name: "Whole Foods Market #10337 Bld",
          phoneFormatted: "",
          phone: "",
          address: "731 E Blithedale Ave",
          city: "Mill Valley",
          country: "United States",
          postalCode: "94941",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-118.28699, 33.71681],
        },
        properties: {
          name: "Wawa Thai Food",
          phoneFormatted: "",
          phone: "",
          address: "3009 Macarthur Blvd.",
          city: "Oakland",
          country: "United States",
          postalCode: "94602",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-120.85265, 37.50017],
        },
        properties: {
          name: "Jura's Pizza",
          phoneFormatted: "",
          phone: "",
          address: "783 N Golden State Blvd.",
          city: "Turlock",
          country: "United States",
          postalCode: "95380",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-122.488012, 37.861752],
        },
        properties: {
          name: "Sausalito Cruising Club",
          phoneFormatted: "",
          phone: "",
          address: "FT of Napa St.",
          city: "Sausalito",
          country: "United States",
          postalCode: "94966",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-121.08374, 38.92322],
        },
        properties: {
          name: "El Agave",
          phoneFormatted: "",
          phone: "",
          address: "1285 Grass Valley Hwy",
          city: "Auburn",
          country: "United States",
          postalCode: "95603",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-122.91427, 39.06364],
        },
        properties: {
          name: "TNT on the Lake",
          phoneFormatted: "",
          phone: "",
          address: "2599 Lakeshore Blvd.",
          city: "Lakeport",
          country: "United States",
          postalCode: "95603",
          state: "CA",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
    ],
  };
  const storesCT = {
    type: "FeatureCollection",
    features: [
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-73.1170617, 41.2025111],
        },
        properties: {
          name: "The Dock Wine and Liquor Inc.",
          phoneFormatted: "(203) 522-4692",
          phone: "2035224692",
          address: "200 East Main Street",
          city: "Stratford",
          country: "United States",
          postalCode: "06614",
          state: "CT",
          premise: "Off",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-72.9177591, 41.369286],
        },
        properties: {
          name: "Liquor Land Inc.",
          phoneFormatted: "(203) 281-0784",
          phone: "2032810784",
          address: "2165 Dixwell Avenue",
          city: "Hamden",
          country: "United States",
          postalCode: "06514",
          state: "CT",
          premise: "Off",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-73.5264641, 41.055012],
        },
        properties: {
          name: "Warehouse Wines & Liquors Corp.",
          phoneFormatted: "(203) 357-9151",
          phone: "2033579151",
          address: "835 East Main Street",
          city: "Stamford",
          country: "United States",
          postalCode: "06902",
          state: "CT",
          premise: "Off",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-73.4009659, 41.1243815],
        },
        properties: {
          name: "Norwalk Liquor Store Inc.",
          phoneFormatted: "(203) 847-2779",
          phone: "2038472779",
          address: "149 Westport Avenue",
          city: "Norwalk",
          country: "United States",
          postalCode: "06851",
          state: "CT",
          premise: "Off",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-73.6843313, 41.0497734],
        },
        properties: {
          name: "King Street Beverages LLC",
          phoneFormatted: "(203) 531-8135",
          phone: "2035318135",
          address: "1071 King Street",
          city: "Greenwich",
          country: "United States",
          postalCode: "06831",
          state: "CT",
          premise: "Off",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-73.4200984, 41.574158],
        },
        properties: {
          name: "Veterans Plaza Beverages Inc.",
          phoneFormatted: "(860) 354-5444",
          phone: "8603545444",
          address: "1 Kent Road",
          city: "New Milford",
          country: "United States",
          postalCode: "06776",
          state: "CT",
          premise: "Off",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-73.4177835, 41.161859],
        },
        properties: {
          name: "Hilltop Beverages, LLC",
          phoneFormatted: "(203) 210-7837",
          phone: "2032107837",
          address: "14 Danbury Road",
          city: "Wilton",
          country: "United States",
          postalCode: "06897",
          state: "CT",
          premise: "Off",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-73.3133786, 41.1382099],
        },
        properties: {
          name: "Greens Farms Beverages Inc.",
          phoneFormatted: "(203) 292-6956",
          phone: "2032926956",
          address: "1460 Post Rd E",
          city: "Westport",
          country: "United States",
          postalCode: "06880",
          state: "CT",
          premise: "Off",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-73.451443, 41.0926718],
        },
        properties: {
          name: "Bev Max of CT Avenue LLC",
          phoneFormatted: "(203) 810-4005",
          phone: "2038104005",
          address: "777 Connecticut Avenue",
          city: "Norwalk",
          country: "United States",
          postalCode: "06854",
          state: "CT",
          premise: "Off",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-73.545492, 41.0696427],
        },
        properties: {
          name: "Ridgeway Beverages Inc.",
          phoneFormatted: "(203) 252-2104",
          phone: "2032522104",
          address: "2202 Bedford Street",
          city: "Stamford",
          country: "United States",
          postalCode: "06905",
          state: "CT",
          premise: "Off",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
      {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-73.4850304, 41.3752652],
        },
        properties: {
          name: "Airport Beverages Inc.",
          phoneFormatted: "(475) 289-3249",
          phone: "4752893249",
          address: "20 Backus Avenue",
          city: "Danbury",
          country: "United States",
          postalCode: "06810",
          state: "CT",
          premise: "Off",
          blanco: 1,
          resposado: 1,
          anejo: 1,
        },
      },
    ],
  };
    const storesNY = {
        type: "FeatureCollection",
        features: [
            {
            type: "Feature",
            geometry: {
            type: "Point",
            coordinates: [ , ],
            },
            properties: {
            name: "",
            phoneFormatted: "",
            phone: "",
            address: "",
            city: "",
            country: "United States",
            postalCode: "",
            state: "NY",
            premise: "Off",
            blanco: 1,
            resposado: 1,
            anejo: 1,
            },
          },
          {
          type: "Feature",
          geometry: {
              type: "Point",
              coordinates: [, ],
          },
          properties: {
              name: "",
              phoneFormatted: "",
              phone: "",
              address: "",
              city: "",
              country: "United States",
              postalCode: "",
              state: "NY",
              premise: "Off",
              blanco: 1,
              resposado: 1,
              anejo: 1,
           },
        },
     ],
   };
  const storesNV = {
      type: "FeatureCollection",
      features: [
          {
          type: "Feature",
          geometry: {
          type: "Point",
          coordinates: [-115.152341, 36.159138],
          },
          properties: {
          name: "18Bin",
          phoneFormatted: "(702) 202-2484",
          phone: "7022022484",
          address: "107 E Charleston Blvd Ste 150",
          city: "Las Vegas",
          country: "United States",
          postalCode: "89101",
          state: "NV",
          premise: "Off",
          blanco: 1,
          resposado: 1,
          anejo: 1,
          },
        },
        {
        type: "Feature",
        geometry: {
            type: "Point",
            coordinates: [-115.191355, 36.126188],
        },
        properties: {
            name: "Màs Por Favor Taqueria y Tequila",
            phoneFormatted: "(702) 201-1133",
            phone: "7022011133",
            address: "3879 Spring Mountain Rd",
            city: "Las Vegas",
            country: "United States",
            postalCode: "89102",
            state: "NV",
            premise: "Off",
            blanco: 1,
            resposado: 1,
            anejo: 1,
           },
        },
        {
          type: "Feature",
          geometry: {
          type: "Point",
          coordinates: [-115.171748, 36.102198],
          },
          properties: {
          name: "T-Mobile Arena",
          phoneFormatted: "+1 (702) 692-1300",
          phone: "+17026921300",
          address: "3780 South Las Vegas Boulevard",
          city: "Las Vegas",
          country: "United States",
          postalCode: "89158",
          state: "NV",
          premise: "OFF",
          blanco: 1,
          resposado: 1,
          anejo: 1
          },
       },
       {
          type: "Feature",
          geometry: {
              type: "Point",
              coordinates: [-115.279036, 36.162464]
            },
            properties: {
              name: "Marche Bacchus",
              phoneFormatted: "+1 (702) 804-8008",
              phone: "+17028048008",
              address: "2620 Regatta Dr Suite 106",
              city: "Las Vegas",
              country: "United States",
              postalCode: "89128",
              state: "NV",
              premise: "OFF",
              blanco: 1,
              resposado: 1,
              anejo: 1
           },
        },
    ],
 };

  storesAZ.features.forEach(function (store, i) {
    store.properties.id = i;
  });
  
  storesCA.features.forEach(function (store, i) {
    store.properties.id = i;
  });

  storesCT.features.forEach(function (store, i) {
    store.properties.id = i;
  });
    
  storesNV.features.forEach(function (store, i) {
    store.properties.id = i;
  });
    
  storesNY.features.forEach(function (store, i) {
    store.properties.id = i;
  });

  const [stores, setStores] = useState(null);
  const [currentStore, setCurrentStore] = useState("CA");

  function setStoresFunction(list, state) {
    const listings = document.getElementById("listings");
    const intro = document.querySelector(".store-locater--intro");
    intro.classList.remove("active");

    //if (currentStore !== state) {
    listings.innerHTML = "";
    setStores(list);
    setCurrentStore(state);
    //}
  }

  function locaterBack() {
    const intro = document.querySelector(".store-locater--intro");
    intro.classList.add("active");
  }

  useEffect(() => {
    mapboxgl.accessToken =
      "pk.eyJ1Ijoibm92YXRyb242IiwiYSI6ImNsOG94YWk1azEzbHczb215bmJ5bHZ1Nm8ifQ.HWyrLPYwAT9_dcik0zeSzA";

    const map = new mapboxgl.Map({
      container: "map",
      style: "mapbox://styles/mapbox/light-v10",
      center: [-98.5795, 39.8283],
      zoom: 5,
      scrollZoom: false,
    });

    map.addControl(new mapboxgl.NavigationControl());

    map.on("load", () => {
      /* Add the data to your map as a layer */
      map.addSource("places", {
        type: "geojson",
        data: stores,
        //cluster: true,
        //clusterMaxZoom: 14, // Max zoom to cluster points on
        //clusterRadius: 50, // Radius of each cluster when clustering points (defaults to 50)
      });
      /*map.fitBounds([
        [-124.409591, 32.534156], // southwestern corner of the bounds
        [-114.131211, 42.009518], // northeastern corner of the bounds
      ]);*/

      var bounds = new mapboxgl.LngLatBounds();

      if (stores !== null) {
        stores.features.forEach(function (marker) {
          bounds.extend(marker.geometry.coordinates);
        });

        map.fitBounds(bounds, {
          padding: 100,
        });
      }
      const geocoder = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken, // Set the access token
        mapboxgl: mapboxgl, // Set the mapbox-gl instance
        marker: true, // Use the geocoder's default marker style
        countries: "US",
        //bbox: [-124.409591, 32.534156, -114.131211, 42.009518], // Set the bounding box coordinates
      });

      map.addControl(geocoder, "top-left");
      if (stores !== null) {
        buildLocationList(stores);
        addMarkers(stores);
      }
      geocoder.on("result", (event) => {
        const searchResult = event.result.geometry;
        const options = { units: "miles" };
        for (const store of stores.features) {
          store.properties.distance = turf.distance(
            searchResult,
            store.geometry,
            options
          );
        }
        stores.features.sort((a, b) => {
          if (a.properties.distance > b.properties.distance) {
            return 1;
          }
          if (a.properties.distance < b.properties.distance) {
            return -1;
          }
          return 0; // a must be equal to b
        });
        const listings = document.getElementById("listings");
        while (listings.firstChild) {
          listings.removeChild(listings.firstChild);
        }
        buildLocationList(stores);

        const activeListing = document.getElementById(
          `link-${stores.features[0].properties.id}`
        );
        activeListing.classList.add("active");

        const bbox = getBbox(stores, 0, searchResult);
        map.fitBounds(bbox, {
          padding: 100,
        });

        createPopUp(stores.features[0]);
      });
    });

    function buildLocationList(stores) {
      for (const store of stores.features) {
        /* Add a new listing section to the sidebar. */
        const listings = document.getElementById("listings");
        const listing = listings.appendChild(document.createElement("a"));
        listing.href = "#";
        /* Assign a unique `id` to the listing. */
        listing.id = `link-${store.properties.id}`;
        /* Assign the `item` class to each listing for styling. */
        listing.className = "item px-8 py-4 border-t border-dashed border-gold";

        /* Add the link to the individual listing created above. */
        const link = listing.appendChild(document.createElement("div"));
        link.href = "#";
        link.className = " title font-historical text-sm";
        link.id = `title-${store.properties.id}`;
        link.innerHTML = `${store.properties.name}`;

        /* Add details to the individual listing. */
        const details = listing.appendChild(document.createElement("div"));
        details.className = "text-xs";
        details.innerHTML = `${store.properties.address} ${store.properties.city}, ${store.properties.state}`;
        if (store.properties.phone) {
          details.innerHTML += `<br />${store.properties.phoneFormatted}`;
        }
        if (store.properties.distance) {
          const roundedDistance =
            Math.round(store.properties.distance * 100) / 100;
          details.innerHTML += `<div class="text-gold">${roundedDistance} miles away</div>`;
        }

        // Sidebar Click
        listing.addEventListener("click", function () {
          for (const feature of stores.features) {
            if (this.id === `link-${feature.properties.id}`) {
              flyToStore(feature);
              createPopUp(feature);
            }
          }
          const activeItem = document.getElementsByClassName("active");
          if (activeItem[0]) {
            activeItem[0].classList.remove("active");
          }
          this.classList.add("active");
        });
      }
    }

    function flyToStore(currentFeature) {
      map.flyTo({
        center: currentFeature.geometry.coordinates,
        zoom: 15,
      });
    }

    function createPopUp(currentFeature) {
      const popUps = document.getElementsByClassName("mapboxgl-popup");
      /** Check if there is already a popup on the map and if so, remove it */
      if (popUps[0]) popUps[0].remove();

      const popup = new mapboxgl.Popup({ closeOnClick: false })
        .setLngLat(currentFeature.geometry.coordinates)
        .setHTML(
          `<div class="title font-historical text-sm text-gold">${currentFeature.properties.name}</div> <div class="text-xs font-sans">${currentFeature.properties.address}<br />${currentFeature.properties.city}, ${currentFeature.properties.state}<br /><a href="tel:${currentFeature.properties.phone}">${currentFeature.properties.phoneFormatted}</a><a href="https://www.google.com/maps/dir/?api=1&origin=${currentFeature.properties.address} ${currentFeature.properties.city}, ${currentFeature.properties.state}" class="text-xs text-center bg-black text-white font-serif lowercase mt-4 w-full px-4 py-2 rounded-sm hover:bg-gold hover:text-white transition-all duration-200 ease-in-out block decoration-0" target="_blank">Get Directions</a></div>`
        )
        .addTo(map);
    }

    function addMarkers(stores) {
      /* For each feature in the GeoJSON object above: */
      for (const marker of stores.features) {
        /* Create a div element for the marker. */
        const el = document.createElement("div");
        /* Assign a unique `id` to the marker. */
        el.id = `marker-${marker.properties.id}`;
        /* Assign the `marker` class to each marker for styling. */
        el.className = "marker";

        /**
         * Create a marker using the div element
         * defined above and add it to the map.
         **/
        new mapboxgl.Marker(el, { offset: [0, -23] })
          .setLngLat(marker.geometry.coordinates)
          .addTo(map);

        el.addEventListener("click", (e) => {
          /* Fly to the point */
          flyToStore(marker);
          /* Close all other popups and display popup for clicked store */
          createPopUp(marker);
          /* Highlight listing in sidebar */
          const activeItem = document.getElementsByClassName("active");
          e.stopPropagation();
          if (activeItem[0]) {
            activeItem[0].classList.remove("active");
          }
          const listing = document.getElementById(
            `link-${marker.properties.id}`
          );
          listing.classList.add("active");
        });
      }
    }

    function getBbox(sortedStores, storeIdentifier, searchResult) {
      const lats = [
        sortedStores.features[storeIdentifier].geometry.coordinates[1],
        searchResult.coordinates[1],
      ];
      const lons = [
        sortedStores.features[storeIdentifier].geometry.coordinates[0],
        searchResult.coordinates[0],
      ];
      const sortedLons = lons.sort((a, b) => {
        if (a > b) {
          return 1;
        }
        if (a.distance < b.distance) {
          return -1;
        }
        return 0;
      });
      const sortedLats = lats.sort((a, b) => {
        if (a > b) {
          return 1;
        }
        if (a.distance < b.distance) {
          return -1;
        }
        return 0;
      });
      return [
        [sortedLons[0], sortedLats[0]],
        [sortedLons[1], sortedLats[1]],
      ];
    }
  });

  return (
    <>
      <div className="klaviyo-form-Ugk2kn"></div>

      <section className={cx("store-locater relative pb-20")}>
        {/* <div className={cx(styles.sectionHeader, "fixed top-0 left-0 right-0 w-full flex justify-center items-center w-full justify-center items-center md:h-28 z-0 bg-offWhite px-4 md:px-0")}>
                <div className={cx(styles.sectionHeaderInner, "flex justify-center items-center h-full border-b border-dashed border-gold pt-6 md:pt-0 pb-4 md:pb-0")}>
                    <C_Logo_Inverted className={cx(styles.sectionHeaderLogo)} />
                </div>

            </div> */}

        <div className="grid grid-cols-4">
          <div className="col-span-4 md:col-span-1 order-2 md:order-1">
            <div className="sidebar border-r border-dashed border-gold">
              <div className="heading flex justify-between items-center px-8">
                <p className="text-xl leading-none font-sans  pt-4 pb-7">
                  Our locations
                </p>
                <a
                  href="#"
                  className="text-sm flex items-center"
                  onClick={() => locaterBack()}
                >
                  <svg
                    className="navArrow rotate-180"
                    width="29"
                    height="14"
                    viewBox="0 0 29 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M27.7101 6.75438L27.4798 6.55394C27.3723 6.44601 27.3417 6.55393 27.2342 6.35349C27.1267 6.15305 27.2342 6.21476 27.05 6.10683C26.8658 5.9989 26.8965 6.10676 26.7891 5.93716C26.6816 5.76755 26.7891 5.79843 26.6049 5.6905L26.3899 5.45919L26.1596 5.25883L25.9447 5.04295L25.7145 4.82707L25.4995 4.61119C25.3921 4.50326 25.4074 4.4879 25.3 4.37997C25.1925 4.27204 25.1619 4.28745 25.0544 4.17952C24.9469 4.07159 25.0544 4.0407 24.8702 3.93277C24.8027 3.85189 24.731 3.77474 24.6553 3.70155L24.425 3.5011C24.3175 3.39317 24.2868 3.50111 24.1794 3.31609C24.0719 3.13107 24.1794 3.16183 24.0105 3.05391C23.8417 2.94598 23.857 2.97682 23.7495 2.86889C23.6421 2.76096 23.6574 2.7456 23.5499 2.63767C23.4425 2.52974 23.55 2.49885 23.3657 2.39092L23.1509 2.17513L22.936 1.95925C22.8285 1.85132 22.7825 1.95926 22.675 1.77424C22.5676 1.58922 22.5829 1.65085 22.4755 1.54292C22.368 1.43499 22.3833 1.41954 22.2759 1.31161C22.1684 1.20368 22.1377 1.23452 22.0302 1.12659C21.9228 1.01866 21.9381 1.0033 21.8307 0.895372C21.7232 0.787442 21.6925 0.802853 21.5851 0.694924C21.4776 0.586994 21.5851 0.556104 21.4009 0.448175L21.1706 0.247821C21.0631 0.139891 21.1706 -0.0143464 20.9556 0.00107213C20.7407 0.0164906 20.8329 0.139891 20.7254 0.247821L20.4798 0.479042C20.3723 0.586971 20.3877 0.617861 20.2649 0.725791C20.1421 0.83372 20.0193 0.725734 20.0193 0.957012C20.0193 1.18829 20.1728 0.957004 20.2803 1.14203C20.3878 1.32705 20.2803 1.29628 20.4491 1.40421L20.6793 1.60456L20.9096 1.82044L21.1246 2.02089L21.3394 2.25221L21.539 2.46799L21.7539 2.68388L21.9842 2.89976L22.1992 3.10021C22.3066 3.20814 22.2759 3.23893 22.3834 3.34686C22.4908 3.45479 22.5368 3.42395 22.6443 3.53188C22.7518 3.6398 22.7364 3.65526 22.8439 3.76319L23.0741 3.96364C23.1815 4.07157 23.0741 4.10236 23.243 4.21029L23.4732 4.41074L23.6881 4.62662L23.9184 4.82707C24.0259 4.935 24.0106 4.95046 24.118 5.05839C24.2255 5.16632 24.2561 5.1509 24.3636 5.25883L24.5785 5.47462C24.686 5.58255 24.5785 5.59801 24.7627 5.70594L24.9929 5.90638L25.2079 6.13761L25.4074 6.35349C25.2539 6.35349 25.2539 6.26098 25.1004 6.26098C24.9469 6.26098 24.9469 6.26098 24.7934 6.26098C24.6399 6.26098 24.6399 6.26098 24.4864 6.26098H24.1794H23.8724H23.5653C23.4118 6.26098 23.4118 6.26098 23.2583 6.26098C23.1048 6.26098 23.1048 6.26098 22.9513 6.26098C22.7978 6.26098 22.7978 6.35349 22.6443 6.35349H22.0302C21.8767 6.35349 21.8767 6.23011 21.7232 6.23011H21.4162H21.1092C20.9557 6.23011 20.9557 6.23011 20.8022 6.23011C20.6487 6.23011 20.6486 6.13761 20.4951 6.13761H20.1881C20.0346 6.13761 20.0347 6.24555 19.8812 6.24555C19.7277 6.24555 19.7276 6.24555 19.5741 6.24555H19.2671C19.1136 6.24555 19.1136 6.24555 18.9601 6.24555C18.8065 6.24555 18.8065 6.15304 18.653 6.15304C18.4995 6.15304 18.4996 6.15304 18.3461 6.15304H18.039C17.8855 6.15304 17.8855 6.15304 17.732 6.15304C17.5785 6.15304 17.5785 6.24555 17.425 6.24555C17.2715 6.24555 17.2868 6.24555 17.1333 6.24555H16.8263C16.6728 6.24555 16.6728 6.24555 16.5193 6.24555C16.3658 6.24555 16.3658 6.33805 16.2123 6.33805H16.0127C15.8592 6.33805 15.8592 6.33805 15.7057 6.33805C15.5522 6.33805 15.5521 6.33805 15.3986 6.33805C15.2451 6.33805 15.2452 6.33805 15.0917 6.33805C14.9382 6.33805 14.9382 6.43056 14.7847 6.43056H14.4776C14.3241 6.43056 14.3241 6.43056 14.1706 6.43056C14.0171 6.43056 14.0171 6.43056 13.8635 6.43056H13.2496H12.9425C12.789 6.43056 12.789 6.43056 12.6355 6.43056H12.3285H12.0215H11.7145H10.1794C10.0259 6.43056 10.0259 6.43056 9.87236 6.43056C9.71885 6.43056 9.71883 6.43056 9.56532 6.43056H9.25829C9.10478 6.43056 9.10485 6.43056 8.95134 6.43056C8.79783 6.43056 8.79782 6.43056 8.64431 6.43056H8.0456C7.89209 6.43056 7.89207 6.43056 7.73856 6.43056C7.58505 6.43056 7.58504 6.33805 7.43153 6.33805H6.80218C6.64867 6.33805 6.64865 6.43056 6.49515 6.43056C6.34164 6.43056 6.34162 6.33805 6.18811 6.33805H5.88117H5.57413C5.42062 6.33805 5.4206 6.43056 5.26709 6.43056H4.65302C4.49951 6.43056 4.49959 6.43056 4.34608 6.43056H3.73201C3.5785 6.43056 3.57848 6.52307 3.42497 6.52307H3.1333H2.82626H2.51932H2.19692H1.88988C1.73637 6.52307 1.73635 6.39979 1.58285 6.39979C1.42934 6.39979 1.42941 6.50773 1.2759 6.50773H0.661831C0.508322 6.50773 0.508303 6.39979 0.354795 6.39979C0.201286 6.39979 0.155214 6.39979 0.0477583 6.39979C-0.0596979 6.39979 0.0477583 6.56935 0.0477583 6.73895C0.0477583 6.90855 0.124588 6.89317 0.124588 7.06277C0.124588 7.23238 0.124588 7.23232 0.124588 7.3865C0.124588 7.54069 0.124569 7.57154 0.201323 7.69489C0.278078 7.81824 0.324119 7.69489 0.477628 7.69489H0.784664C0.953524 7.69489 0.953464 7.69489 1.10697 7.69489C1.26048 7.69489 1.2605 7.69489 1.41401 7.69489C1.56752 7.69489 1.56754 7.61782 1.72105 7.61782C1.87455 7.61782 1.87457 7.69489 2.02808 7.69489H2.33512H2.64206H2.9491C3.10261 7.69489 3.10262 7.69489 3.25613 7.69489H3.56317H4.17715C4.33066 7.69489 4.33068 7.69489 4.48418 7.69489H4.79122C4.94473 7.69489 4.94475 7.69489 5.09826 7.69489C5.25177 7.69489 5.25178 7.80283 5.40529 7.80283C5.5588 7.80283 5.55873 7.67946 5.71224 7.67946C5.86574 7.67946 5.86576 7.67946 6.01927 7.67946C6.17278 7.67946 6.1728 7.67946 6.32631 7.67946H6.63335C6.78685 7.67946 6.78686 7.67946 6.92502 7.67946C7.06317 7.67946 7.07854 7.67946 7.23205 7.67946H7.84603C7.99954 7.67946 7.99956 7.60238 8.15307 7.60238C8.30658 7.60238 8.30659 7.71032 8.4601 7.71032H9.07408H9.38112C9.53463 7.71032 9.53465 7.63325 9.68816 7.63325C9.84166 7.63325 9.84168 7.75662 9.99519 7.75662C10.1487 7.75662 10.1487 7.61782 10.3022 7.61782C10.4557 7.61782 10.4557 7.69489 10.6092 7.69489H10.9162H11.2232H11.5303C11.6838 7.69489 11.6838 7.69489 11.8373 7.69489H12.1443C12.2978 7.69489 12.2978 7.69489 12.4513 7.69489C12.6048 7.69489 12.6048 7.60238 12.7583 7.60238C12.9118 7.60238 12.9119 7.69489 13.0654 7.69489H13.3724C13.5259 7.69489 13.5258 7.69489 13.6793 7.69489C13.8329 7.69489 13.8329 7.61782 13.9864 7.61782C14.1399 7.61782 14.1399 7.72576 14.2934 7.72576C14.4469 7.72576 14.4469 7.63325 14.6005 7.63325C14.754 7.63325 14.754 7.63325 14.9075 7.63325C15.061 7.63325 15.0609 7.63325 15.2144 7.63325H15.8285C15.982 7.63325 15.982 7.54074 16.1355 7.54074C16.2891 7.54074 16.2891 7.54074 16.4426 7.54074H16.7342C16.8877 7.54074 16.8877 7.44824 17.0412 7.44824C17.1947 7.44824 17.1947 7.44824 17.3482 7.44824C17.5017 7.44824 17.5018 7.44824 17.6553 7.44824C17.8088 7.44824 17.8088 7.52531 17.9623 7.52531H18.2692C18.4228 7.52531 18.4228 7.52531 18.5763 7.52531C18.7298 7.52531 18.7298 7.52531 18.8833 7.52531H19.1904C19.3439 7.52531 19.3439 7.52531 19.4974 7.52531C19.6509 7.52531 19.6508 7.52531 19.8043 7.52531C19.9578 7.52531 19.9579 7.41737 20.1114 7.41737C20.2649 7.41737 20.2649 7.52531 20.4184 7.52531H20.7254H21.0325H21.6465H21.9535H22.2605H22.5676H22.8592C23.0127 7.52531 23.0127 7.52531 23.1662 7.52531C23.3197 7.52531 23.3197 7.4328 23.4732 7.4328C23.6267 7.4328 23.6267 7.4328 23.7802 7.4328C23.9338 7.4328 23.9338 7.4328 24.0873 7.4328C24.2408 7.4328 24.2408 7.52531 24.3943 7.52531C24.5478 7.52531 24.5478 7.52531 24.7013 7.52531H25.5763L25.3461 7.72576C25.2386 7.83369 25.254 7.84914 25.1465 7.95707L24.9162 8.15743C24.8087 8.26536 24.8395 8.29624 24.732 8.40417C24.6245 8.5121 24.5939 8.48126 24.4864 8.58919C24.379 8.69712 24.3943 8.71257 24.2869 8.8205L24.0566 9.02086C23.9491 9.12879 23.9644 9.14424 23.857 9.25217C23.7495 9.3601 23.7649 9.37556 23.6574 9.48349L23.4272 9.68394L23.2123 9.89972C23.1048 10.0077 23.1202 10.0385 23.0127 10.1465L22.7978 10.3469C22.6903 10.4549 22.6443 10.424 22.5368 10.5319C22.4294 10.6399 22.5368 10.6552 22.3526 10.7632L22.1377 10.979C22.0302 11.087 22.0456 11.1024 21.9381 11.2104C21.8307 11.3183 21.8 11.3029 21.6926 11.4108C21.5851 11.5187 21.6158 11.5341 21.5083 11.642C21.4009 11.75 21.3548 11.642 21.2473 11.827C21.1399 12.0121 21.2473 11.9659 21.0785 12.0738L20.8483 12.2742L20.618 12.4747C20.5105 12.5826 20.5259 12.598 20.4184 12.7059C20.3109 12.8138 20.2188 12.7059 20.2188 12.9218C20.2188 13.1376 20.2188 13.0605 20.4184 13.1839C20.618 13.3072 20.5719 13.1839 20.6793 13.3689C20.7868 13.5539 20.7561 13.5231 20.8789 13.6464C21.0017 13.7698 20.9711 13.8623 21.1246 13.8623C21.2781 13.8623 21.278 13.8623 21.3701 13.6464C21.423 13.5628 21.4847 13.4853 21.5544 13.4152C21.6772 13.2918 21.6926 13.3227 21.8 13.2147C21.9075 13.1068 21.8768 13.076 21.9842 12.9681L22.1992 12.7368L22.414 12.5209L22.6443 12.305L22.8745 12.1046C22.982 11.9966 22.9666 11.9813 23.0741 11.8733C23.1815 11.7654 23.1969 11.7808 23.3197 11.6729L23.5193 11.457L23.7342 11.2258C23.8417 11.1179 23.8263 11.1024 23.9337 10.9945L24.164 10.794L24.3943 10.5781L24.6092 10.3624L24.8241 10.131C24.9316 10.0231 24.9162 10.0077 25.0237 9.89972L25.2386 9.69928C25.3143 9.62609 25.3861 9.54894 25.4535 9.46805C25.561 9.36013 25.5917 9.39097 25.7145 9.28304C25.8373 9.17511 25.7145 9.12879 25.8833 9.02086L26.1136 8.8205L26.3438 8.62006L26.5588 8.40417C26.6662 8.29624 26.6509 8.28079 26.7583 8.17286L26.9886 7.95707L27.2035 7.74119L27.4184 7.52531C27.5259 7.41738 27.5105 7.40192 27.618 7.29399C27.7254 7.18606 27.7561 7.294 27.8635 7.10898C27.971 6.92396 28.0938 7.10904 28.0938 6.87776C28.0938 6.64648 27.8175 6.86231 27.7101 6.75438Z"
                      fill="black"
                    ></path>
                  </svg>{" "}
                  <span className="ml-2 mb-2">Back</span>
                </a>
              </div>
              <div id="listings" className="listings"></div>
            </div>
          </div>
          <div className="col-span-4 md:col-span-3 order-1 md:order-2">
            <div id="map" className="map"></div>
          </div>
        </div>

        <div className="store-locater--intro active flex justify-center">
          <div className="w-full md:w-1/2">
            <div className="flex flex-col justify-center items-center w-full mt-10">
              <div className="blog__featuredPostCategory text-gold font-sans lowercase pb-3 pt-8 md:pt-0">
                Store Locater
              </div>
              <div className="font-historical text-center text-2xl portableText-module--rte--1-k7p mb-5">
                <h4>Chose Your State</h4>
              </div>
              <div className="flex justify-center">
                <button
                  onClick={() => setStoresFunction(storesAZ, "AZ")}
                  className="read__more font-serif lowercase text-xs mx-2 hover:bg-darkGray transition-all duration-200 ease-in-out"
                >
                  Arizona
                </button>
                <button
                  onClick={() => setStoresFunction(storesCA, "CA")}
                  className="read__more font-serif lowercase text-xs mx-2 hover:bg-darkGray transition-all duration-200 ease-in-out"
                >
                  California
                </button>
                <button
                  onClick={() => setStoresFunction(storesCT, "CT")}
                  className="read__more font-serif lowercase text-xs mx-2 hover:bg-darkGray transition-all duration-200 ease-in-out"
                >
                  Connecticut
                </button>
                <button
                  onClick={() => setStoresFunction(storesNV, "NV")}
                  className="read__more font-serif lowercase text-xs mx-2 hover:bg-darkGray transition-all duration-200 ease-in-out"
                 >
                   Nevada
                </button>
                <button
                  onClick={() => setStoresFunction(storesNY, "NY")}
                  className="read__more font-serif lowercase text-xs mx-2 hover:bg-darkGray transition-all duration-200 ease-in-out"
                >
                   New York
                </button>
              </div>
            </div>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 959 593"
              width="959"
              height="593"
            >
              <g className="state">
                <path
                  className="al"
                  d="m 643,467.4 .4,-7.3 -.9,-1.2 -1.7,-.7 -2.5,-2.8 .5,-2.9 48.8,-5.1 -.7,-2.2 -1.5,-1.5 -.5,-1.4 .6,-6.3 -2.4,-5.7 .5,-2.6 .3,-3.7 2.2,-3.8 -.2,-1.1 -1.7,-1 v -3.2 l -1.8,-1.9 -2.9,-6.1 -12.9,-45.8 -45.7,4 1.3,2 -1.3,67 4.4,33.2 .9,-.5 1.3,.1 .6,.4 .8,-.1 2,-3.8 v -2.3 l 1.1,-1.1 1.4,.5 3.4,6.4 v .9 l -3.3,2.2 3.5,-.4 4.9,-1.6 z"
                >
                  <title>Alabama</title>
                </path>

                <path
                  className="az"
                  onClick={() => setStoresFunction(storesAZ, "AZ")}
                  d="m 139.6,387.6 3,-2.2 .8,-2.4 -1,-1.6 -1.8,-.2 -1.1,-1.6 1.1,-6.9 1.6,-.3 2.4,-3.2 1.6,-7 2.4,-3.6 4.8,-1.7 1.3,-1.3 -.4,-1.9 -2.3,-2.5 -1.2,-5.8 -1.4,-1.8 -1.3,-3.4 .9,-2.1 1.4,-3 .5,-2.9 -.5,-4.9 1,-13.6 3.5,-.6 3.7,1.4 1.2,2.7 h 2 l 2.4,-2.9 3.4,-17.5 46.2,8.2 40,6 -17.4,124.1 -37.3,-5.4 -64.2,-37.5 .5,-2.9 2,-1.8 z"
                >
                  <title>Arizona</title>
                </path>

                <path
                  className="ar"
                  d="m 584.2,367 .9,-2.2 1.2,.5 .7,-1 -.8,-.7 .3,-1.5 -1.1,-.9 .6,-1 -.1,-1.5 -1.1,-.1 .8,-.8 1.3,.8 .3,-1.4 -.4,-1.1 .1,-.7 2,.6 -.4,-1.5 1.6,-1.3 -.5,-.9 -1.1,.1 -.6,-.9 .9,-.9 1.6,-.2 .5,-.8 1.4,-.2 -.1,-.8 -.9,-.9 v -.5 h 1.5 l .4,-.7 -1.4,-1 -.1,-.6 -11.2,.8 2.8,-5.1 1.7,-1.5 v -2.2 l -1.6,-2.5 -39.8,2 -39.1,.7 4.1,24.4 -.7,39 2.6,2.3 2.8,-1.3 3.2,.8 .2,11.9 52.3,-1.3 1.2,-1.5 .5,-3 -1.5,-2.3 -.5,-2.2 .9,-.7 v -.8 l -1.7,-1.1 -.1,-.7 1.6,-.9 -1.2,-1.1 1.7,-7.1 3.4,-1.6 v -.8 l -1.1,-1.4 2.9,-5.4 h 1.9 l 1.5,-1.2 -.3,-5.2 3.1,-4.5 1.8,-.6 -.5,-3.1 z"
                >
                  <title>Arkansas</title>
                </path>

                <path
                  className="ca"
                  onClick={() => setStoresFunction(storesCA, "CA")}
                  d="m 69.4,365.6 3.4,5.2 -1.4,.1 -1.8,-1.9 z m 1.9,-9.8 1.8,4.1 2.6,1 .7,-.6 -1.3,-2.5 -2.6,-2.4 z m -19.9,-19 v 2.4 l 2,1.2 4.4,-.2 1,-1 -3.1,-.2 z m -5.9,.1 3.3,.5 1.4,2.2 h -3.8 z m 47.9,45.5 -1,-3 .2,-3 -.4,-7.9 -1.8,-4.8 -1.2,-1.4 -.6,-1.5 -7,-8.6 -3.6,.1 -2,-1.9 1.1,-1.8 -.7,-3.7 -2.2,-1.2 -3.9,-.6 -2.8,-1.3 -1.5,-1.9 -4.5,-6.6 -2.7,-2.2 -3.7,-.5 -3.1,-2.3 -4.7,-1.5 -2.8,-.3 -2.5,-2.5 .2,-2.8 .8,-4.8 1.8,-5.1 -1.4,-1.6 -4,-9.4 -2.7,-3.7 -.4,-3 -1.6,-2.3 .2,-2.5 -2,-5 -2.9,-2.7 .6,-7.1 2.4,-.8 1.8,-3.1 -.4,-3.2 -1,-.9 h -2.5 l -2.5,-3.3 -1.5,-3.5 v -7.5 l 1.2,-4.2 .2,-2.1 2.5,.2 -.1,1.6 -.8,.7 v 2.5 l 3.7,3.2 v -4.7 l -1.4,-3.4 .5,-1.1 -1,-1.7 2.8,-1.5 -1.9,-3 -1.4,.5 -1.5,3.8 .5,1.3 -.8,1 -.9,-.1 -5.4,-6.1 .7,-5.6 -1.1,-3.9 -6.5,-12.8 .8,-10.7 2.3,-3.6 .2,-6.4 -5.5,-11.1 .3,-5.2 6.9,-7.5 1.7,-2.4 -.1,-1.4 4,-9.2 .1,-8.4 .9,-2.5 66.1,18.6 -16.4,63.1 1.1,3.5 70.4,105 -.9,2.1 1.3,3.4 1.4,1.8 1.2,5.8 2.3,2.5 .4,1.9 -1.3,1.3 -4.8,1.7 -2.4,3.6 -1.6,7 -2.4,3.2 -1.6,.3 -1.1,6.9 1.1,1.6 1.8,.2 1,1.6 -.8,2.4 -3,2.2 -2.2,-.1 z"
                >
                  <title>California</title>
                </path>

                <path
                  className="co"
                  d="m 374.6,323.3 -16.5,-1 -51.7,-4.8 -52.6,-6.5 11.5,-88.3 44.9,5.7 37.5,3.4 33.1,2.4 -1.4,22.1 z"
                >
                  <title>Colorado</title>
                </path>

                <path
                  className="ct"
                  onClick={() => setStoresFunction(storesCT, "CT")}
                  d="m 873.5,178.9 .4,-1.1 -3.2,-12.3 -.1,-.3 -14.9,3.4 v .7 l -.9,.3 -.5,-.7 -10.5,2.4 2.8,16.3 1.8,1.5 -3.5,3.4 1.7,2.2 5.4,-4.5 1.7,-1.3 h .8 l 2.4,-3.1 1.4,.1 2.9,-1.1 h 2.1 l 5.3,-2.7 2.8,-.9 1,-1 1.5,.5 z"
                >
                  <title>Connecticut</title>
                </path>

                <path
                  className="de"
                  d="m 822.2,226.6 -1.6,.3 -1.5,1.1 -1.2,2.1 7.6,27.1 10.9,-2.3 -2.2,-7.6 -1.1,.5 -3.3,-2.6 -.5,-1.7 -1.8,-1 -.2,-3.7 -2.1,-2.2 -1.1,-.8 -1.2,-1.1 -.4,-3.2 .3,-2.1 1,-2.2 z"
                >
                  <title>Delaware</title>
                </path>

                <path
                  className="fl"
                  d="m 751.7,445.1 -4,-.7 -1.7,-.9 -2.2,1.4 v 2.5 l 1.4,2.1 -.5,4.3 -2.1,.6 -1,-1.1 -.6,-3.2 -50.1,3.3 -3.3,-6 -48.8,5.1 -.5,2.9 2.5,2.8 1.7,.7 .9,1.2 -.4,7.3 -1.1,.6 .5,.4 1,-.3 .7,-.8 10.5,-2.7 9.2,-.5 8.1,1.9 8.5,5 2.4,.8 2.2,2 -.1,2.7 h 2.4 l 1.9,-1 2.5,.1 2,-.8 2.9,-2 3.1,-2.9 1.1,-.4 .6,.5 h 1.4 l .5,-.8 -.5,-1.2 -.6,-.6 .2,-.8 2,-1.1 5,-.4 .8,1 1,.1 2.3,1 3,1.8 1.2,1.7 1.1,1.2 2.8,1.4 v 2.4 l 2.8,1.9 1,.1 1.6,1.4 .7,1.6 1,.2 .8,2.1 .7,.6 1,-1.1 2.9,.1 .5,1.4 1.1,.9 v 1.3 l 2.9,2.2 .2,9.6 -1.8,5.8 1,1.2 -.2,3.4 -.8,1.4 .7,1.2 2.3,2.3 .3,1.5 .8,1 -.4,-1.9 1.3,-.6 .8,-3.6 -3,-1.2 .1,-.6 2.6,-.4 .9,2.6 1.1,.6 .1,-2 1.1,.3 .6,.8 -.1,.7 -2.9,4.2 -.2,1.1 -1.7,1.9 v 1.1 l 3.7,3.8 5.3,7.9 1.8,2.1 v 1.8 l 2.8,4.6 2.3,.6 .7,-1.2 -2.1,.3 -3,-4.5 .2,-1.4 1.5,-.8 v -1.5 l -.6,-1.3 .9,-.9 .4,.9 .7,.5 v 4 l -1.2,-.6 -.8,.9 1.4,1.6 1,2.6 1.2,-.6 2.3,1.2 2.1,2.2 1.6,5.1 3.1,4.8 .8,-1.3 2.8,-.5 3.2,1.3 .3,1.7 3.3,3.8 .1,1.1 2.2,2.7 -.7,.5 v 2.7 l 2.7,1.4 h 1.5 l 2.7,-1.8 1.5,.3 1.1,.4 2.3,-1.7 .2,-.7 1.2,.3 2.4,-1.7 1.3,-2.3 -.7,-3.2 -.2,-1.3 1.1,-4 .6,-.2 .6,1.6 .8,-1.8 -.8,-7.2 -.4,-10.5 -1,-6.8 -.7,-1.7 -6.6,-11.1 -5.2,-9.1 -2.2,-3.3 -1.3,-3.6 -.2,-3.4 .9,-.3 v -.9 l -1.1,-2.2 -4,-4 -7.6,-9.7 -5.7,-10.4 -4.3,-10.7 -.6,-3.7 -1.2,-1 -.5,-3.8 z m 9.2,134.5 1.7,-.1 -.7,-1 z m 7.3,-1.1 v -.7 l 1.6,-.2 3.7,-3.3 1.5,-.6 2.4,-.9 .3,1.3 1.7,.8 -2.6,1.2 h -2.4 l -3.9,2.5 z m 17.2,-7.6 -3,1.4 -1,1.3 1.1,.1 z m 3.8,-2.9 -1.1,.3 -1.4,2 1.1,-.2 1.5,-1.6 z m 8.3,-15.7 -1.7,5.6 -.8,1 -1,2.6 -1.2,1.6 -.7,1.7 -1.9,2.2 v .9 l 2.7,-2.8 2.4,-3.5 .6,-2 2.1,-4.9 z"
                >
                  <title>Florida</title>
                </path>

                <path
                  className="ga"
                  d="m 761.8,414.1 v 1.4 l -4.2,6.2 -1.2,.2 1.5,.5 v 2 l -.9,1.1 -.6,6 -2.3,6.2 .5,2 .7,5.1 -3.6,.3 -4,-.7 -1.7,-.9 -2.2,1.4 v 2.5 l 1.4,2.1 -.5,4.3 -2.1,.6 -1,-1.1 -.6,-3.2 -50.1,3.3 -3.3,-6 -.7,-2.2 -1.5,-1.5 -.5,-1.4 .6,-6.3 -2.4,-5.7 .5,-2.6 .3,-3.7 2.2,-3.8 -.2,-1.1 -1.7,-1 v -3.2 l -1.8,-1.9 -2.9,-6.1 -12.9,-45.8 22.9,-2.9 21.4,-3 -.1,1.9 -1.9,1 -1.4,3.2 .2,1.3 6.1,3.8 2.6,-.3 3.1,4 .4,1.7 4.2,5.1 2.6,1.7 1.4,.2 2.2,1.6 1.1,2.2 2,1.6 1.8,.5 2.7,2.7 .1,1.4 2.6,2.8 5,2.3 3.6,6.7 .3,2.7 3.9,2.1 2.5,4.8 .8,3.1 4.2,.4 z"
                >
                  <title>Georgia</title>
                </path>

                <path
                  className="id"
                  d="m 165.3,183.1 -24.4,-5.4 8.5,-37.3 2.9,-5.8 .4,-2.1 .8,-.9 -.9,-2 -2.9,-1.2 .2,-4.2 4,-5.8 2.5,-.8 1.6,-2.3 -.1,-1.6 1.8,-1.6 3.2,-5.5 4.2,-4.8 -.5,-3.2 -3.5,-3.1 -1.6,-3.6 1.1,-4.3 -.7,-4 12.7,-56.1 14.2,3 -4.8,22 3.7,7.4 -1.6,4.8 3.6,4.8 1.9,.7 3.9,8.3 v 2.1 l 2.3,3 h .9 l 1.4,2.1 h 3.2 v 1.6 l -7.1,17 -.5,4.1 1.4,.5 1.6,2.6 2.8,-1.4 3.6,-2.4 1.9,1.9 .5,2.5 -.5,3.2 2.5,9.7 2.6,3.5 2.3,1.4 .4,3 v 4.1 l 2.3,2.3 1.6,-2.3 6.9,1.6 2.1,-1.2 9,1.7 2.8,-3.3 1.8,-.6 1.2,1.8 1.6,4.1 .9,.1 -8.5,54.8 -47.9,-8.2 z"
                >
                  <title>Idaho</title>
                </path>

                <path
                  className="il"
                  d="m 623.5,265.9 -1,5.2 v 2 l 2.4,3.5 v .7 l -.3,.9 .9,1.9 -.3,2.4 -1.6,1.8 -1.3,4.2 -3.8,5.3 -.1,7 h -1 l .9,1.9 v .9 l -2.2,2.7 .1,1.1 1.5,2.2 -.1,.9 -3.7,.6 -.6,1.2 -1.2,-.6 -1,.5 -.4,3.3 1.7,1.8 -.4,2.4 -1.5,.3 -6.9,-3 -4,3.7 .3,1.8 h -2.8 l -1.4,-1.5 -1.8,-3.8 v -1.9 l .8,-.6 .1,-1.3 -1.7,-1.9 -.9,-2.5 -2.7,-4.1 -4.8,-1.3 -7.4,-7.1 -.4,-2.4 2.8,-7.6 -.4,-1.9 1.2,-1.1 v -1.3 l -2.8,-1.5 -3,-.7 -3.4,1.2 -1.3,-2.3 .6,-1.9 -.7,-2.4 -8.6,-8.4 -2.2,-1.5 -2.5,-5.9 -1.2,-5.4 1.4,-3.7 .7,-.7 .1,-2.3 -.7,-.9 1,-1.5 1.8,-.6 .9,-.3 1,-1.2 v -2.4 l 1.7,-2.4 .5,-.5 .1,-3.5 -.9,-1.4 -1,-.3 -1.1,-1.6 1,-4 3,-.8 h 2.4 l 4.2,-1.8 1.7,-2.2 .1,-2.4 1.1,-1.3 1.3,-3.2 -.1,-2.6 -2.8,-3.5 h -1.2 l -.9,-1.1 .2,-1.6 -1.7,-1.7 -2.5,-1.3 .5,-.6 45.9,-2.8 .1,4.6 3.4,4.6 1.2,4.1 1.6,3.2 z"
                >
                  <title>Illinois</title>
                </path>

                <path
                  className="in"
                  d="m 629.2,214.8 -5.1,2.3 -4.7,-1.4 4.1,50.2 -1,5.2 v 2 l 2.4,3.5 v .7 l -.3,.9 .9,1.9 -.3,2.4 -1.6,1.8 -1.3,4.2 -3.8,5.3 -.1,7 h -1 l .9,1.9 1.1,.8 .6,-1 -.7,-1.7 4.6,-.5 .2,1.2 1.1,.2 .4,-.9 -.6,-1.3 .3,-.8 1.3,.8 1.7,-.4 1.7,.6 3.4,2.1 1.8,-2.8 3.5,-2.2 3,3.3 1.6,-2.1 .3,-2.7 3.8,-2.3 .2,1.3 1.9,1.2 3,-.2 1.2,-.7 .1,-3.4 2.5,-3.7 4.6,-4.4 -.1,-1.7 1.2,-3.8 2.2,1 6.7,-4.5 -.4,-1.7 -1.5,-2.1 1,-1.9 -6.6,-57.2 -.1,-1.4 -32.4,3.4 z"
                >
                  <title>Indiana</title>
                </path>

                <path
                  className="ia"
                  d="m 556.9,183 2.1,1.6 .6,1.1 -1.6,3.3 -.1,2.5 2,5.5 2.7,1.5 3.3,.7 1.3,2.8 -.5,.6 2.5,1.3 1.7,1.7 -.2,1.6 .9,1.1 h 1.2 l 2.8,3.5 .1,2.6 -1.3,3.2 -1.1,1.3 -.1,2.4 -1.7,2.2 -4.2,1.8 h -2.4 l -3,.8 -1,4 1.1,1.6 1,.3 .9,1.4 -.1,3.5 -.5,.5 -1.7,2.4 v 2.4 l -1,1.2 -.9,.3 -1.8,.6 -1,1.5 .7,.9 -.1,2.3 -.7,.7 -1.5,-.8 -1.1,-1.1 -.6,-1.6 -1.7,-1.3 -14.3,.8 -27.2,1.2 -25.9,-.1 -1.8,-4.4 .7,-2.2 -.8,-3.3 .2,-2.9 -1.3,-.7 -.4,-6.1 -2.8,-5 -.2,-3.7 -2.2,-4.3 -1.3,-3.7 v -1.4 l -.6,-1.7 v -2.3 l -.5,-.9 -.7,-1.7 -.3,-1.3 -1.3,-1.2 1,-4.3 1.7,-5.1 -.7,-2 -1.3,-.4 -.4,-1.6 1,-.5 .1,-1.1 -1.3,-1.5 .1,-1.6 2.2,.1 h 28.2 l 36.3,-.9 18.6,-.7 z"
                >
                  <title>Iowa</title>
                </path>

                <path
                  className="ks"
                  d="m 459.1,259.5 -43.7,-1.2 -36,-2 -4.8,67 67.7,2.9 62,.1 -.5,-48.1 -3.2,-.7 -2.6,-4.7 -2.5,-2.5 .5,-2.3 2.7,-2.6 .1,-1.2 -1.5,-2.1 -.9,1 -2,-.6 -2.9,-3 z"
                >
                  <title>Kansas</title>
                </path>

                <path
                  className="ky"
                  d="m 692.1,322.5 -20.5,1.4 -5.2,.8 -17.4,1 -2.6,.8 -22.6,2 -.7,-.6 h -3.7 l 1.2,3.2 -.6,.9 -23.3,1.5 1,-2.7 1.4,.9 .7,-.4 1.2,-4.1 -1,-1 1,-2 .2,-.9 -1.3,-.8 -.3,-1.8 4,-3.7 6.9,3 1.5,-.3 .4,-2.4 -1.7,-1.8 .4,-3.3 1,-.5 1.2,.6 .6,-1.2 3.7,-.6 .1,-.9 -1.5,-2.2 -.1,-1.1 2.2,-2.7 0,-.9 1.1,.8 .6,-1 -.7,-1.7 4.6,-.5 .2,1.2 1.1,.2 .4,-.9 -.6,-1.3 .3,-.8 1.3,.8 1.7,-.4 1.7,.6 3.4,2.1 1.8,-2.8 3.5,-2.2 3,3.3 1.6,-2.1 .3,-2.7 3.8,-2.3 .2,1.3 1.9,1.2 3,-.2 1.2,-.7 .1,-3.4 2.5,-3.7 4.6,-4.4 -.1,-1.7 1.2,-3.8 2.2,1 6.7,-4.5 -.4,-1.7 -1.5,-2.1 1,-1.9 1.3,.5 2.2,.1 1.9,-.8 2.9,1.2 2.2,3.4 v 1 l 4.1,.7 2.3,-.2 1.9,2.1 2.2,.2 v -1 l 1.9,-.8 3,.8 1.2,.8 1.3,-.7 h .9 l .6,-1.7 3.4,-1.8 .5,.8 .8,2.9 3.5,1.4 1.2,2.1 -.1,1.1 .6,1 -.6,3.6 1.9,1.6 .8,1.1 1,.6 -.1,.9 4.4,5.6 h 1.4 l 1.5,1.8 1.2,.3 1.4,-.1 -4.9,6.6 -2.9,1 -3,3 -.4,2.2 -2.1,1.3 -.1,1.7 -1.4,1.4 -1.8,.5 -.5,1.9 -1,.4 -6.9,4.2 z m -98,11.3 -.7,-.7 .2,-1 h 1.1 l .7,.7 -.3,1 z"
                >
                  <title>Kentucky</title>
                </path>

                <path
                  className="la"
                  d="m 602.5,472.8 -1.2,-1.8 .3,-1.3 -4.8,-6.8 .9,-4.6 1,-1.4 .1,-1.4 -36,2 1.7,-11.9 2.4,-4.8 6,-8.4 -1.8,-2.5 h 2 v -3.3 l -2.4,-2.5 .5,-1.7 -1.2,-1 -1.6,-7.1 .6,-1.4 -52.3,1.3 .5,19.9 .7,3.4 2.6,2.8 .7,5.4 3.8,4.6 .8,4.3 h 1 l -.1,7.3 -3.3,6.4 1.3,2.3 -1.3,1.5 .7,3 -.1,4.3 -2.2,3.5 -.1,.8 -1.7,1.2 1,1.8 1.2,1.1 1.6,-1.3 5.3,-.9 6.1,-.1 9.6,3.8 8,1 1.5,-1.4 1.8,-.2 4.8,2.2 1.6,-.4 1.1,-1.5 -4.2,-1.8 -2.2,1 -1.1,-.2 -1.4,-2 3.3,-2.2 1.6,-.1 v 1.7 l 1.5,-.1 3.4,-.3 .4,2.3 1.1,.4 .6,1.9 4.8,1 1.7,1.6 v .7 h -1.2 l -1.5,1.7 1.7,1.2 5.4,1 2.7,2.8 4.4,-1 -3.7,.2 -.1,-.6 2.8,-.7 .2,-1.8 1.2,-.3 v -1.4 l 1.1,.1 v 1.6 l 2.5,.1 .8,-1.9 .9,.3 .2,2.5 1.2,.2 -1.8,2 2.6,-.9 2,-1.1 2.9,-3.3 h -.7 l -1.3,1.2 -.4,-.1 -.5,-.8 .9,-1.2 v -2.3 l 1.1,-.8 .7,.7 1,-.8 1,-.1 .6,1.3 -.6,1.9 h 2.4 l 5.1,1.7 .5,1.3 1.6,1.4 2.8,.1 1.3,.7 1.8,-1 .9,-1.7 v -1.7 h -1.4 l -1.2,-1.4 -1.1,-1.1 -3.2,-.9 -2.6,.2 -4.2,-2.4 v -2.3 l 1.3,-1 2.4,.6 -3.1,-1.6 .2,-.8 h 3.6 l 2.6,-3.5 -2.6,-1.8 .8,-1.5 -1.2,-.8 h -.8 l -2,2.1 v 2.1 l -.6,.7 -1.1,-.1 -1.6,-1.4 h -1.3 v -1.5 l .6,-.7 .8,.7 1.7,-1.6 .7,-1.6 .8,-.3 z m -10.3,-2.7 1.9,1 .8,1.1 2.5,.1 1.5,.8 .2,1.4 -.4,.6 -.9,-1.5 -1.4,1.2 -.9,1.4 -2.8,.8 -1.6,.1 -3.7,-1 .1,-1.7 2,-2 1.1,-2.4 z m -4.7,1.2 v 1.1 l -1.8,2 h -1.2 v -2.2 l 1.6,-1.5 z"
                >
                  <title>Louisiana</title>
                </path>

                <path
                  className="me"
                  d="m 875,128.7 .6,4 3.2,2 .8,2.2 2.3,1.4 1.4,-.3 1,-3 -.8,-2.9 1.6,-.9 .5,-2.8 -.6,-1.3 3.3,-1.9 -2.2,-2.3 .9,-2.4 1.4,-2.2 .5,3.2 1.6,-2 1.3,.9 1.2,-.8 v -1.7 l 3.2,-1.3 .3,-2.9 2.5,-.2 2.7,-3.7 v -.7 l -.9,-.5 -.1,-3.3 .6,-1.1 .2,1.6 1,-.5 -.2,-3.2 -.9,.3 -.1,1.2 -1.2,-1.4 .9,-1.4 .6,.1 1.1,-.4 .5,2.8 2,-.3 2.9,.7 v -1 l -1.1,-1.2 1.3,.1 .1,-2.3 .6,.8 .3,1.9 2.1,1.5 .2,-1 .9,-.2 -.3,-.8 .8,-.6 -.1,-1.6 -1.6,-.2 -2,.7 1.4,-1.6 .7,-.8 1.3,-.2 .4,1.3 1.7,1.6 .4,-2.1 2.3,-1.2 -.9,-1.3 .1,-1.7 1.1,.5 h .7 l 1.7,-1.4 .4,-2.3 2.2,.3 .1,-.7 .2,-1.6 .5,1.4 1.5,-1 2.3,-4.1 -.1,-2.2 -1.4,-2 -3,-3.2 h -1.9 l -.8,2.2 -2.9,-3 .3,-.8 v -1.5 l -1.6,-4.5 -.8,-.2 -.7,.4 h -4.8 l -.3,-3.6 -8.1,-26 -7.3,-3.7 -2.9,-.1 -6.7,6.6 -2.7,-1 -1,-3.9 h -2.7 l -6.9,19.5 .7,6.2 -1.7,2.4 -.4,4.6 1.3,3.7 .8,.2 v 1.6 l -1.6,4.5 -1.5,1.4 -1.3,2.2 -.4,7.8 -2.4,-1 -1.5,.4 z m 34.6,-24.7 -1,.8 v 1.3 l .7,-.8 .9,.8 .4,-.5 1.1,.2 -1,-.8 .4,-.8 z m -1.7,2.6 -1,1.1 .5,.4 -.1,1 h 1.1 v -1.8 z m -3,-1.6 .9,1.3 1,.5 .3,-1 v -1.8 l -1.3,-.7 -.4,1.2 z m -1,5 -1.7,-1.7 1.6,-2.4 .8,.3 .2,1.1 1,.8 v 1.1 l -1,1 z"
                >
                  <title>Maine</title>
                </path>

                <path
                  className="md"
                  d="m 822.9,269.3 0,-1.7 h -.8 l 0,1.8 z m 11.8,-3.9 1.2,-2.2 .1,-2.5 -.6,-.6 -.7,.9 -.2,2.1 -.8,1.4 -.3,1.1 -4.6,1.6 -.7,.8 -1.3,.2 -.4,.9 -1.3,.6 -.3,-2.5 .4,-.7 -.8,-.5 .2,-1.5 -1.6,1 v -2 l 1.2,-.3 -1.9,-.4 -.7,-.8 .4,-1.3 -.8,-.6 -.7,1.6 .5,.8 -.7,.6 -1.1,.5 -2,-1 -.2,-1.2 -1,-1.1 -1.4,-1.7 1.5,-.8 -1,-.6 v -.9 l .6,-1 1.7,-.3 -1.4,-.6 -.1,-.7 -1.3,-.1 -.4,1.1 -.6,.3 .1,-3.4 1,-1 .8,.7 .1,-1.6 -1,-.9 -.9,1.1 -1,1.4 -.6,-1 .2,-2.4 .9,-1 .9,.9 1.2,-.7 -.4,-1.7 -1,1 -.9,-2.1 -.2,-1.7 1.1,-2.4 1.1,-1.4 1.4,-.2 -.5,-.8 .5,-.6 -.3,-.7 .2,-2.1 -1.5,.4 -.8,1.1 1,1.3 -2.6,3.6 -.9,-.4 -.7,.9 -.6,2.2 -1.8,.5 1.3,.6 1.3,1.3 -.2,.7 .9,1.2 -1.1,1 .5,.3 -.5,1.3 v 2.1 l -.5,1.3 .9,1.1 .7,3.4 1.3,1.4 1.6,1.4 .4,2.8 1.6,2 .4,1.4 v 1 h -.7 l -1.5,-1.2 -.4,.2 -1.2,-.2 -1.7,-1.4 -1.4,-.3 -1,.5 -1.2,-.3 -.4,.2 -1.7,-.8 -1,-1 -1,-1.3 -.6,-.2 -.8,.7 -1.6,1.3 -1.1,-.8 -.4,-2.3 .8,-2.1 -.3,-.5 .3,-.4 -.7,-1 1,-.1 1,-.9 .4,-1.8 1.7,-2.6 -2.6,-1.8 -1,1.7 -.6,-.6 h -1 l -.6,-.1 -.4,-.4 .1,-.5 -1.7,-.6 -.8,.3 -1.2,-.1 -.7,-.7 -.5,-.2 -.2,-.7 .6,-.8 v -.9 l -1.2,-.2 -1,-.9 -.9,.1 -1.6,-.3 -.9,-.4 .2,-1.6 -1,-.5 -.2,-.7 h -.7 l -.8,-1.2 .2,-1 -2.6,.4 -2.2,-1.6 -1.4,.3 -.9,1.4 h -1.3 l -1.7,2.9 -3.3,.4 -1.9,-1 -2.6,3.8 -2.2,-.3 -3.1,3.9 -.9,1.6 -1.8,1.6 -1.7,-11.4 60.5,-11.8 7.6,27.1 10.9,-2.3 0,5.3 -.1,3.1 -1,1.8 z m -13.4,-1.8 -1.3,.9 .8,1.8 1.7,.8 -.4,-1.6 z"
                >
                  <title>Maryland</title>
                </path>

                <path
                  className="ma"
                  d="m 899.9,174.2 h 3.4 l .9,-.6 .1,-1.3 -1.9,-1.8 .4,1 -1.5,1.5 h -2.3 l .1,.8 z m -9,1.8 -1.2,-.6 1,-.8 .6,-2.1 1.2,-1 .8,-.2 .6,.9 1.1,.2 .6,-.6 .5,1.9 -1.3,.3 -2.8,.7 z m -34.9,-23.4 18.4,-3.8 1,-1.5 .3,-1.7 1.9,-.6 .5,-1.1 1.7,-1.1 1.3,.3 1.7,3.3 1,.4 1.1,-1.3 .8,1.3 v 1.1 l -3,2.4 .2,.8 -.9,1 .4,.8 -1.3,.3 .9,1.2 -.8,.7 .6,1 .9,-.2 .3,-.8 1.1,.6 h 1.8 l 2.5,2.6 .2,2.6 1.8,.1 .8,1.1 .6,2 1,.7 h 1.9 l 1.9,-.1 .8,-.9 1.6,-1.2 1.1,-.3 -1.2,-2.1 -.3,.9 -1.5,-3.6 h -.8 l -.4,.9 -1.2,-1 1.3,-1.1 1.8,.4 2.3,2.1 1.3,2.7 1.2,3.3 -1,2.8 v -1.8 l -.7,-1 -3.5,2.3 -.9,-.3 -1.6,1 -.1,1.2 -2.2,1.2 -2,2.1 -2,1.9 h -1.2 l 3.3,-3.3 .5,-1.9 -.5,-.6 -.3,-1.3 -.9,-.1 -.1,1.3 -1,1.2 h -1.2 l -.3,1.1 .4,1.2 -1.2,1.1 -1.1,-.2 -.4,1 -1.4,-3 -1.3,-1.1 -2.6,-1.3 -.6,-2.2 h -.8 l -.7,-2.6 -6.5,2 -.1,-.3 -14.9,3.4 v .7 l -.9,.3 -.5,-.7 -10.5,2.4 -.7,-1 .5,-15 z"
                >
                  <title>Massachusetts</title>
                </path>

                <path
                  className="mi"
                  d="m 663.3,209.8 .1,1.4 21.4,-3.5 .5,-1.2 3.9,-5.9 v -4.3 l .8,-2.1 2.2,-.8 2,-7.8 1,-.5 1,.6 -.2,.6 -1.1,.8 .3,.9 .8,.4 1.9,-1.4 .4,-9.8 -1.6,-2.3 -1.2,-3.7 v -2.5 l -2.3,-4.4 v -1.8 l -1.2,-3.3 -2.3,-3 -2.9,-1 -4.8,3 -2.5,4.6 -.2,.9 -3,3.5 -1.5,-.2 -2.9,-2.8 -.1,-3.4 1.5,-1.9 2,-.2 1.2,-1.7 .2,-4 .8,-.8 1.1,-.1 .9,-1.7 -.2,-9.6 -.3,-1.3 -1.2,-1.2 -1.7,-1 -.1,-1.8 .7,-.6 1.8,.8 -.3,-1.7 -1.9,-2.7 -.7,-1.6 -1.1,-1.1 h -2.2 l -8.1,-2.9 -1.4,-1.7 -3.1,-.3 -1.2,.3 -4.4,-2.3 h -1.4 l .5,1 -2.7,-.1 .1,.6 .6,.6 -2.5,2.1 .1,1.8 1.5,2.3 1.5,.2 v .6 l -1.5,.5 -2.1,-.1 -2.8,2.5 .1,2.5 .4,5.8 -2.2,3.4 .8,-4.5 -.8,-.6 -.9,5.3 -1,-2.3 .5,-2.3 -.5,-1 .6,-1.3 -.6,-1.1 1,-1 v -1.2 l -1.3,.6 -1.3,3.1 -.7,.7 -1.3,2.4 -1.7,-.2 -.1,1.2 h -1.6 l .2,1.5 .2,2 -3,1.2 .1,1.3 1,1.7 -.1,5.2 -1.3,4.4 -1.7,2.5 1.2,1.4 .8,3.5 -1,2.5 -.2,2.1 1.7,3.4 2.5,4.9 1.2,1.9 1.6,6.9 -.1,8.8 -.9,3.9 -2,3.2 -.9,3.7 -2,3 -1.2,1 z m -95.8,-96.8 3,3.8 17,3.8 1.4,1 4,.8 .7,.5 2.8,-.2 4.9,.8 1.4,1.5 -1,1 .8,.8 3.8,.7 1.2,1.2 .1,4.4 -1.3,2.8 2,.1 1,-.8 .9,.8 -1.1,3.1 1,1.6 1.2,.3 .8,-1.8 2.9,-4.6 1.6,-6 2.3,-2 -.5,-1.6 .5,-.9 1,1.6 -.3,2.2 2.9,-2.2 .2,-2.3 2.1,.6 .8,-1.6 .7,.6 -.7,1.5 -1,.5 -1,2 1.4,1.8 1.1,-.5 -.5,-.7 1,-1.5 1.9,-1.7 h .8 l .2,-2.6 2,-1.8 7.9,-.5 1.9,-3.1 3.8,-.3 3.8,1.2 4.2,2.7 .7,-.2 -.2,-3.5 .7,-.2 4.5,1.1 1.5,-.2 2.9,-.7 1.7,.4 1.8,.1 v -1.1 l -.7,-.9 -1.5,-.2 -1.1,-.8 .5,-1.4 -.8,-.3 -2.6,.1 -.1,-1 1.1,-.8 .6,.8 .5,-1.8 -.7,-.7 .7,-.2 -1.4,-1.3 .3,-1.3 .1,-1.9 h -1.3 l -1.5,1 -1.9,.1 -.5,1.8 -1.9,.2 -.3,-1.2 -2.2,.1 -1,1.2 -.7,-.1 -.2,-.8 -2.6,.4 -.1,-4.8 1,-2 -.7,-.1 -1.8,1.1 h -2.2 l -3.8,2.7 -6.2,.3 -4.1,.8 -1.9,1.5 -1.4,1.3 -2.5,1.7 -.3,.8 -.6,-1.7 -1.3,-.6 v .6 l .7,.7 v 1.3 l -1.5,-.6 h -.6 l -.3,1.2 -2,-1.9 -1.3,-.2 -1.3,1.5 -3.2,-.1 -.5,-1.4 -2,-1.9 -1.3,-1.6 v -.7 l -1.1,-1.4 -2.6,-1.2 -3.3,-.1 -1.1,-.9 h -1.4 l -.7,.4 -2.2,2.2 -.7,1.1 -1,-.7 .2,-1 .8,-2.1 3.2,-5 .8,-.2 1.7,-1.9 .7,-1.6 3,-.6 .8,-.6 -.1,-1 -.5,-.5 -4.5,.2 -2,.5 -2.6,1.2 -1.2,1.2 -1.7,2.2 -1.8,1 -3.3,3.4 -.4,1.6 -7.4,4.6 -4,.5 -1.8,.4 -2.3,3 -1.8,.7 -4.4,2.3 z m 100.7,3.8 3.8,.1 .6,-.5 -.2,-2 -1.7,-1.8 -1.9,.1 -.1,.5 1.1,.4 -1.6,.8 -.3,1 -.6,-.6 -.4,.8 z m -75.1,-41.9 -2.3,.2 -2.7,1.9 -7.1,5.3 .8,1 1.8,.3 2.8,-2 -1.1,-.5 2.3,-1.6 h 1 l 3,-1.9 -.1,-.9 z m 41.1,62.8 v 1 l 2.1,1.6 -.2,-2.4 z m -.7,2.8 1.1,.1 v .9 h -1 z m 21.4,-21.3 v .9 l .8,-.2 v -.5 z m 4.7,3.1 -.1,-1.1 -1.6,-.2 -.6,-.4 h -.9 l -.4,.3 .9,.4 1.1,1.1 z m -18,1.2 -.1,1.1 -.3,.7 .2,2.2 .4,.3 .7,.1 .5,-.9 .1,-1.6 -.3,-.6 -.1,-1.1 z"
                >
                  <title>Michigan</title>
                </path>

                <path
                  className="mn"
                  d="m 464.7,68.6 -1.1,2.8 .8,1.4 -.3,5.1 -.5,1.1 2.7,9.1 1.3,2.5 .7,14 1,2.7 -.4,5.8 2.9,7.4 .3,5.8 -.1,2.1 -.1,2.2 -.9,2 -3.1,1.9 -.3,1.2 1.7,2.5 .4,1.8 2.6,.6 1.5,1.9 -.2,39.5 h 28.2 l 36.3,-.9 18.6,-.7 -1.1,-4.5 -.2,-3 -2.2,-3 -2.8,-.7 -5.2,-3.6 -.6,-3.3 -6.3,-3.1 -.2,-1.3 h -3.3 l -2.2,-2.6 -2,-1.3 .7,-5.1 -.9,-1.6 .5,-5.4 1,-1.8 -.3,-2.7 -1.2,-1.3 -1.8,-.3 v -1.7 l 2.8,-5.8 5.9,-3.9 -.4,-13 .9,.4 .6,-.5 .1,-1.1 .9,-.6 1.4,1.2 .7,-.1 v 0 l -1.2,-2.2 4.3,-3.1 3.1,-3.7 1.6,-.8 4.7,-5.9 6.3,-5.8 3.9,-2.1 6.3,-2.7 7.6,-4.5 -.6,-.4 -3.7,.7 -2.8,.1 -1,-1.6 -1.4,-.9 -9.8,1.2 -1,-2.8 -1.6,-.1 -1.7,.8 -3.7,3.1 h -4.1 l -2.1,-1 -.3,-1.7 -3.9,-.8 -.6,-1.6 -.7,-1.3 -1,.9 -2.6,.1 -9.9,-5.5 h -2.9 l -.8,-.7 -3.1,1.3 -.8,1.3 -3.3,.8 -1.3,-.2 v -1.7 l -.7,-.9 h -5.9 l -.4,-1.4 h -2.6 l -1.1,.4 -2.4,-1.7 .3,-1.4 -.6,-2.4 -.7,-1.1 -.2,-3 -1,-3.1 -2.1,-1.6 h -2.9 l .1,8 -30.9,-.4 z"
                >
                  <title>Minnesota</title>
                </path>

                <path
                  className="ms"
                  d="m 623.8,468.6 -5,.1 -2.4,-1.5 -7.9,2.5 -.9,-.7 -.5,.2 -.1,1.6 -.6,.1 -2.6,2.7 -.7,-.1 -.6,-.7 -1.2,-1.8 .3,-1.3 -4.8,-6.8 .9,-4.6 1,-1.4 .1,-1.4 -36,2 1.7,-11.9 2.4,-4.8 6,-8.4 -1.8,-2.5 h 2 v -3.3 l -2.4,-2.5 .5,-1.7 -1.2,-1 -1.6,-7.1 .6,-1.4 1.2,-1.5 .5,-3 -1.5,-2.3 -.5,-2.2 .9,-.7 v -.8 l -1.7,-1.1 -.1,-.7 1.6,-.9 -1.2,-1.1 1.7,-7.1 3.4,-1.6 v -.8 l -1.1,-1.4 2.9,-5.4 h 1.9 l 1.5,-1.2 -.3,-5.2 3.1,-4.5 1.8,-.6 -.5,-3.1 38.3,-2.6 1.3,2 -1.3,67 4.4,33.2 z"
                >
                  <title>Mississippi</title>
                </path>

                <path
                  className="mo"
                  d="m 555.3,248.9 -1.1,-1.1 -.6,-1.6 -1.7,-1.3 -14.3,.8 -27.2,1.2 -25.9,-.1 1.3,1.3 -.3,1.4 2.1,3.7 3.9,6.3 2.9,3 2,.6 .9,-1 1.5,2.1 -.1,1.2 -2.7,2.6 -.5,2.3 2.5,2.5 2.6,4.7 3.2,.7 .5,48.1 .2,10.8 39.1,-.7 39.8,-2 1.6,2.5 v 2.2 l -1.7,1.5 -2.8,5.1 11.2,-.8 1,-2 1.2,-.5 v -.7 l -1.2,-1.1 -.6,-1 1.7,.2 .8,-.7 -1.4,-1.5 1.4,-.5 .1,-1 -.6,-1 v -1.3 l -.7,-.7 .2,-1 h 1.1 l .7,.7 -.3,1 .8,.7 .8,-1 1,-2.7 1.4,.9 .7,-.4 1.2,-4.1 -1,-1 1,-2 .2,-.9 -1.3,-.8 h -2.8 l -1.4,-1.5 -1.8,-3.8 v -1.9 l .8,-.6 .1,-1.3 -1.7,-1.9 -.9,-2.5 -2.7,-4.1 -4.8,-1.3 -7.4,-7.1 -.4,-2.4 2.8,-7.6 -.4,-1.9 1.2,-1.1 v -1.3 l -2.8,-1.5 -3,-.7 -3.4,1.2 -1.3,-2.3 .6,-1.9 -.7,-2.4 -8.6,-8.4 -2.2,-1.5 -2.5,-5.9 -1.2,-5.4 1.4,-3.7 z"
                >
                  <title>Missouri</title>
                </path>

                <path
                  className="mt"
                  d="m 247,130.5 57.3,7.9 51,5.3 2,-20.7 5.2,-66.7 -53.5,-5.6 -54.3,-7.7 -65.9,-12.5 -4.8,22 3.7,7.4 -1.6,4.8 3.6,4.8 1.9,.7 3.9,8.3 v 2.1 l 2.3,3 h .9 l 1.4,2.1 h 3.2 v 1.6 l -7.1,17 -.5,4.1 1.4,.5 1.6,2.6 2.8,-1.4 3.6,-2.4 1.9,1.9 .5,2.5 -.5,3.2 2.5,9.7 2.6,3.5 2.3,1.4 .4,3 v 4.1 l 2.3,2.3 1.6,-2.3 6.9,1.6 2.1,-1.2 9,1.7 2.8,-3.3 1.8,-.6 1.2,1.8 1.6,4.1 .9,.1 z"
                >
                  <title>Montana</title>
                </path>

                <path
                  className="ne"
                  d="m 402.5,191.1 38,1.6 3.4,3.2 1.7,.2 2.1,2 1.8,-.1 1.8,-2 1.5,.6 1,-.7 .7,.5 .9,-.4 .7,.4 .9,-.4 1,.5 1.4,-.6 2,.6 .6,1.1 6.1,2.2 1.2,1.3 .9,2.6 1.8,.7 1.5,-.2 .5,.9 v 2.3 l .6,1.7 v 1.4 l 1.3,3.7 2.2,4.3 .2,3.7 2.8,5 .4,6.1 1.3,.7 -.2,2.9 .8,3.3 -.7,2.2 1.8,4.4 1.3,1.3 -.3,1.4 2.1,3.7 3.9,6.3 h -32.4 l -43.7,-1.2 -36,-2 1.4,-22.1 -33.1,-2.4 3.7,-44.2 z"
                >
                  <title>Nebraska</title>
                </path>

                <path
                  className="nv"
                  onClick={() => setStoresFunction(storesNV, "NV")}
                  d="m 167.6,296.8 -3.4,17.5 -2.4,2.9 h -2 l -1.2,-2.7 -3.7,-1.4 -3.5,.6 -1,13.6 .5,4.9 -.5,2.9 -1.4,3 -70.4,-105 -1.1,-3.5 16.4,-63.1 47,11.2 24.4,5.4 23.3,4.7 z"
                >
                  <title>Nevada</title>
                </path>

                <path
                  className="nh"
                  d="m 862.6,93.6 -1.3,.1 -1,-1.1 -1.9,1.4 -.5,6.1 1.2,2.3 -1.1,3.5 2.1,2.8 -.4,1.7 .1,1.3 -1.1,2.1 -1.4,.4 -.6,1.3 -2.1,1 -.7,1.5 1.4,3.4 -.5,2.5 .5,1.5 -1,1.9 .4,1.9 -1.3,1.9 .2,2.2 -.7,1.1 .7,4.5 .7,1.5 -.5,2.6 .9,1.8 -.2,2.5 -.5,1.3 -.1,1.4 2.1,2.6 18.4,-3.8 1,-1.5 .3,-1.7 1.9,-.6 .5,-1.1 1.7,-1.1 1.3,.3 .8,-4.8 -2.3,-1.4 -.8,-2.2 -3.2,-2 -.6,-4 -11.9,-36.8 z"
                >
                  <title>New Hampshire</title>
                </path>

                <path
                  className="nj"
                  d="m 842.5,195.4 -14.6,-4.9 -1.8,2.5 .1,2.2 -3,5.4 1.5,1.8 -.7,2 -1,1 .5,3.6 2.7,.9 1,2.8 2.1,1.1 4.2,3.2 -3.3,2.6 -1.6,2.3 -1.8,3 -1.6,.6 -1.4,1.7 -1,2.2 -.3,2.1 .8,.9 .4,2.3 1.2,.6 2.4,1.5 1.8,.8 1.6,.8 .1,1.1 .8,.1 1.1,-1.2 .8,.4 2.1,.2 -.2,2.9 .2,2.5 1.8,-.7 1.5,-3.9 1.6,-4.8 2.9,-2.8 .6,-3.5 -.6,-1.2 1.7,-2.9 v -1.2 l -.7,-1.1 1.2,-2.7 -.3,-3.6 -.6,-8.2 -1.2,-1.4 v 1.4 l .5,.6 h -1.1 l -.6,-.4 -1.3,-.2 -.9,.6 -1.2,-1.6 .7,-1.7 v -1 l 1.7,-.7 .8,-2.1 z"
                >
                  <title>New Jersey</title>
                </path>

                <path
                  className="nm"
                  d="m 357.5,332.9 h -.8 l -7.9,99.3 -31.8,-2.6 -34.4,-3.6 -.3,3 2,2.2 -30.8,-4.1 -1.4,10.2 -15.7,-2.2 17.4,-124.1 52.6,6.5 51.7,4.8 z"
                >
                  <title>New Mexico</title>
                </path>

                <path
                  className="ny"
                  onClick={() => setStoresFunction(storesNY, "NY")}
                  d="m 872.9,181.6 -1.3,.1 -.5,1 z m -30.6,22.7 .7,.6 1.3,-.3 1.1,.3 .9,-1.3 h 1.9 l 2.4,-.9 5.1,-2.1 -.5,-.5 -1.9,.8 -2,.9 .2,-.8 2.6,-1.1 .8,-1 1.2,.1 4.1,-2.3 v .7 l -4.2,3 4.5,-2.8 1.7,-2.2 1.5,-.1 4.5,-3.1 3.2,-3.1 3,-2.3 1,-1.2 -1.7,-.1 -1,1.2 -.2,.7 -.9,.7 -.8,-1.1 -1.7,1 -.1,.9 -.9,-.2 .5,-.9 -1.2,-.7 -.6,.9 .9,.3 .2,.5 -.3,.5 -1.4,2.6 h -1.9 l .9,-1.8 .9,-.6 .3,-1.7 1.4,-1.6 .9,-.8 1.5,-.7 -1.2,-.2 -.7,.9 h -.7 l -1.1,.8 -.2,1 -2.2,2.1 -.4,.9 -1.4,.9 -7.7,1.9 .2,.9 -.9,.7 -2,.3 -1,-.6 -.2,1.1 -1.1,-.4 .1,1 -1.2,-.1 -1.2,.5 -.2,1.1 h -1 l .2,1 h -.7 l .2,1 -1.8,.4 -1.5,2.3 z m -.8,-.4 -1.6,.4 v 1 l -.7,1.6 .6,.7 2.4,-2.3 -.1,-.9 z m -10.1,-95.2 -.6,1.9 1.4,.9 -.4,1.5 .5,3.2 2.2,2.3 -.4,2.2 .6,2 -.4,1 -.3,3.8 3.1,6.7 -.8,1.8 .9,2.2 .9,-1.6 1.9,1.5 3,14.2 -.5,2 1.1,1 -.5,15 .7,1 2.8,16.3 1.8,1.5 -3.5,3.4 1.7,2.2 -1.3,3.3 -1.5,1.7 -1.5,2.3 -.2,-.7 .4,-5.9 -14.6,-4.9 -1.6,-1.1 -1.9,.3 -3,-2.2 -3,-5.8 h -2 l -.4,-1.5 -1.7,-1.1 -70.5,13.9 -.8,-6 4.3,-3.9 .6,-1.7 3.9,-2.5 .6,-2.4 2.3,-2 .8,-1.1 -1.7,-3.3 -1.7,-.5 -1.8,-3 -.2,-3.2 7.6,-3.9 8.2,-1.6 h 4.4 l 3.2,1.6 .9,-.1 1.8,-1.6 3.4,-.7 h 3 l 2.6,-1.3 2.5,-2.6 2.4,-3.1 1.9,-.4 1.1,-.5 .4,-3.2 -1.4,-2.7 -1.2,-.7 2,-1.3 -.1,-1.8 h -1.5 l -2.3,-1.4 -.1,-3.1 6.2,-6.1 .7,-2.4 3.7,-6.3 5.9,-6.4 2.1,-1.7 2.5,.1 20.6,-5.2 z"
                >
                  <title>New York</title>
                </path>

                <path
                  className="nc"
                  d="m 829,300.1 -29.1,6.1 -39.4,7.3 -29.4,3.5 v 5.2 l -1.5,-.1 -1.4,1.2 -2.4,5.2 -2.6,-1.1 -3.5,2.5 -.7,2.1 -1.5,1.2 -.8,-.8 -.1,-1.5 -.8,-.2 -4,3.3 -.6,3.4 -4.7,2.4 -.5,1.2 -3.2,2.6 -3.6,.5 -4.6,3 -.8,4.1 -1.3,.9 -1.5,-.1 -1.4,1.3 -.1,4.9 21.4,-3 4.4,-1.9 1.3,-.1 7.3,-4.3 23.2,-2.2 .4,.5 -.2,1.4 .7,.3 1.2,-1.5 3.3,3 .1,2.6 19.7,-2.8 24.5,17.1 4,-2.2 3,-.7 h 1.7 l 1.1,1.1 .8,-2 .6,-5 1.7,-3.9 5.4,-6.1 4.1,-3.5 5.4,-2.3 2.5,-.4 1.3,.4 .7,1.1 3.3,-6.6 3.3,-5.3 -.7,-.3 -4.4,6.8 -.5,-.8 2,-2.2 -.4,-1.5 -2,-.5 1,1.3 -1.2,.1 -1.2,-1.8 -1.2,2 -1.6,.2 1,-2.7 .7,-1.7 -.2,-2.9 -2.2,-.1 .9,-.9 1.1,.3 2.7,.1 .8,-.5 h 2.3 l 2,-1.9 .2,-3.2 1.3,-1.4 1.2,-.2 1.3,-1 -.5,-3.7 -2.2,-3.8 -2.7,-.2 -.9,1.6 -.5,-1 -2.7,.2 -1.2,.4 -1.9,1.2 -.3,-.4 h -.9 l -1.8,1.2 -2.6,.5 v -1.3 l .8,-1 1,.7 h 1 l 1.7,-2.1 3.7,-1.7 2,-2.2 h 2.4 l .8,1.3 1.7,.8 -.5,-1.5 -.3,-1.6 -2.8,-3.1 -.3,-1.4 -.4,1 -.9,-1.3 z m 7,31 2.7,-2.5 4.6,-3.3 v -3.7 l -.4,-3.1 -1.7,-4.2 1.5,1.4 1,3.2 .4,7.6 -1.7,.4 -3.1,2.4 -3.2,3.2 z m 1.9,-19.3 -.9,-.2 v 1 l 2.5,2.2 -.2,-1.4 z m 2.9,2.1 -1.4,-2.8 -2.2,-3.4 -2.4,-3 -2.2,-4.3 -.8,-.7 2.2,4.3 .3,1.3 3.4,5.5 1.8,2.1 z"
                >
                  <title>North Carolina</title>
                </path>

                <path
                  className="nd"
                  d="m 464.7,68.6 -1.1,2.8 .8,1.4 -.3,5.1 -.5,1.1 2.7,9.1 1.3,2.5 .7,14 1,2.7 -.4,5.8 2.9,7.4 .3,5.8 -.1,2.1 -29.5,-.4 -46,-2.1 -39.2,-2.9 5.2,-66.7 44.5,3.4 55.3,1.6 z"
                >
                  <title>North Dakota</title>
                </path>

                <path
                  className="oh"
                  d="m 685.7,208.8 1.9,-.4 3,1.3 2.1,.6 .7,.9 h 1 l 1,-1.5 1.3,.8 h 1.5 l -.1,1 -3.1,.5 -2,1.1 1.9,.8 1.6,-1.5 2.4,-.4 2.2,1.5 1.5,-.1 2.5,-1.7 3.6,-2.1 5.2,-.3 4.9,-5.9 3.8,-3.1 9.3,-5.1 4.9,29.9 -2.2,1.2 1.4,2.1 -.1,2.2 .6,2 -1.1,3.4 -.1,5.4 -1,3.6 .5,1.1 -.4,2.2 -1.1,.5 -2,3.3 -1.8,2 h -.6 l -1.8,1.7 -1.3,-1.2 -1.5,1.8 -.3,1.2 h -1.3 l -1.3,2.2 .1,2.1 -1,.5 1.4,1.1 v 1.9 l -1,.2 -.7,.8 -1,.5 -.6,-2.1 -1.6,-.5 -1,2.3 -.3,2.2 -1.1,1.3 1.3,3.6 -1.5,.8 -.4,3.5 h -1.5 l -3.2,1.4 -1.2,-2.1 -3.5,-1.4 -.8,-2.9 -.5,-.8 -3.4,1.8 -.6,1.7 h -.9 l -1.3,.7 -1.2,-.8 -3,-.8 -1.9,.8 v 1 l -2.2,-.2 -1.9,-2.1 -2.3,.2 -4.1,-.7 v -1 l -2.2,-3.4 -2.9,-1.2 -1.9,.8 -2.2,-.1 -1.3,-.5 -6.6,-57.2 21.4,-3.5 z"
                >
                  <title>Ohio</title>
                </path>

                <path
                  className="ok"
                  d="m 501.5,398.6 -4.6,-3.8 -2.2,-.9 -.5,1.6 -5.1,.3 -.6,-1.5 -5,2.5 -1.6,-.7 -3.7,.3 -.6,1.7 -3.6,.9 -1.3,-1.2 -1.2,.1 -2,-1.8 -2.1,.7 -2,-.5 -1.8,-2 -2.5,4.2 -1.2,.8 -1,-1.8 .3,-2 -1.2,-.7 -2.3,2.5 -1.7,-1.2 -.1,-1.5 -1.3,.5 -2.6,-1.7 -3,2.6 -2.3,-1.1 .7,-2.1 -2.3,.1 -1.9,-3 -3.5,-1.1 -2,2.3 -2.3,-2.2 -1.4,.4 -2,.1 -3.5,-1.9 -2.3,.1 -1.2,-.7 -.5,-2.9 -2.3,-1.7 -1.1,1.5 -1.4,-1 -1.2,-.4 -1.1,1 -1.5,-.3 -2.5,-3 -2.7,-1.3 1.4,-42.7 -52.6,-3.2 .6,-10.6 16.5,1 67.7,2.9 62,.1 .2,10.8 4.1,24.4 -.7,39 z"
                >
                  <title>Oklahoma</title>
                </path>

                <path
                  className="or"
                  d="m 93.9,166.5 47,11.2 8.5,-37.3 2.9,-5.8 .4,-2.1 .8,-.9 -.9,-2 -2.9,-1.2 .2,-4.2 4,-5.8 2.5,-.8 1.6,-2.3 -.1,-1.6 1.8,-1.6 3.2,-5.5 4.2,-4.8 -.5,-3.2 -3.5,-3.1 -1.6,-3.6 -30.3,-7.3 -2.8,1 -5.4,-.9 -1.8,-.9 -1.5,1.2 -3.3,-.4 -4.5,.5 -.9,.7 -4.2,-.4 -.8,-1.6 -1.2,-.2 -4.4,1.3 -1.6,-1.1 -2.2,.8 -.2,-1.8 -2.3,-1.2 -1.5,-.2 -1,-1.1 -3,.3 -1.2,-.8 h -1.2 l -1.2,.9 -5.5,.7 -6.6,-4.2 1.1,-5.6 -.4,-4.1 -3.2,-3.7 -3.7,.1 -.4,-1.1 .4,-1.2 -.7,-.8 -1,.1 -1.1,1.3 -1.5,-.2 -.5,-1.1 -1,-.1 -.7,.6 -2,-1.9 v 4.3 l -1.3,1.3 -1.1,3.5 -.1,2.3 -4.5,12.3 -13.2,31.3 -3.2,4.6 -1.6,-.1 .1,2.1 -5.2,7.1 -.3,3.3 1,1.3 .1,2.4 -1.2,1.1 -1.2,3 .1,5.7 1.2,2.9 z"
                >
                  <title>Oregon</title>
                </path>

                <path
                  className="pa"
                  d="m 826.3,189.4 -1.9,.3 -3,-2.2 -3,-5.8 h -2 l -.4,-1.5 -1.7,-1.1 -70.5,13.9 -.8,-6 -4.2,3.4 -.9,.1 -2.7,3 -3.3,1.7 4.9,29.9 3.2,19.7 17.4,-2.9 60.5,-11.8 1.2,-2.1 1.5,-1.1 1.6,-.3 1.6,.6 1.4,-1.7 1.6,-.6 1.8,-3 1.6,-2.3 3.3,-2.6 -4.2,-3.2 -2.1,-1.1 -1,-2.8 -2.7,-.9 -.5,-3.6 1,-1 .7,-2 -1.5,-1.8 3,-5.4 -.1,-2.2 1.8,-2.5 z"
                >
                  <title>Pennsylvania</title>
                </path>

                <path
                  className="ri"
                  d="m 883.2,170.7 -1.3,-1.1 -2.6,-1.3 -.6,-2.2 h -.8 l -.7,-2.6 -6.5,2 3.2,12.3 -.4,1.1 .4,1.8 5.6,-3.6 .1,-3 -.8,-.8 .4,-.6 -.1,-1.3 -.9,-.7 1.2,-.4 -.9,-1.6 1.8,.7 .3,1.4 .7,1.2 -1.4,-.8 1.1,1.7 -.3,1.2 -.6,-1.1 v 2.5 l .6,-.9 .4,.9 1.3,-1.5 -.2,-2.5 1.4,3.1 1,-.9 z m -4.7,12.2 h .9 l .5,-.6 -.8,-1.3 -.7,.7 z"
                >
                  <title>Rhode Island</title>
                </path>

                <path
                  className="sc"
                  d="m 772.3,350.2 -19.7,2.8 -.1,-2.6 -3.3,-3 -1.2,1.5 -.7,-.3 .2,-1.4 -.4,-.5 -23.2,2.2 -7.3,4.3 -1.3,.1 -4.4,1.9 -.1,1.9 -1.9,1 -1.4,3.2 .2,1.3 6.1,3.8 2.6,-.3 3.1,4 .4,1.7 4.2,5.1 2.6,1.7 1.4,.2 2.2,1.6 1.1,2.2 2,1.6 1.8,.5 2.7,2.7 .1,1.4 2.6,2.8 5,2.3 3.6,6.7 .3,2.7 3.9,2.1 2.5,4.8 .8,3.1 4.2,.4 .8,-1.5 h .6 l 1.8,-1.5 .5,-2 3.2,-2.1 .3,-2.4 -1.2,-.9 .8,-.7 .8,.4 1.3,-.4 1.8,-2.1 3.8,-1.8 1.6,-2.4 .1,-.7 4.8,-4.4 -.1,-.5 -.9,-.8 1.1,-1.5 h .8 l .4,.5 .7,-.8 h 1.3 l .6,-1.5 2.3,-2.1 -.3,-5.4 .8,-2.3 3.6,-6.2 2.4,-2.2 2.2,-1.1 z"
                >
                  <title>South Carolina</title>
                </path>

                <path
                  className="sd"
                  d="m 396.5,125.9 46,2.1 29.5,.4 -.1,2.2 -.9,2 -3.1,1.9 -.3,1.2 1.7,2.5 .4,1.8 2.6,.6 1.5,1.9 -.2,39.5 -2.2,-.1 -.1,1.6 1.3,1.5 -.1,1.1 -1,.5 .4,1.6 1.3,.4 .7,2 -1.7,5.1 -1,4.3 1.3,1.2 .3,1.3 .7,1.7 -1.5,.2 -1.8,-.7 -.9,-2.6 -1.2,-1.3 -6.1,-2.2 -.6,-1.1 -2,-.6 -1.4,.6 -1,-.5 -.9,.4 -.7,-.4 -.9,.4 -.7,-.5 -1,.7 -1.5,-.6 -1.8,2 -1.8,.1 -2.1,-2 -1.7,-.2 -3.4,-3.2 -38,-1.6 -51.1,-3.5 3.9,-43.9 2,-20.7 z"
                >
                  <title>South Dakota</title>
                </path>

                <path
                  className="tn"
                  d="m 620.9,365.1 45.7,-4 22.9,-2.9 .1,-4.9 1.4,-1.3 1.5,.1 1.3,-.9 .8,-4.1 4.6,-3 3.6,-.5 3.2,-2.6 .5,-1.2 4.7,-2.4 .6,-3.4 4,-3.3 .8,.2 .1,1.5 .8,.8 1.5,-1.2 .7,-2.1 3.5,-2.5 2.6,1.1 2.4,-5.2 1.4,-1.2 1.5,.1 0,-5.2 .3,-.7 -4.6,.5 -.2,1 -28.9,3.3 -5.6,1.4 -20.5,1.4 -5.2,.8 -17.4,1 -2.6,.8 -22.6,2 -.7,-.6 h -3.7 l 1.2,3.2 -.6,.9 -23.3,1.5 -.8,1 -.8,-.7 h -1 v 1.3 l .6,1 -.1,1 -1.4,.5 1.4,1.5 -.8,.7 -1.7,-.2 .6,1 1.2,1.1 v .7 l -1.2,.5 -1,2 .1,.6 1.4,1 -.4,.7 h -1.5 v .5 l .9,.9 .1,.8 -1.4,.2 -.5,.8 -1.6,.2 -.9,.9 .6,.9 1.1,-.1 .5,.9 -1.6,1.3 .4,1.5 -2,-.6 -.1,.7 .4,1.1 -.3,1.4 -1.3,-.8 -.8,.8 1.1,.1 .1,1.5 -.6,1 1.1,.9 -.3,1.5 .8,.7 -.7,1 -1.2,-.5 -.9,2.2 -1.6,.7 z"
                >
                  <title>Tennessee</title>
                </path>

                <path
                  className="tx"
                  d="m 282.3,429 .3,-3 34.4,3.6 31.8,2.6 7.9,-99.3 .8,0 52.6,3.2 -1.4,42.7 2.7,1.3 2.5,3 1.5,.3 1.1,-1 1.2,.4 1.4,1 1.1,-1.5 2.3,1.7 .5,2.9 1.2,.7 2.3,-.1 3.5,1.9 2,-.1 1.4,-.4 2.3,2.2 2,-2.3 3.5,1.1 1.9,3 2.3,-.1 -.7,2.1 2.3,1.1 3,-2.6 2.6,1.7 1.3,-.5 .1,1.5 1.7,1.2 2.3,-2.5 1.2,.7 -.3,2 1,1.8 1.2,-.8 2.5,-4.2 1.8,2 2,.5 2.1,-.7 2,1.8 1.2,-.1 1.3,1.2 3.6,-.9 .6,-1.7 3.7,-.3 1.6,.7 5,-2.5 .6,1.5 5.1,-.3 .5,-1.6 2.2,.9 4.6,3.8 6.4,1.9 2.6,2.3 2.8,-1.3 3.2,.8 .2,11.9 .5,19.9 .7,3.4 2.6,2.8 .7,5.4 3.8,4.6 .8,4.3 h 1 l -.1,7.3 -3.3,6.4 1.3,2.3 -1.3,1.5 .7,3 -.1,4.3 -2.2,3.5 -.1,.8 -1.7,1.2 1,1.8 1.2,1.1 -3.5,.3 -8.4,3.9 -3.5,1.4 -1.8,1.8 -.7,-.5 2.1,-2.3 1.8,-.7 .5,-.9 -2.9,-.1 -.7,-.8 .8,-2 -.9,-1.8 h -.6 l -2.4,1.3 -1.9,2.6 .3,1.7 3.3,3.4 1.3,.3 v .8 l -2.3,1.6 -4.9,4 -4,3.9 -3.2,1.4 -5,3 -3.7,2 -4.5,1.9 -4.1,2.5 3.2,-3 v -1.1 l .6,-.8 -.2,-1.8 -1.5,-.1 -1.1,1.5 -2.6,1.3 -1.8,-1.2 -.3,-1.7 h -1.5 l .8,2.2 1.4,.7 1.2,.9 1.8,1.6 -.7,.8 -3.9,1.7 -1.7,.1 -1.2,-1.2 -.5,2.1 .5,1.1 -2.7,2 -1.5,.2 -.8,.7 -.4,1.7 -1.8,3.3 -1.6,.7 -1.6,-.6 -1.8,1.1 .3,1.4 1.3,.8 1,.8 -1.8,3.5 -.3,2.8 -1,1.7 -1.4,1 -2.9,.4 1.8,.6 1.9,-.6 -.4,3.2 -1.1,-.1 .2,1.2 .3,1.4 -1.3,.9 v 3.1 l 1.6,1.4 .6,3.1 -.4,2.2 -1,.4 .4,1.5 1.1,.4 .8,1.7 v 2.6 l 1.1,2.1 2.2,2.6 -.1,.7 -2.2,-.2 -1.6,1.4 .2,1.4 -.9,-.3 -1.4,-.2 -3.4,-3.7 -2.3,-.6 h -7.1 l -2.8,-.8 -3.6,-3 -1.7,-1 -2.1,.1 -3.2,-2.6 -5.4,-1.6 v -1.3 l -1.4,-1.8 -.9,-4.7 -1.1,-1.7 -1.7,-1.4 v -1.6 l -1.4,-.6 .6,-2.6 -.3,-2.2 -1.3,-1.4 .7,-3 -.8,-3.2 -1.7,-1.4 h -1.1 l -4,-3.5 .1,-1.9 -.8,-1.7 -.8,-.2 -.9,-2.4 -2,-1.6 -2.9,-2.5 -.2,-2.1 -1,-.7 .2,-1.6 .5,-.7 -1.4,-1.5 .1,-.7 -2,-2.2 .1,-2.1 -2.7,-4.9 -.1,-1.7 -1.8,-3.1 -5.1,-4.8 v -1.1 l -3.3,-1.7 -.1,-1.8 -1.2,-.4 v -.7 l -.8,-.2 -2.1,-2.8 h -.8 l -.7,-.6 -1.3,1.1 h -2.2 l -2.6,-1.1 h -4.6 l -4.2,-2.1 -1.3,1.9 -2.2,-.6 -3.3,1.2 -1.7,2.8 -2,3.2 -1.1,4.4 -1.4,1.2 -1.1,.1 -.9,1.6 -1.3,.6 -.1,1.8 -2.9,.1 -1.8,-1.5 h -1 l -2,-2.9 -3.6,-.5 -1.7,-2.3 -1.3,-.2 -2.1,-.8 -3.4,-3.4 .2,-.8 -1.6,-1.2 -1,-.1 -3.4,-3.1 -.1,-2 -2.3,-4 .2,-1.6 -.7,-1.3 .8,-1.5 -.1,-2.4 -2.6,-4.1 -.6,-4.2 -1.6,-1.6 v -1 l -1.2,-.2 -.7,-1.1 -2.4,-1.7 -.9,-.1 -1.9,-1.6 v -1.1 l -2.9,-1.8 -.6,-2.1 -2.6,-2.3 -3.2,-4.4 -3,-1.3 -2.1,-1.8 .2,-1.2 -1.3,-1.4 -1.7,-3.7 -2.4,-1 z m 174.9,138.3 .8,.1 -.6,-4.8 -3.5,-12.3 -.2,-8.1 4.9,-10.5 6.1,-8.2 7.2,-5.1 v -.7 h -.8 l -2.6,1 -3.6,2.3 -.7,1.5 -8.2,11.6 -2.8,7.9 v 8.8 l 3.6,12 z"
                >
                  <title>Texas</title>
                </path>

                <path
                  className="ut"
                  d="m 233.2,217.9 3.3,-21.9 -47.9,-8.2 -21,109 46.2,8.2 40,6 11.5,-88.3 z"
                >
                  <title>Utah</title>
                </path>

                <path
                  className="vt"
                  d="m 859.1,102.4 -1.1,3.5 2.1,2.8 -.4,1.7 .1,1.3 -1.1,2.1 -1.4,.4 -.6,1.3 -2.1,1 -.7,1.5 1.4,3.4 -.5,2.5 .5,1.5 -1,1.9 .4,1.9 -1.3,1.9 .2,2.2 -.7,1.1 .7,4.5 .7,1.5 -.5,2.6 .9,1.8 -.2,2.5 -.5,1.3 -.1,1.4 2.1,2.6 -12.4,2.7 -1.1,-1 .5,-2 -3,-14.2 -1.9,-1.5 -.9,1.6 -.9,-2.2 .8,-1.8 -3.1,-6.7 .3,-3.8 .4,-1 -.6,-2 .4,-2.2 -2.2,-2.3 -.5,-3.2 .4,-1.5 -1.4,-.9 .6,-1.9 -.8,-1.7 27.3,-6.9 z"
                >
                  <title>Vermont</title>
                </path>

                <path
                  className="va"
                  d="m 834.7,265.4 -1.1,2.8 .5,1.1 .4,-1.1 .8,-3.1 z m -34.6,-7 -.7,-1 1,-.1 1,-.9 .4,-1.8 -.2,-.5 .1,-.5 -.3,-.7 -.6,-.5 -.4,-.1 -.5,-.4 -.6,-.6 h -1 l -.6,-.1 -.4,-.4 .1,-.5 -1.7,-.6 -.8,.3 -1.2,-.1 -.7,-.7 -.5,-.2 -.2,-.7 .6,-.8 v -.9 l -1.2,-.2 -1,-.9 -.9,.1 -1.6,-.3 -.4,.7 -.4,1.6 -.5,2.3 -10,-5.2 -.2,.9 .9,1.6 -.8,2.3 .1,2.9 -1.2,.8 -.5,2.1 -.9,.8 -1.4,1.8 -.9,.8 -1,2.5 -2.4,-1.1 -2.3,8.5 -1.3,1.6 -2.8,-.5 -1.3,-1.9 -2.3,-.7 -.1,4.7 -1.4,1.7 .4,1.5 -2.1,2.2 .4,1.9 -3.7,6.3 -1,3.3 1.5,1.2 -1.5,1.9 .1,1.4 -2.3,2 -.7,-1.1 -4.3,3.1 -1.5,-1 -.6,1.4 .8,.5 -.5,.9 -5.5,2.4 -3,-1.8 -.8,1.7 -1.9,1.8 -2.3,.1 -4.4,-2.3 -.1,-1.5 -1.5,-.7 .8,-1.2 -.7,-.6 -4.9,6.6 -2.9,1 -3,3 -.4,2.2 -2.1,1.3 -.1,1.7 -1.4,1.4 -1.8,.5 -.5,1.9 -1,.4 -6.9,4.2 28.9,-3.3 .2,-1 4.6,-.5 -.3,.7 29.4,-3.5 39.4,-7.3 29.1,-6.1 -.6,-1.2 .4,-.1 .9,.9 -.1,-1.4 -.3,-1.9 1.6,1.2 .9,2.1 v -1.3 l -3.4,-5.5 v -1.2 l -.7,-.8 -1.3,.7 .5,1.4 h -.8 l -.4,-1 -.6,.9 -.9,-1.1 -2.1,-.1 -.2,.7 1.5,2.1 -1.4,-.7 -.5,-1 -.4,.8 -.8,.1 -1.5,1.7 .3,-1.6 v -1.4 l -1.5,-.7 -1.8,-.5 -.2,-1.7 -.6,-1.3 -.6,1.1 -1.7,-1 -2,.3 .2,-.9 1.5,-.2 .9,.5 1.7,-.8 .9,.4 .5,1 v .7 l 1.9,.4 .3,.9 .9,.4 .9,1.2 1.4,-1.6 h .6 l -.1,-2.1 -1.3,1 -.6,-.9 1.5,-.2 -1.2,-.9 -1.2,.6 -.1,-1.7 -1.7,.2 -2.2,-1.1 -1.8,-2.2 3.6,2.2 .9,.3 1.7,-.8 -1.7,-.9 .6,-.6 -1,-.5 .8,-.2 -.3,-.9 1.1,.9 .4,-.8 .4,1.3 1.2,.8 .6,-.5 -.5,-.6 -.1,-2.5 -1.1,-.1 -1.6,-.8 .9,-1.1 -2,-.1 -.4,-.5 -1.4,.6 -1.4,-.8 -.5,-1.2 -2.1,-1.2 -2.1,-1.8 -2.2,-1.9 3,1.3 .9,1.2 2.1,.7 2.3,2.5 .2,-1.7 .6,1.3 2.3,.5 v -4 l -.8,-1.1 1.1,.4 .1,-1.6 -3.1,-1.4 -1.6,-.2 -1.3,-.2 .3,-1.2 -1.5,-.3 -.1,-.6 h -1.8 l -.2,.8 -.7,-1 h -2.7 l -1,-.4 -.2,-1 -1.2,-.6 -.4,-1.5 -.6,-.4 -.7,1.1 -.9,.2 -.9,.7 h -1.5 l -.9,-1.3 .4,-3.1 .5,-2.4 .6,.5 z m 21.9,11.6 .9,-.1 0,-.6 -.8,.1 z m 7.5,14.2 -1,2.7 1.2,-1.3 z m -1.8,-15.3 .7,.3 -.2,1.9 -.5,-.5 -1.3,1 1,.4 -1.8,4.4 .1,8.1 1.9,3.1 .5,-1.5 .4,-2.7 -.3,-2.3 .7,-.9 -.2,-1.4 1.2,-.6 -.6,-.5 .5,-.7 .8,1.1 -.2,1.1 -.4,3.9 1.1,-2.2 .4,-3.1 .1,-3 -.3,-2 .6,-2.3 1.1,-1.8 .1,-2.2 .3,-.9 -4.6,1.6 -.7,.8 z"
                >
                  <title>Virginia</title>
                </path>

                <path
                  className="wa"
                  d="m 161.9,83.6 .7,4 -1.1,4.3 -30.3,-7.3 -2.8,1 -5.4,-.9 -1.8,-.9 -1.5,1.2 -3.3,-.4 -4.5,.5 -.9,.7 -4.2,-.4 -.8,-1.6 -1.2,-.2 -4.4,1.3 -1.6,-1.1 -2.2,.8 -.2,-1.8 -2.3,-1.2 -1.5,-.2 -1,-1.1 -3,.3 -1.2,-.8 h -1.2 l -1.2,.9 -5.5,.7 -6.6,-4.2 1.1,-5.6 -.4,-4.1 -3.2,-3.7 -3.7,.1 -.4,-1.1 .4,-1.2 -.7,-.8 -1,.1 -2.1,-1.5 -1.2,.4 -2,-.1 -.7,-1.5 -1.6,-.3 2.5,-7.5 -.7,6 .5,.5 v -2 l .8,-.2 1.1,2.3 -.5,-2.2 1.2,-4.2 1.8,.4 -1.1,-2 -1,.3 -1.5,-.4 .2,-4.2 .2,1.5 .9,.5 .6,-1.6 h 3.2 l -2.2,-1.2 -1.7,-1.9 -1.4,1.6 1.2,-3.1 -.3,-4.6 -.2,-3.6 .9,-6.1 -.5,-2 -1.4,-2.1 .1,-4 .4,-2.7 2,-2.3 -.7,-1.4 .2,-.6 .9,.1 7.8,7.6 4.7,1.9 5.1,2.5 3.2,-.1 .2,3 1,-1.6 h .7 l .6,2.7 .5,-2.6 1.4,-.2 .5,.7 -1.1,.6 .1,1.6 .7,-1.5 h 1.1 l -.4,2.6 -1.1,-.8 .4,1.4 -.1,1.5 -.8,.7 -2.5,2.9 1.2,-3.4 -1.6,.4 -.4,2.1 -3.8,2.8 -.4,1 -2.1,2.2 -.1,1 h 2.2 l 2.4,-.2 .5,-.9 -3.9,.5 v -.6 l 2.6,-2.8 1.8,-.8 1.9,-.2 1,-1.6 3,-2.3 v -1.4 h 1.1 l .1,4 h -1.5 l -.6,.8 -1.1,-.9 .3,1.1 v 1.7 l -.7,.7 -.3,-1.6 -.8,.8 .7,.6 -.9,1.1 h 1.3 l .7,-.5 .1,2 -1,1.9 -.9,1 -.1,1.8 -1,-.2 -.2,-1.4 .9,-1.1 -.8,-.5 -.8,.7 -.7,2.2 -.8,.9 -.1,-2 .8,-1.1 -.2,-1.1 -1.2,1.2 .1,2.2 -.6,.4 -2.1,-.4 -1.3,1.2 2.2,-.6 -.2,2.2 1,-1.8 .4,1.4 .5,-1 .7,1.8 h .7 l .7,-.8 .6,-.1 2,-1.9 .2,-1.2 .8,.6 .3,.9 .7,-.3 .1,-1.2 h 1.3 l .2,-2.9 -.1,-2.7 .9,.3 -.7,-2.1 1.4,-.8 .2,-2.4 2.3,-2.2 1,.1 .3,-1.4 -1.2,-1.4 -.1,-3.5 -.8,.9 .7,2.9 -.6,.1 -.6,-1.9 -.6,-.5 .3,-2.3 1.8,-.1 .3,.7 .3,-1.6 -1.6,-1.7 -.6,-1.6 -.2,2 .9,1.1 -.7,.4 -1,-.8 -1.8,1.3 1.5,.5 .2,2.4 -.3,1.8 .9,-1.3 1.4,2.3 -.4,1.9 h -1.5 v -1.2 l -1.5,-1.2 .5,-3 -1.9,-2.6 2.7,-3 .6,-4.1 h .9 l 1.4,3.2 v -2.6 l 1.2,.3 v -3.3 l -.9,-.8 -1.2,2.5 -1,-3 1.3,-.1 -1.5,-4.9 1.9,-.6 25.4,7.5 31.7,8 23.6,5.5 z m -78.7,-39.4 h .5 l .1,.8 -.5,.3 .1,.6 -.7,.4 -.2,-.9 .5,-.4 z m 5,-4.3 -1.2,1.9 -.1,.8 .4,.2 .5,-.6 1.1,.1 z m -.4,-21.6 .5,.6 1.3,-.3 .2,-1 1.2,-1.8 -1,-.4 -.7,1.6 -.1,-1.6 -1.1,.2 -.7,1.4 z m 3.2,-5.5 .7,1.5 -.9,.2 -.8,.4 -.2,-2.4 z m -2.7,-1.6 -1.1,-.2 .5,1.4 z m -1,2.5 .8,.4 -.4,1.1 1.7,-.5 -.2,-2.2 -.9,-.2 z m -2.7,-.4 .3,2.7 1.6,1.3 .6,-1.9 -1.1,-2.2 z m 1.9,-1.1 -1.1,-1 -.9,.1 1.8,1.5 z m 3.2,-7 h -1.2 v .8 l 1.2,.6 z m -.9,32.5 .4,-2.7 h -1.1 l -.2,1.9 z"
                >
                  <title>Washington</title>
                </path>

                <path
                  className="wv"
                  d="m 723.4,297.5 -.8,1.2 1.5,.7 .1,1.5 4.4,2.3 2.3,-.1 1.9,-1.8 .8,-1.7 3,1.8 5.5,-2.4 .5,-.9 -.8,-.5 .6,-1.4 1.5,1 4.3,-3.1 .7,1.1 2.3,-2 -.1,-1.4 1.5,-1.9 -1.5,-1.2 1,-3.3 3.7,-6.3 -.4,-1.9 2.1,-2.2 -.4,-1.5 1.4,-1.7 .1,-4.7 2.3,.7 1.3,1.9 2.8,.5 1.3,-1.6 2.3,-8.5 2.4,1.1 1,-2.5 .9,-.8 1.4,-1.8 .9,-.8 .5,-2.1 1.2,-.8 -.1,-2.9 .8,-2.3 -.9,-1.6 .2,-.9 10,5.2 .5,-2.3 .4,-1.6 .4,-.7 -.9,-.4 .2,-1.6 -1,-.5 -.2,-.7 h -.7 l -.8,-1.2 .2,-1 -2.6,.4 -2.2,-1.6 -1.4,.3 -.9,1.4 h -1.3 l -1.7,2.9 -3.3,.4 -1.9,-1 -2.6,3.8 -2.2,-.3 -3.1,3.9 -.9,1.6 -1.8,1.6 -1.7,-11.4 -17.4,2.9 -3.2,-19.7 -2.2,1.2 1.4,2.1 -.1,2.2 .6,2 -1.1,3.4 -.1,5.4 -1,3.6 .5,1.1 -.4,2.2 -1.1,.5 -2,3.3 -1.8,2 h -.6 l -1.8,1.7 -1.3,-1.2 -1.5,1.8 -.3,1.2 h -1.3 l -1.3,2.2 .1,2.1 -1,.5 1.4,1.1 v 1.9 l -1,.2 -.7,.8 -1,.5 -.6,-2.1 -1.6,-.5 -1,2.3 -.3,2.2 -1.1,1.3 1.3,3.6 -1.5,.8 -.4,3.5 h -1.5 l -3.2,1.4 -.1,1.1 .6,1 -.6,3.6 1.9,1.6 .8,1.1 1,.6 -.1,.9 4.4,5.6 h 1.4 l 1.5,1.8 1.2,.3 1.4,-.1 z"
                >
                  <title>West Virginia</title>
                </path>

                <path
                  className="wi"
                  d="m 611,144 -2.9,.8 .2,2.3 -2.4,3.4 -.2,3.1 .6,.7 .8,-.7 .5,-1.6 2,-1.1 1.6,-4.2 3.5,-1.1 .8,-3.3 .7,-.9 .4,-2.1 1.8,-1.1 v -1.5 l 1,-.9 1.4,.1 v 2 l -1,.1 .5,1.2 -.7,2.2 -.6,.1 -1.2,4.5 -.7,.5 -2.8,7.2 -.3,4.2 .6,2 .1,1.3 -2.4,1.9 .3,1.9 -.9,3.1 .3,1.6 .4,3.7 -1.1,4.1 -1.5,5 1,1.5 -.3,.3 .8,1.7 -.5,1.1 1.1,.9 v 2.7 l 1.3,1.5 -.4,3 .3,4 -45.9,2.8 -1.3,-2.8 -3.3,-.7 -2.7,-1.5 -2,-5.5 .1,-2.5 1.6,-3.3 -.6,-1.1 -2.1,-1.6 -.2,-2.6 -1.1,-4.5 -.2,-3 -2.2,-3 -2.8,-.7 -5.2,-3.6 -.6,-3.3 -6.3,-3.1 -.2,-1.3 h -3.3 l -2.2,-2.6 -2,-1.3 .7,-5.1 -.9,-1.6 .5,-5.4 1,-1.8 -.3,-2.7 -1.2,-1.3 -1.8,-.3 v -1.7 l 2.8,-5.8 5.9,-3.9 -.4,-13 .9,.4 .6,-.5 .1,-1.1 .9,-.6 1.4,1.2 .7,-.1 h 2.6 l 6.8,-2.6 .3,-1 h 1.2 l .7,-1.2 .4,.8 1.8,-.9 1.8,-1.7 .3,.5 1,-1 2.2,1.6 -.8,1.6 -1.2,1.4 .5,1.5 -1.4,1.6 .4,.9 2.3,-1.1 v -1.4 l 3.3,1.9 1.9,.7 1.9,.7 3,3.8 17,3.8 1.4,1 4,.8 .7,.5 2.8,-.2 4.9,.8 1.4,1.5 -1,1 .8,.8 3.8,.7 1.2,1.2 .1,4.4 -1.3,2.8 2,.1 1,-.8 .9,.8 -1.1,3.1 1,1.6 1.2,.3 z m -49.5,-37.3 -.5,.1 -1.5,1.6 .2,.5 1.5,-.6 v -.6 l .9,-.3 z m 1.6,-1.1 -1,.3 -.2,.7 .9,-.1 z m -1.3,-1.6 -.2,.9 h 1.7 l .6,-.4 .1,-1 z m 2.8,-3 -.3,1.9 1.2,-.5 .1,-1.4 z m 58.3,31.9 -2,.3 -.4,1.3 1.3,1.7 z"
                >
                  <title>Wisconsin</title>
                </path>

                <path
                  className="wy"
                  d="m 355.3,143.7 -51,-5.3 -57.3,-7.9 -2,10.7 -8.5,54.8 -3.3,21.9 32.1,4.8 44.9,5.7 37.5,3.4 3.7,-44.2 z"
                >
                  <title>Wyoming</title>
                </path>

                <path
                  className="dc"
                  d="m 803.5,252 -2.6,-1.8 -1,1.7 .5,.4 .4,.1 .6,.5 .3,.7 -.1,.5 .2,.5 z"
                >
                  <title>District of Columbia</title>
                </path>
              </g>

              <g className="borders" fill="none">
                <path
                  className="al-fl"
                  d="m 687.6,447.4 -48.8,5.1 -.5,2.9 2.5,2.8 1.7,.7 .9,1.2 -.4,7.3 -1.1,.6"
                />
                <path
                  className="al-ga"
                  d="m 666.6,361.1 12.9,45.8 2.9,6.1 1.8,1.9 v 3.2 l 1.7,1 .2,1.1 -2.2,3.8 -.3,3.7 -.5,2.6 2.4,5.7 -.6,6.3 .5,1.4 1.5,1.5 .7,2.2"
                />
                <path
                  className="al-ms"
                  d="m 620.9,365.1 1.3,2 -1.3,67 4.4,33.2"
                />
                <path className="al-tn" d="m 620.9,365.1 45.7,-4" />
                <path className="ar-la" d="m 516.7,414.2 52.3,-1.3" />
                <path
                  className="ar-mo"
                  d="m 591.7,344.9 -11.2,.8 2.8,-5.1 1.7,-1.5 v -2.2 l -1.6,-2.5 -39.8,2 -39.1,.7"
                />
                <path
                  className="ar-ms"
                  d="m 569,412.9 1.2,-1.5 .5,-3 -1.5,-2.3 -.5,-2.2 .9,-.7 v -.8 l -1.7,-1.1 -.1,-.7 1.6,-.9 -1.2,-1.1 1.7,-7.1 3.4,-1.6 0,-.8 -1.1,-1.4 2.9,-5.4 h 1.9 l 1.5,-1.2 -.3,-5.2 3.1,-4.5 1.8,-.6 -.5,-3.1"
                />
                <path className="ar-ok" d="m 507.9,400.5 .7,-39 -4.1,-24.4" />
                <path
                  className="ar-tn"
                  d="m 582.6,367.7 1.6,-.7 .9,-2.2 1.2,.5 .7,-1 -.8,-.7 .3,-1.5 -1.1,-.9 .6,-1 -.1,-1.5 -1.1,-.1 .8,-.8 1.3,.8 .3,-1.4 -.4,-1.1 .1,-.7 2,.6 -.4,-1.5 1.6,-1.3 -.5,-.9 -1.1,.1 -.6,-.9 .9,-.9 1.6,-.2 .5,-.8 1.4,-.2 -.1,-.8 -.9,-.9 0,-.5 h 1.5 l .4,-.7 -1.4,-1 -.1,-.6"
                />
                <path
                  className="ar-tx"
                  d="m 507.9,400.5 2.6,2.3 2.8,-1.3 3.2,.8 .2,11.9"
                />
                <path
                  className="az-ca"
                  d="m 149,338.1 -.9,2.1 1.3,3.4 1.4,1.8 1.2,5.8 2.3,2.5 .4,1.9 -1.3,1.3 -4.8,1.7 -2.4,3.6 -1.6,7 -2.4,3.2 -1.6,.3 -1.1,6.9 1.1,1.6 1.8,.2 1,1.6 -.8,2.4 -3,2.2 -2.2,-.1"
                />
                <path className="az-nm" d="m 253.8,311 -17.4,124.1" />
                <path
                  className="az-nv"
                  d="m 167.6,296.8 -3.4,17.5 -2.4,2.9 h -2 l -1.2,-2.7 -3.7,-1.4 -3.5,.6 -1,13.6 .5,4.9 -.5,2.9 -1.4,3"
                />
                <path className="az-ut" d="m 167.6,296.8 46.2,8.2 40,6" />
                <path
                  className="ca-nv"
                  d="m 93.9,166.5 -16.4,63.1 1.1,3.5 70.4,105"
                />
                <path className="ca-or" d="m 27.8,147.9 66.1,18.6" />
                <path className="co-ks" d="m 379.4,256.3 -4.8,67" />
                <path className="co-ne" d="m 347.7,231.8 33.1,2.4 -1.4,22.1" />
                <path className="co-nm" d="m 253.8,311 52.6,6.5 51.7,4.8" />
                <path className="co-ok" d="m 358.1,322.3 16.5,1" />
                <path className="co-ut" d="m 265.3,222.7 -11.5,88.3" />
                <path className="co-wy" d="m 265.3,222.7 44.9,5.7 37.5,3.4" />
                <path
                  className="ct-ma"
                  d="m 843.8,171.3 10.5,-2.4 .5,.7 .9,-.3 0,-.7 14.9,-3.4 .1,.3"
                />
                <path
                  className="ct-ny"
                  d="m 846.6,194.7 -1.7,-2.2 3.5,-3.4 -1.8,-1.5 -2.8,-16.3"
                />
                <path
                  className="ct-ri"
                  d="m 870.7,165.5 3.2,12.3 -.4,1.1 .4,1.8"
                />
                <path
                  className="dc-md"
                  d="m 801.8,254.6 1.7,-2.6 -2.6,-1.8 -1,1.7"
                />
                <path
                  className="dc-va"
                  d="m 799.9,251.9 .5,.4 .4,.1 .6,.5 .3,.7 -.1,.5 .2,.5"
                />
                <path className="de-md" d="m 817.9,230.1 7.6,27.1 10.9,-2.3" />
                <path className="de-nj" d="m 823.8,227.2 -1,2.2 -.3,2.1" />
                <path
                  className="de-pa"
                  d="m 817.9,230.1 1.2,-2.1 1.5,-1.1 1.6,-.3 1.6,.6"
                />
                <path
                  className="fl-ga"
                  d="m 687.6,447.4 3.3,6 50.1,-3.3 .6,3.2 1,1.1 2.1,-.6 .5,-4.3 -1.4,-2.1 v -2.5 l 2.2,-1.4 1.7,.9 4,.7 3.6,-.3"
                />
                <path className="ga-nc" d="m 689.5,358.2 21.4,-3" />
                <path
                  className="ga-sc"
                  d="m 710.9,355.2 -.1,1.9 -1.9,1 -1.4,3.2 .2,1.3 6.1,3.8 2.6,-.3 3.1,4 .4,1.7 4.2,5.1 2.6,1.7 1.4,.2 2.2,1.6 1.1,2.2 2,1.6 1.8,.5 2.7,2.7 .1,1.4 2.6,2.8 5,2.3 3.6,6.7 .3,2.7 3.9,2.1 2.5,4.8 .8,3.1 4.2,.4"
                />
                <path className="ga-tn" d="m 666.6,361.1 22.9,-2.9" />
                <path
                  className="ia-il"
                  d="m 556.8,249.7 .7,-.7 .1,-2.3 -.7,-.9 1,-1.5 1.8,-.6 .9,-.3 1,-1.2 0,-2.4 1.7,-2.4 .5,-.5 .1,-3.5 -.9,-1.4 -1,-.3 -1.1,-1.6 1,-4 3,-.8 h 2.4 l 4.2,-1.8 1.7,-2.2 .1,-2.4 1.1,-1.3 1.3,-3.2 -.1,-2.6 -2.8,-3.5 -1.2,0 -.9,-1.1 .2,-1.6 -1.7,-1.7 -2.5,-1.3 .5,-.6"
                />
                <path
                  className="ia-mn"
                  d="m 473.6,182 28.2,0 36.3,-.9 18.6,-.7"
                />
                <path
                  className="ia-mo"
                  d="m 484.5,246.8 25.9,.1 27.2,-1.2 14.3,-.8 1.7,1.3 .6,1.6 1.1,1.1 1.5,.8"
                />
                <path
                  className="ia-ne"
                  d="m 484.5,246.8 -1.8,-4.4 .7,-2.2 -.8,-3.3 .2,-2.9 -1.3,-.7 -.4,-6.1 -2.8,-5 -.2,-3.7 -2.2,-4.3 -1.3,-3.7 v -1.4 l -.6,-1.7 v -2.3 l -.5,-.9"
                />
                <path
                  className="ia-sd"
                  d="m 473.5,204.2 -.7,-1.7 -.3,-1.3 -1.3,-1.2 1,-4.3 1.7,-5.1 -.7,-2 -1.3,-.4 -.4,-1.6 1,-.5 .1,-1.1 -1.3,-1.5 .1,-1.6 2.2,.1"
                />
                <path
                  className="ia-wi"
                  d="m 567.2,202 -1.3,-2.8 -3.3,-.7 -2.7,-1.5 -2,-5.5 .1,-2.5 1.6,-3.3 -.6,-1.1 -2.1,-1.6 -.2,-2.6"
                />
                <path
                  className="id-mt"
                  d="m 188.8,30.5 -4.8,22 3.7,7.4 -1.6,4.8 3.6,4.8 1.9,.7 3.9,8.3 v 2.1 l 2.3,3 h .9 l 1.4,2.1 h 3.2 v 1.6 l -7.1,17 -.5,4.1 1.4,.5 1.6,2.6 2.8,-1.4 3.6,-2.4 1.9,1.9 .5,2.5 -.5,3.2 2.5,9.7 2.6,3.5 2.3,1.4 .4,3 v 4.1 l 2.3,2.3 1.6,-2.3 6.9,1.6 2.1,-1.2 9,1.7 2.8,-3.3 1.8,-.6 1.2,1.8 1.6,4.1 .9,.1"
                />
                <path className="id-nv" d="m 140.9,177.7 24.4,5.4 23.3,4.7" />
                <path
                  className="id-or"
                  d="m 140.9,177.7 8.5,-37.3 2.9,-5.8 .4,-2.1 .8,-.9 -.9,-2 -2.9,-1.2 .2,-4.2 4,-5.8 2.5,-.8 1.6,-2.3 -.1,-1.6 1.8,-1.6 3.2,-5.5 4.2,-4.8 -.5,-3.2 -3.5,-3.1 -1.6,-3.6"
                />
                <path className="id-ut" d="m 236.5,196 -47.9,-8.2" />
                <path
                  className="id-wa"
                  d="m 174.6,27.5 -12.7,56.1 .7,4 -1.1,4.3"
                />
                <path className="id-wy" d="m 245,141.2 -8.5,54.8" />
                <path
                  className="il-in"
                  d="m 619.4,215.7 4.1,50.2 -1,5.2 v 2 l 2.4,3.5 v .7 l -.3,.9 .9,1.9 -.3,2.4 -1.6,1.8 -1.3,4.2 -3.8,5.3 -.1,7 h -1 l .9,1.9"
                />
                <path
                  className="il-ky"
                  d="m 599.9,322.5 -.3,-1.8 4,-3.7 6.9,3 1.5,-.3 .4,-2.4 -1.7,-1.8 .4,-3.3 1,-.5 1.2,.6 .6,-1.2 3.7,-.6 .1,-.9 -1.5,-2.2 -.1,-1.1 2.2,-2.7 v -.9"
                />
                <path
                  className="il-mo"
                  d="m 599.9,322.5 -2.8,0 -1.4,-1.5 -1.8,-3.8 v -1.9 l .8,-.6 .1,-1.3 -1.7,-1.9 -.9,-2.5 -2.7,-4.1 -4.8,-1.3 -7.4,-7.1 -.4,-2.4 2.8,-7.6 -.4,-1.9 1.2,-1.1 v -1.3 l -2.8,-1.5 -3,-.7 -3.4,1.2 -1.3,-2.3 .6,-1.9 -.7,-2.4 -8.6,-8.4 -2.2,-1.5 -2.5,-5.9 -1.2,-5.4 1.4,-3.7"
                />
                <path className="il-wi" d="m 567.2,202 45.9,-2.8" />
                <path
                  className="in-ky"
                  d="m 618.3,302.7 1.1,.8 .6,-1 -.7,-1.7 4.6,-.5 .2,1.2 1.1,.2 .4,-.9 -.6,-1.3 .3,-.8 1.3,.8 1.7,-.4 1.7,.6 3.4,2.1 1.8,-2.8 3.5,-2.2 3,3.3 1.6,-2.1 .3,-2.7 3.8,-2.3 .2,1.3 1.9,1.2 3,-.2 1.2,-.7 .1,-3.4 2.5,-3.7 4.6,-4.4 -.1,-1.7 1.2,-3.8 2.2,1 6.7,-4.5 -.4,-1.7 -1.5,-2.1 1,-1.9"
                />
                <path className="in-mi" d="m 630.9,213.2 32.4,-3.4 .1,1.4" />
                <path className="in-oh" d="m 670,268.4 -6.6,-57.2" />
                <path
                  className="ks-mo"
                  d="m 504.3,326.3 -.5,-48.1 -3.2,-.7 -2.6,-4.7 -2.5,-2.5 .5,-2.3 2.7,-2.6 .1,-1.2 -1.5,-2.1 -.9,1 -2,-.6 -2.9,-3"
                />
                <path
                  className="ks-ne"
                  d="m 379.4,256.3 36,2 43.7,1.2 h 32.4"
                />
                <path className="ks-ok" d="m 374.6,323.3 67.7,2.9 62,.1" />
                <path
                  className="ky-mo"
                  d="m 596.7,333.5 1,-2.7 1.4,.9 .7,-.4 1.2,-4.1 -1,-1 1,-2 .2,-.9 -1.3,-.8 m -5.8,11.3 -.7,-.7 .2,-1 h 1.1 l .7,.7 -.3,1"
                />
                <path
                  className="ky-oh"
                  d="m 670,268.4 1.3,.5 2.2,.1 1.9,-.8 2.9,1.2 2.2,3.4 v 1 l 4.1,.7 2.3,-.2 1.9,2.1 2.2,.2 v -1 l 1.9,-.8 3,.8 1.2,.8 1.3,-.7 h .9 l .6,-1.7 3.4,-1.8 .5,.8 .8,2.9 3.5,1.4 1.2,2.1"
                />
                <path
                  className="ky-tn"
                  d="m 596.7,333.5 23.3,-1.5 .6,-.9 -1.2,-3.2 h 3.7 l .7,.6 22.6,-2 2.6,-.8 17.4,-1 5.2,-.8 20.5,-1.4 5.6,-1.4 m -103.6,12.7 h 1"
                />
                <path
                  className="ky-va"
                  d="m 697.7,321.1 6.9,-4.2 1,-.4 .5,-1.9 1.8,-.5 1.4,-1.4 .1,-1.7 2.1,-1.3 .4,-2.2 3,-3 2.9,-1 4.9,-6.6"
                />
                <path
                  className="ky-wv"
                  d="m 709.3,279.4 -.1,1.1 .6,1 -.6,3.6 1.9,1.6 .8,1.1 1,.6 -.1,.9 4.4,5.6 h 1.4 l 1.5,1.8 1.2,.3 1.4,-.1"
                />
                <path
                  className="la-ms"
                  d="m 569,412.9 -.6,1.4 1.6,7.1 1.2,1 -.5,1.7 2.4,2.5 v 3.3 l -2,0 1.8,2.5 -6,8.4 -2.4,4.8 -1.7,11.9 36,-2 -.1,1.4 -1,1.4 -.9,4.6 4.8,6.8 -.3,1.3 1.2,1.8 .6,.7"
                />
                <path
                  className="la-tx"
                  d="m 516.7,414.2 .5,19.9 .7,3.4 2.6,2.8 .7,5.4 3.8,4.6 .8,4.3 h 1 l -.1,7.3 -3.3,6.4 1.3,2.3 -1.3,1.5 .7,3 -.1,4.3 -2.2,3.5 -.1,.8 -1.7,1.2 1,1.8 1.2,1.1"
                />
                <path
                  className="ma-nh"
                  d="m 856,152.6 18.4,-3.8 1,-1.5 .3,-1.7 1.9,-.6 .5,-1.1 1.7,-1.1 1.3,.3"
                />
                <path className="ma-ny" d="m 843.8,171.3 -.7,-1 .5,-15" />
                <path
                  className="ma-ri"
                  d="m 870.7,165.5 6.5,-2 .7,2.6 h .8 l .6,2.2 2.6,1.3 1.3,1.1 1.4,3"
                />
                <path className="ma-vt" d="m 843.6,155.3 12.4,-2.7" />
                <path className="md-pa" d="m 757.4,241.9 60.5,-11.8" />
                <path
                  className="md-va"
                  d="m 822.9,269.3 -.8,.1 m 13.2,-4.3 -.6,.3 m -1.3,.2 -4.6,1.6 -.7,.8 m -28.2,-16.1 -.6,-.6 h -1 l -.6,-.1 -.4,-.4 .1,-.5 -1.7,-.6 -.8,.3 -1.2,-.1 -.7,-.7 -.5,-.2 -.2,-.7 .6,-.8 v -.9 l -1.2,-.2 -1,-.9 -.9,.1 -1.6,-.3 m 11.6,13.5 .3,-.4 -.7,-1 1,-.1 1,-.9 .4,-1.8"
                />
                <path
                  className="md-wv"
                  d="m 757.4,241.9 1.7,11.4 1.8,-1.6 .9,-1.6 3.1,-3.9 2.2,.3 2.6,-3.8 1.9,1 3.3,-.4 1.7,-2.9 h 1.3 l .9,-1.4 1.4,-.3 2.2,1.6 2.6,-.4 -.2,1 .8,1.2 h .7 l .2,.7 1,.5 -.2,1.6 .9,.4"
                />
                <path
                  className="me-nh"
                  d="m 881.9,138.3 -2.3,-1.4 -.8,-2.2 -3.2,-2 -.6,-4 -11.9,-36.8"
                />
                <path className="mi-oh" d="m 663.4,211.2 21.4,-3.5" />
                <path
                  className="mi-wi"
                  d="m 565.6,112.3 1.9,.7 3,3.8 17,3.8 1.4,1 4,.8 .7,.5 2.8,-.2 4.9,.8 1.4,1.5 -1,1 .8,.8 3.8,.7 1.2,1.2 .1,4.4 -1.3,2.8 2,.1 1,-.8 .9,.8 -1.1,3.1 1,1.6 1.2,.3"
                />
                <path
                  className="mn-nd"
                  d="m 462.3,61.3 2.4,7.3 -1.1,2.8 .8,1.4 -.3,5.1 -.5,1.1 2.7,9.1 1.3,2.5 .7,14 1,2.7 -.4,5.8 2.9,7.4 .3,5.8 -.1,2.1"
                />
                <path
                  className="mn-sd"
                  d="m 473.6,182 .2,-39.5 -1.5,-1.9 -2.6,-.6 -.4,-1.8 -1.7,-2.5 .3,-1.2 3.1,-1.9 .9,-2 .1,-2.2"
                />
                <path
                  className="mn-wi"
                  d="m 556.7,180.4 -1.1,-4.5 -.2,-3 -2.2,-3 -2.8,-.7 -5.2,-3.6 -.6,-3.3 -6.3,-3.1 -.2,-1.3 -3.3,0 -2.2,-2.6 -2,-1.3 .7,-5.1 -.9,-1.6 .5,-5.4 1,-1.8 -.3,-2.7 -1.2,-1.3 -1.8,-.3 v -1.7 l 2.8,-5.8 5.9,-3.9 -.4,-13 .9,.4 .6,-.5 .1,-1.1 .9,-.6 1.4,1.2 .7,-.1"
                />
                <path
                  className="mo-ne"
                  d="m 491.5,259.5 -3.9,-6.3 -2.1,-3.7 .3,-1.4 -1.3,-1.3"
                />
                <path className="mo-ok" d="m 504.3,326.3 .2,10.8" />
                <path
                  className="mo-tn"
                  d="m 591.7,344.9 1,-2 1.2,-.5 v -.7 l -1.2,-1.1 -.6,-1 1.7,.2 .8,-.7 -1.4,-1.5 1.4,-.5 .1,-1 -.6,-1 0,-1.3 m 1,0 .8,.7 .8,-1"
                />
                <path className="ms-tn" d="m 582.6,367.7 38.3,-2.6" />
                <path className="mt-nd" d="m 362.5,56.3 -5.2,66.7" />
                <path className="mt-sd" d="m 357.3,123 -2,20.7" />
                <path
                  className="mt-wy"
                  d="m 355.3,143.7 -51,-5.3 -57.3,-7.9 -2,10.7"
                />
                <path
                  className="nc-sc"
                  d="m 710.9,355.2 4.4,-1.9 1.3,-.1 7.3,-4.3 23.2,-2.2 .4,.5 -.2,1.4 .7,.3 1.2,-1.5 3.3,3 .1,2.6 19.7,-2.8 24.5,17.1"
                />
                <path
                  className="nc-tn"
                  d="m 731.1,317 0,5.2 -1.5,-.1 -1.4,1.2 -2.4,5.2 -2.6,-1.1 -3.5,2.5 -.7,2.1 -1.5,1.2 -.8,-.8 -.1,-1.5 -.8,-.2 -4,3.3 -.6,3.4 -4.7,2.4 -.5,1.2 -3.2,2.6 -3.6,.5 -4.6,3 -.8,4.1 -1.3,.9 -1.5,-.1 -1.4,1.3 -.1,4.9"
                />
                <path
                  className="nc-va"
                  d="m 731.1,317 29.4,-3.5 39.4,-7.3 29.1,-6.1"
                />
                <path
                  className="nd-sd"
                  d="m 357.3,123 39.2,2.9 46,2.1 29.5,.4"
                />
                <path
                  className="ne-sd"
                  d="m 351.4,187.6 51.1,3.5 38,1.6 3.4,3.2 1.7,.2 2.1,2 1.8,-.1 1.8,-2 1.5,.6 1,-.7 .7,.5 .9,-.4 .7,.4 .9,-.4 1,.5 1.4,-.6 2,.6 .6,1.1 6.1,2.2 1.2,1.3 .9,2.6 1.8,.7 1.5,-.2"
                />
                <path className="ne-wy" d="m 347.7,231.8 3.7,-44.2" />
                <path
                  className="nh-vt"
                  d="m 857.9,100.1 1.2,2.3 -1.1,3.5 2.1,2.8 -.4,1.7 .1,1.3 -1.1,2.1 -1.4,.4 -.6,1.3 -2.1,1 -.7,1.5 1.4,3.4 -.5,2.5 .5,1.5 -1,1.9 .4,1.9 -1.3,1.9 .2,2.2 -.7,1.1 .7,4.5 .7,1.5 -.5,2.6 .9,1.8 -.2,2.5 -.5,1.3 -.1,1.4 2.1,2.6"
                />
                <path className="nj-ny" d="m 827.9,190.5 14.6,4.9 -.4,5.9" />
                <path
                  className="nj-pa"
                  d="m 823.8,227.2 1.4,-1.7 1.6,-.6 1.8,-3 1.6,-2.3 3.3,-2.6 -4.2,-3.2 -2.1,-1.1 -1,-2.8 -2.7,-.9 -.5,-3.6 1,-1 .7,-2 -1.5,-1.8 3,-5.4 -.1,-2.2 1.8,-2.5"
                />
                <path className="nm-ok" d="m 358.1,322.3 -.6,10.6" />
                <path
                  className="nm-tx"
                  d="m 284.3,431.2 -2,-2.2 .3,-3 34.4,3.6 31.8,2.6 7.9,-99.3 .8,0"
                />
                <path className="nv-or" d="m 93.9,166.5 47,11.2" />
                <path className="nv-ut" d="m 188.6,187.8 -21,109" />
                <path
                  className="ny-pa"
                  d="m 827.9,190.5 -1.6,-1.1 -1.9,.3 -3,-2.2 -3,-5.8 h -2 l -.4,-1.5 -1.7,-1.1 -70.5,13.9 -.8,-6"
                />
                <path
                  className="ny-vt"
                  d="m 843.6,155.3 -1.1,-1 .5,-2 -3,-14.2 -1.9,-1.5 -.9,1.6 -.9,-2.2 .8,-1.8 -3.1,-6.7 .3,-3.8 .4,-1 -.6,-2 .4,-2.2 -2.2,-2.3 -.5,-3.2 .4,-1.5 -1.4,-.9 .6,-1.9 -.8,-1.7"
                />
                <path className="oh-pa" d="m 736.8,225.1 -4.9,-29.9" />
                <path
                  className="oh-wv"
                  d="m 709.3,279.4 3.2,-1.4 h 1.5 l .4,-3.5 1.5,-.8 -1.3,-3.6 1.1,-1.3 .3,-2.2 1,-2.3 1.6,.5 .6,2.1 1,-.5 .7,-.8 1,-.2 v -1.9 l -1.4,-1.1 1,-.5 -.1,-2.1 1.3,-2.2 h 1.3 l .3,-1.2 1.5,-1.8 1.3,1.2 1.8,-1.7 h .6 l 1.8,-2 2,-3.3 1.1,-.5 .4,-2.2 -.5,-1.1 1,-3.6 .1,-5.4 1.1,-3.4 -.6,-2 .1,-2.2 -1.4,-2.1 2.2,-1.2"
                />
                <path
                  className="ok-tx"
                  d="m 357.5,332.9 52.6,3.2 -1.4,42.7 2.7,1.3 2.5,3 1.5,.3 1.1,-1 1.2,.4 1.4,1 1.1,-1.5 2.3,1.7 .5,2.9 1.2,.7 2.3,-.1 3.5,1.9 2,-.1 1.4,-.4 2.3,2.2 2,-2.3 3.5,1.1 1.9,3 2.3,-.1 -.7,2.1 2.3,1.1 3,-2.6 2.6,1.7 1.3,-.5 .1,1.5 1.7,1.2 2.3,-2.5 1.2,.7 -.3,2 1,1.8 1.2,-.8 2.5,-4.2 1.8,2 2,.5 2.1,-.7 2,1.8 1.2,-.1 1.3,1.2 3.6,-.9 .6,-1.7 3.7,-.3 1.6,.7 5,-2.5 .6,1.5 5.1,-.3 .5,-1.6 2.2,.9 4.6,3.8 6.4,1.9"
                />
                <path
                  className="or-wa"
                  d="m 161.5,91.9 -30.3,-7.3 -2.8,1 -5.4,-.9 -1.8,-.9 -1.5,1.2 -3.3,-.4 -4.5,.5 -.9,.7 -4.2,-.4 -.8,-1.6 -1.2,-.2 -4.4,1.3 -1.6,-1.1 -2.2,.8 -.2,-1.8 -2.3,-1.2 -1.5,-.2 -1,-1.1 -3,.3 -1.2,-.8 h -1.2 l -1.2,.9 -5.5,.7 -6.6,-4.2 1.1,-5.6 -.4,-4.1 -3.2,-3.7 -3.7,.1 -.4,-1.1 .4,-1.2 -.7,-.8 -1,.1"
                />
                <path className="pa-wv" d="m 736.8,225.1 3.2,19.7 17.4,-2.9" />
                <path className="sd-wy" d="m 351.4,187.6 3.9,-43.9" />
                <path
                  className="tn-va"
                  d="m 697.7,321.1 28.9,-3.3 .2,-1 4.6,-.5 -.3,.7"
                />
                <path className="ut-wy" d="m 236.5,196 -3.3,21.9 32.1,4.8" />
                <path
                  className="va-wv"
                  d="m 722.7,296.9 .7,.6 -.8,1.2 1.5,.7 .1,1.5 4.4,2.3 2.3,-.1 1.9,-1.8 .8,-1.7 3,1.8 5.5,-2.4 .5,-.9 -.8,-.5 .6,-1.4 1.5,1 4.3,-3.1 .7,1.1 2.3,-2 -.1,-1.4 1.5,-1.9 -1.5,-1.2 1,-3.3 3.7,-6.3 -.4,-1.9 2.1,-2.2 -.4,-1.5 1.4,-1.7 .1,-4.7 2.3,.7 1.3,1.9 2.8,.5 1.3,-1.6 2.3,-8.5 2.4,1.1 1,-2.5 .9,-.8 1.4,-1.8 .9,-.8 .5,-2.1 1.2,-.8 -.1,-2.9 .8,-2.3 -.9,-1.6 .2,-.9 10,5.2 .5,-2.3 .4,-1.6 .4,-.7"
                />
              </g>

              <circle
                className="state borders dccircle dc"
                cx="801.6"
                cy="252.1"
                r="5"
              >
                <title>District of Columbia</title>
              </circle>
            </svg>
          </div>
        </div>
      </section>
    </>
  );
};
